import { GraphQLClient } from 'graphql-request';
import { RequestInit } from 'graphql-request/dist/types.dom';
import { useMutation, useQuery, UseMutationOptions, UseQueryOptions } from '@tanstack/react-query';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };

function fetcher<TData, TVariables extends { [key: string]: any }>(client: GraphQLClient, query: string, variables?: TVariables, requestHeaders?: RequestInit['headers']) {
  return async (): Promise<TData> => client.request({
    document: query,
    variables,
    requestHeaders
  });
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Any: { input: any; output: any; }
  AnyAggridInput: { input: any; output: any; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  Decimal: { input: any; output: any; }
  Json: { input: any; output: any; }
};

export type AccessPermission = {
  __typename?: 'AccessPermission';
  cancel: Scalars['Boolean']['output'];
  create: Scalars['Boolean']['output'];
  delete: Scalars['Boolean']['output'];
  update: Scalars['Boolean']['output'];
  view: Scalars['Boolean']['output'];
  view_self: Scalars['Boolean']['output'];
};

export type AccessPermissionInput = {
  cancel: Scalars['Boolean']['input'];
  create: Scalars['Boolean']['input'];
  delete: Scalars['Boolean']['input'];
  update: Scalars['Boolean']['input'];
  view: Scalars['Boolean']['input'];
  view_self: Scalars['Boolean']['input'];
};

export type ActivityLog = {
  __typename?: 'ActivityLog';
  activity_detail?: Maybe<ActivityLogDetailObject>;
  activity_type?: Maybe<ActivityType>;
  created_by?: Maybe<CreatorObject>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  document_type?: Maybe<ActivityLogDocumentType>;
  id: Scalars['Int']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  reference_id?: Maybe<Scalars['Int']['output']>;
};

export type ActivityLogByRefereceIdInput = {
  document_type: ActivityLogDocumentType;
  reference_id: Scalars['Int']['input'];
};

export type ActivityLogCopyObject = {
  __typename?: 'ActivityLogCopyObject';
  id?: Maybe<Scalars['Int']['output']>;
  unique_id?: Maybe<Scalars['String']['output']>;
};

export type ActivityLogCopyObjectInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityLogCreateInput = {
  activity_detail: ActivityLogDetailObjectInput;
  activity_type: ActivityType;
  created_by: CreatorInputObject;
  document_type: ActivityLogDocumentType;
  reference_id: Scalars['Int']['input'];
};

export type ActivityLogDetailObject = {
  __typename?: 'ActivityLogDetailObject';
  added_related_employee?: Maybe<ActivityLogRelatedEmployeeObject>;
  attachment_list?: Maybe<Array<Scalars['String']['output']>>;
  copied_from?: Maybe<ActivityLogCopyObject>;
  copied_to?: Maybe<ActivityLogCopyObject>;
  curr_status?: Maybe<Scalars['String']['output']>;
  deleted_related_employee?: Maybe<ActivityLogRelatedEmployeeObject>;
  message?: Maybe<Array<Scalars['String']['output']>>;
  prev_status?: Maybe<Scalars['String']['output']>;
  updated_fields?: Maybe<Scalars['Json']['output']>;
};

export type ActivityLogDetailObjectInput = {
  added_related_employee?: InputMaybe<ActivityLogRelatedEmployeeObjectInput>;
  attachment_list?: InputMaybe<Array<Scalars['String']['input']>>;
  copied_from?: InputMaybe<ActivityLogCopyObjectInput>;
  copied_to?: InputMaybe<ActivityLogCopyObjectInput>;
  curr_status?: InputMaybe<Scalars['String']['input']>;
  deleted_related_employee?: InputMaybe<ActivityLogRelatedEmployeeObjectInput>;
  message?: InputMaybe<Array<Scalars['String']['input']>>;
  prev_status?: InputMaybe<Scalars['String']['input']>;
  secondary_operation?: InputMaybe<ActivityType>;
  updated_fields?: InputMaybe<Scalars['Json']['input']>;
};

export enum ActivityLogDocumentType {
  CashSales = 'cash_sales',
  CreditNote = 'credit_note',
  Customer = 'customer',
  CustomerDeposit = 'customer_deposit',
  DeliveryOrder = 'delivery_order',
  GoodsAdjustment = 'goods_adjustment',
  GoodsIssue = 'goods_issue',
  GoodsReceive = 'goods_receive',
  GoodsReturn = 'goods_return',
  GoodsTransfer = 'goods_transfer',
  Item = 'item',
  Promotion = 'promotion',
  PurchaseInvoice = 'purchase_invoice',
  PurchaseOrder = 'purchase_order',
  PurchaseRequest = 'purchase_request',
  PurchaseReturn = 'purchase_return',
  Quotation = 'quotation',
  Role = 'role',
  SalesInvoice = 'sales_invoice',
  SalesOrder = 'sales_order',
  SalesReturn = 'sales_return',
  User = 'user',
  Vendor = 'vendor'
}

export type ActivityLogFindManyAggrid = {
  __typename?: 'ActivityLogFindManyAggrid';
  count: Scalars['Int']['output'];
  results: Array<ActivityLog>;
};

export type ActivityLogRelatedEmployeeObject = {
  __typename?: 'ActivityLogRelatedEmployeeObject';
  first_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  user_unique_id?: Maybe<Scalars['String']['output']>;
};

export type ActivityLogRelatedEmployeeObjectInput = {
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  user_unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityLogUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export enum ActivityType {
  AddRelatedEmployee = 'add_related_employee',
  Approve = 'approve',
  Cancel = 'cancel',
  CancelPendingScan = 'cancel_pending_scan',
  Comment = 'comment',
  Copy = 'copy',
  Create = 'create',
  Delete = 'delete',
  DeleteRelatedEmployee = 'delete_related_employee',
  Document = 'document',
  Edit = 'edit',
  Image = 'image',
  StatusChange = 'status_change'
}

export enum AdditionalDiscountType {
  Baht = 'baht',
  Percent = 'percent',
  Promotion = 'promotion'
}

export enum AggridArrayFilterType {
  Array = 'array'
}

export type AggridBooleanFilterModelInput = {
  filter?: InputMaybe<Scalars['String']['input']>;
  filterType?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AggridBooleanFilterModelType>;
};

export enum AggridBooleanFilterModelType {
  Equals = 'equals',
  NotEqual = 'notEqual'
}

export type AggridDateFilterModelInput = {
  filter?: InputMaybe<Scalars['String']['input']>;
  filterTo?: InputMaybe<Scalars['String']['input']>;
  filterType?: InputMaybe<AggridDateFilterType>;
  type?: InputMaybe<AggridDateFilterModelType>;
};

export enum AggridDateFilterModelType {
  Blank = 'blank',
  Empty = 'empty',
  Equals = 'equals',
  GreaterThan = 'greaterThan',
  GreaterThanOrEqual = 'greaterThanOrEqual',
  InRange = 'inRange',
  LessThan = 'lessThan',
  LessThanOrEqual = 'lessThanOrEqual',
  NotBlank = 'notBlank',
  NotEqual = 'notEqual'
}

export enum AggridDateFilterType {
  Date = 'date'
}

export type AggridFloatFilterModelInput = {
  condition1?: InputMaybe<AggridFloatFilterModelInputCondition>;
  condition2?: InputMaybe<AggridFloatFilterModelInputCondition>;
  filter?: InputMaybe<Scalars['Float']['input']>;
  filterTo?: InputMaybe<Scalars['Float']['input']>;
  filterType?: InputMaybe<AggridNumberFilterType>;
  operator?: InputMaybe<AggridOperatorFilter>;
  type?: InputMaybe<AggridNumberFilterModelType>;
};

export type AggridFloatFilterModelInputCondition = {
  filter?: InputMaybe<Scalars['Float']['input']>;
  filterTo?: InputMaybe<Scalars['Float']['input']>;
  filterType?: InputMaybe<AggridNumberFilterType>;
  type?: InputMaybe<AggridNumberFilterModelType>;
};

export type AggridGenericArrayFilterModelInput = {
  filterType?: InputMaybe<AggridArrayFilterType>;
  type?: InputMaybe<AggridGenericArrayFilterModelType>;
  values?: InputMaybe<Scalars['Any']['input']>;
};

export enum AggridGenericArrayFilterModelType {
  Equals = 'equals',
  Has = 'has',
  HasEvery = 'hasEvery',
  HasSome = 'hasSome',
  IsEmpty = 'isEmpty'
}

export enum AggridISimpleFilterModelType {
  Blank = 'blank',
  Contains = 'contains',
  Empty = 'empty',
  EndsWith = 'endsWith',
  Equals = 'equals',
  GreaterThan = 'greaterThan',
  GreaterThanOrEqual = 'greaterThanOrEqual',
  InRange = 'inRange',
  LessThan = 'lessThan',
  LessThanOrEqual = 'lessThanOrEqual',
  NotBlank = 'notBlank',
  NotContains = 'notContains',
  NotEqual = 'notEqual',
  StartsWith = 'startsWith'
}

export type AggridIntFilterModelInput = {
  condition1?: InputMaybe<AggridIntFilterModelInputCondition>;
  condition2?: InputMaybe<AggridIntFilterModelInputCondition>;
  filter?: InputMaybe<Scalars['Int']['input']>;
  filterTo?: InputMaybe<Scalars['Int']['input']>;
  filterType?: InputMaybe<AggridNumberFilterType>;
  operator?: InputMaybe<AggridOperatorFilter>;
  type?: InputMaybe<AggridNumberFilterModelType>;
};

export type AggridIntFilterModelInputCondition = {
  filter?: InputMaybe<Scalars['Int']['input']>;
  filterTo?: InputMaybe<Scalars['Int']['input']>;
  filterType?: InputMaybe<AggridNumberFilterType>;
  type?: InputMaybe<AggridNumberFilterModelType>;
};

export enum AggridNumberFilterModelType {
  Blank = 'blank',
  Empty = 'empty',
  Equals = 'equals',
  GreaterThan = 'greaterThan',
  GreaterThanOrEqual = 'greaterThanOrEqual',
  InRange = 'inRange',
  LessThan = 'lessThan',
  LessThanOrEqual = 'lessThanOrEqual',
  NotBlank = 'notBlank',
  NotEqual = 'notEqual'
}

export enum AggridNumberFilterType {
  Number = 'number'
}

export enum AggridObjectArrayFilterModelType {
  Every = 'every',
  None = 'none',
  Some = 'some'
}

export enum AggridObjectArrayFilterType {
  ObjectArray = 'objectArray'
}

export enum AggridOperatorFilter {
  And = 'AND',
  Or = 'OR'
}

export type AggridSetSingleFilterModelInput = {
  condition1?: InputMaybe<AggridSetSingleFilterModelInputCondition>;
  condition2?: InputMaybe<AggridSetSingleFilterModelInputCondition>;
  filterType?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<AggridOperatorFilter>;
  values?: InputMaybe<Array<InputMaybe<Scalars['Any']['input']>>>;
};

export type AggridSetSingleFilterModelInputCondition = {
  filterType?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AggridSetSingleFilterModelType>;
  values?: InputMaybe<Array<InputMaybe<Scalars['Any']['input']>>>;
};

export enum AggridSetSingleFilterModelType {
  Blank = 'blank',
  Contains = 'contains',
  Equals = 'equals',
  NotBlank = 'notBlank',
  NotContains = 'notContains',
  NotEqual = 'notEqual'
}

export type AggridSortModelItem = {
  colId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortOrder>;
};

export type AggridSortModelItemInput = {
  colId: Scalars['String']['input'];
  sort: SortOrder;
};

export type AggridStringFilterModelInput = {
  condition1?: InputMaybe<AggridStringFilterModelInputCondition>;
  condition2?: InputMaybe<AggridStringFilterModelInputCondition>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterTo?: InputMaybe<Scalars['String']['input']>;
  filterType?: InputMaybe<AggridTextFilterType>;
  mode?: InputMaybe<AggridStringModeOption>;
  operator?: InputMaybe<AggridOperatorFilter>;
  type?: InputMaybe<AggridStringFilterModelType>;
};

export type AggridStringFilterModelInputCondition = {
  filter?: InputMaybe<Scalars['String']['input']>;
  filterTo?: InputMaybe<Scalars['String']['input']>;
  filterType?: InputMaybe<AggridTextFilterType>;
  mode?: InputMaybe<AggridStringModeOption>;
  type?: InputMaybe<AggridStringFilterModelType>;
};

export enum AggridStringFilterModelType {
  Blank = 'blank',
  Contains = 'contains',
  Empty = 'empty',
  EndsWith = 'endsWith',
  Equals = 'equals',
  NotBlank = 'notBlank',
  NotContains = 'notContains',
  NotEqual = 'notEqual',
  StartsWith = 'startsWith'
}

export enum AggridStringModeOption {
  Default = 'default',
  Insensitive = 'insensitive'
}

export type AggridTemplateInput = {
  endRow?: InputMaybe<Scalars['Int']['input']>;
  filterModel?: InputMaybe<Scalars['Any']['input']>;
  sortModel?: InputMaybe<Array<AggridSortModelItemInput>>;
  startRow?: InputMaybe<Scalars['Int']['input']>;
};

export enum AggridTextFilterType {
  Text = 'text'
}

export type ApprovalProgress = {
  __typename?: 'ApprovalProgress';
  approval_template?: Maybe<ApprovalTemplate>;
  approval_template_id: Scalars['Int']['output'];
  approver: User;
  approver_id: Scalars['Int']['output'];
  created_date: Scalars['DateTime']['output'];
  document_id: Scalars['Int']['output'];
  document_type: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  step_number: Scalars['Int']['output'];
  updated_date?: Maybe<Scalars['DateTime']['output']>;
};

export type ApprovalTemplate = {
  __typename?: 'ApprovalTemplate';
  approver_id_list?: Maybe<Array<Scalars['String']['output']>>;
  approver_list?: Maybe<Array<User>>;
  id: Scalars['Int']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  required_approval: Scalars['Int']['output'];
  step_number: Scalars['Int']['output'];
  workflow_document_type: Scalars['String']['output'];
  workflow_step_number: Scalars['Int']['output'];
  workflow_template?: Maybe<WorkflowTemplate>;
};

export enum AvailableFor {
  Erp = 'erp',
  ErpPos = 'erp_pos'
}

export type BinLocation = {
  __typename?: 'BinLocation';
  id: Scalars['Int']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  warehouse_level_3: WarehouseLevel3;
};

export type Branch = {
  __typename?: 'Branch';
  address: Scalars['Json']['output'];
  created_date?: Maybe<Scalars['DateTime']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  is_hq: Scalars['Boolean']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  short_name: Scalars['String']['output'];
  status: Scalars['Int']['output'];
  unique_id: Scalars['String']['output'];
  user_id_list: Array<Scalars['Int']['output']>;
  user_list?: Maybe<Array<Maybe<BranchUser>>>;
  zone?: Maybe<Scalars['String']['output']>;
};

export type BranchUser = {
  __typename?: 'BranchUser';
  branch?: Maybe<Branch>;
  branch_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

export type BundleItemDetail = {
  __typename?: 'BundleItemDetail';
  bundle_item: Item;
  bundle_item_id: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  item: Item;
  item_sku_detail?: Maybe<ItemSkuDetail>;
  item_unique_id: Scalars['String']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  qty: Scalars['Int']['output'];
  ratio_percentage?: Maybe<Scalars['Float']['output']>;
  sku_desc?: Maybe<Scalars['String']['output']>;
  sku_name: Scalars['String']['output'];
  sorting_order?: Maybe<Scalars['Int']['output']>;
  special_price?: Maybe<Scalars['Float']['output']>;
};

export type CashSales = {
  __typename?: 'CashSales';
  account_id?: Maybe<Scalars['String']['output']>;
  additional_discount?: Maybe<Scalars['Float']['output']>;
  additional_discount_type?: Maybe<AdditionalDiscountType>;
  aggrid_status?: Maybe<Scalars['String']['output']>;
  approval_step?: Maybe<Scalars['Int']['output']>;
  approver_list?: Maybe<Array<Maybe<Scalars['Json']['output']>>>;
  branch: Branch;
  branch_id: Scalars['Int']['output'];
  contact_person_list?: Maybe<Array<Scalars['Json']['output']>>;
  created_by: Scalars['Json']['output'];
  created_date: Scalars['DateTime']['output'];
  credit_day?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customer_details?: Maybe<Scalars['Json']['output']>;
  customer_unique_id?: Maybe<Scalars['String']['output']>;
  deduction_document_list?: Maybe<Array<SalesDeduction>>;
  deduction_total_amount?: Maybe<Scalars['Float']['output']>;
  delivery_date?: Maybe<Scalars['DateTime']['output']>;
  due_date?: Maybe<Scalars['DateTime']['output']>;
  external_reference_no?: Maybe<Scalars['String']['output']>;
  flag_status?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['Int']['output'];
  is_original_print?: Maybe<Scalars['Json']['output']>;
  issue_date?: Maybe<Scalars['DateTime']['output']>;
  item_list?: Maybe<Array<SalesItem>>;
  item_price_list?: Maybe<ItemPriceList>;
  item_price_list_id?: Maybe<Scalars['Int']['output']>;
  last_updated_by?: Maybe<Scalars['Json']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  main_status?: Maybe<Scalars['String']['output']>;
  need_tax_invoice?: Maybe<Scalars['Boolean']['output']>;
  net_amount?: Maybe<Scalars['Float']['output']>;
  paid_net_amount?: Maybe<Scalars['Float']['output']>;
  paid_total_amount?: Maybe<Scalars['Float']['output']>;
  payment_list?: Maybe<Array<SalesPayment>>;
  payment_total_amount?: Maybe<Scalars['Float']['output']>;
  post_discount_amount?: Maybe<Scalars['Float']['output']>;
  pre_vat_amount?: Maybe<Scalars['Float']['output']>;
  price_vat_type?: Maybe<PriceVatType>;
  promotion_list?: Maybe<Array<PromotionAppliedLog>>;
  reference_document_list?: Maybe<Array<Scalars['Json']['output']>>;
  reference_no?: Maybe<Scalars['String']['output']>;
  related_user_list?: Maybe<Array<Scalars['Json']['output']>>;
  remark?: Maybe<Scalars['String']['output']>;
  reviewer_list?: Maybe<Array<Maybe<Scalars['Json']['output']>>>;
  sales_channel?: Maybe<SalesChannel>;
  sales_channel_id?: Maybe<Scalars['Int']['output']>;
  sales_contact?: Maybe<Array<Scalars['Json']['output']>>;
  sales_type?: Maybe<Scalars['String']['output']>;
  shipping_cost?: Maybe<Scalars['Float']['output']>;
  sub_status?: Maybe<Scalars['String']['output']>;
  tag_id_list?: Maybe<Array<Scalars['Int']['output']>>;
  tag_list?: Maybe<Array<Tag>>;
  tax_invoice_date?: Maybe<Scalars['DateTime']['output']>;
  tax_invoice_no?: Maybe<Scalars['String']['output']>;
  template_remark_id?: Maybe<Scalars['String']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
  unique_id: Scalars['String']['output'];
  vat_0_percent_amount?: Maybe<Scalars['Float']['output']>;
  vat_7_percent_amount?: Maybe<Scalars['Float']['output']>;
  vat_amount?: Maybe<Scalars['Float']['output']>;
  vat_exempted_amount?: Maybe<Scalars['Float']['output']>;
  withholding_tax_amount?: Maybe<Scalars['Float']['output']>;
};

export type CashSalesAggridOutput = {
  __typename?: 'CashSalesAggridOutput';
  count?: Maybe<Scalars['Int']['output']>;
  results: Array<CashSales>;
};

export type CashSalesCreateInput = {
  account_id?: InputMaybe<Scalars['String']['input']>;
  additional_discount?: InputMaybe<Scalars['Float']['input']>;
  additional_discount_type?: InputMaybe<AdditionalDiscountType>;
  aggrid_status?: InputMaybe<Scalars['String']['input']>;
  approval_step?: InputMaybe<Scalars['Int']['input']>;
  approver_list?: InputMaybe<Array<InputMaybe<Scalars['Json']['input']>>>;
  branch_id: Scalars['Int']['input'];
  contact_person_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  coupon_code_list?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  created_by: Scalars['Json']['input'];
  credit_day?: InputMaybe<Scalars['Int']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  customer_details?: InputMaybe<Scalars['Json']['input']>;
  customer_unique_id?: InputMaybe<Scalars['String']['input']>;
  deduction_document_list?: InputMaybe<Array<SalesDeductionCreateInput>>;
  deduction_total_amount?: InputMaybe<Scalars['Float']['input']>;
  delivery_date?: InputMaybe<Scalars['DateTime']['input']>;
  due_date?: InputMaybe<Scalars['DateTime']['input']>;
  external_reference_no?: InputMaybe<Scalars['String']['input']>;
  flag_status?: InputMaybe<Array<Scalars['String']['input']>>;
  is_original_print?: InputMaybe<Scalars['Json']['input']>;
  issue_date?: InputMaybe<Scalars['DateTime']['input']>;
  item_list?: InputMaybe<Array<SalesItemCreateInput>>;
  item_price_list_id?: InputMaybe<Scalars['Int']['input']>;
  last_updated_by?: InputMaybe<Scalars['Json']['input']>;
  main_status?: InputMaybe<Scalars['String']['input']>;
  need_tax_invoice?: InputMaybe<Scalars['Boolean']['input']>;
  net_amount?: InputMaybe<Scalars['Float']['input']>;
  paid_net_amount?: InputMaybe<Scalars['Float']['input']>;
  paid_total_amount?: InputMaybe<Scalars['Float']['input']>;
  payment_list?: InputMaybe<Array<SalesPaymentCreateInput>>;
  payment_total_amount?: InputMaybe<Scalars['Float']['input']>;
  post_discount_amount?: InputMaybe<Scalars['Float']['input']>;
  pre_vat_amount?: InputMaybe<Scalars['Float']['input']>;
  price_vat_type?: InputMaybe<PriceVatType>;
  promotion_list?: InputMaybe<Array<PromotionAppliedLogUpsertInput>>;
  reference_document_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  reference_no?: InputMaybe<Scalars['String']['input']>;
  related_user_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  remark?: InputMaybe<Scalars['String']['input']>;
  reviewer_list?: InputMaybe<Array<InputMaybe<Scalars['Json']['input']>>>;
  sales_channel_id?: InputMaybe<Scalars['Int']['input']>;
  sales_contact?: InputMaybe<Array<Scalars['Json']['input']>>;
  sales_type?: InputMaybe<Scalars['String']['input']>;
  shipping_cost?: InputMaybe<Scalars['Float']['input']>;
  sub_status?: InputMaybe<Scalars['String']['input']>;
  tag_id_list?: InputMaybe<Array<Scalars['Int']['input']>>;
  tax_invoice_date?: InputMaybe<Scalars['DateTime']['input']>;
  tax_invoice_no?: InputMaybe<Scalars['String']['input']>;
  template_remark_id?: InputMaybe<Scalars['String']['input']>;
  total_amount?: InputMaybe<Scalars['Float']['input']>;
  unique_id: Scalars['String']['input'];
  vat_0_percent_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_7_percent_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_exempted_amount?: InputMaybe<Scalars['Float']['input']>;
  withholding_tax_amount?: InputMaybe<Scalars['Float']['input']>;
};

export type CashSalesItemExportView = {
  __typename?: 'CashSalesItemExportView';
  additional_discount?: Maybe<Scalars['Float']['output']>;
  billing_address?: Maybe<Scalars['String']['output']>;
  billing_address_country?: Maybe<Scalars['String']['output']>;
  billing_address_district?: Maybe<Scalars['String']['output']>;
  billing_address_postal_code?: Maybe<Scalars['String']['output']>;
  billing_address_province?: Maybe<Scalars['String']['output']>;
  billing_address_sub_district?: Maybe<Scalars['String']['output']>;
  branch_id?: Maybe<Scalars['Int']['output']>;
  branch_name?: Maybe<Scalars['String']['output']>;
  branch_unique_id?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customer_email?: Maybe<Scalars['String']['output']>;
  customer_fax?: Maybe<Scalars['String']['output']>;
  customer_name?: Maybe<Scalars['String']['output']>;
  customer_phone?: Maybe<Scalars['String']['output']>;
  customer_unique_id?: Maybe<Scalars['String']['output']>;
  deduction_total_amount?: Maybe<Scalars['Float']['output']>;
  delivery_address?: Maybe<Scalars['String']['output']>;
  delivery_address_contact_name?: Maybe<Scalars['String']['output']>;
  delivery_address_contact_phone?: Maybe<Scalars['String']['output']>;
  delivery_address_country?: Maybe<Scalars['String']['output']>;
  delivery_address_district?: Maybe<Scalars['String']['output']>;
  delivery_address_postal_code?: Maybe<Scalars['String']['output']>;
  delivery_address_province?: Maybe<Scalars['String']['output']>;
  delivery_address_sub_district?: Maybe<Scalars['String']['output']>;
  external_reference_no?: Maybe<Scalars['String']['output']>;
  issue_date?: Maybe<Scalars['DateTime']['output']>;
  item_additional_discount?: Maybe<Scalars['Float']['output']>;
  item_discount?: Maybe<Scalars['Float']['output']>;
  item_name?: Maybe<Scalars['String']['output']>;
  item_net_amount?: Maybe<Scalars['Float']['output']>;
  item_post_discount_amount?: Maybe<Scalars['Float']['output']>;
  item_pre_discount_amount?: Maybe<Scalars['Float']['output']>;
  item_price_list?: Maybe<Scalars['String']['output']>;
  item_price_per_unit?: Maybe<Scalars['Float']['output']>;
  item_qty?: Maybe<Scalars['Float']['output']>;
  item_qty_returned?: Maybe<Scalars['Float']['output']>;
  item_qty_shipped?: Maybe<Scalars['Float']['output']>;
  item_qty_to_ship?: Maybe<Scalars['Float']['output']>;
  item_remark?: Maybe<Scalars['String']['output']>;
  item_sku_desc?: Maybe<Scalars['String']['output']>;
  item_stock_qty?: Maybe<Scalars['Float']['output']>;
  item_total_amount?: Maybe<Scalars['Float']['output']>;
  item_unique_id?: Maybe<Scalars['String']['output']>;
  item_uom?: Maybe<Scalars['String']['output']>;
  item_vat_0_percent_amount?: Maybe<Scalars['Float']['output']>;
  item_vat_7_percent_amount?: Maybe<Scalars['Float']['output']>;
  item_vat_amount?: Maybe<Scalars['Float']['output']>;
  item_vat_exempted_amount?: Maybe<Scalars['Float']['output']>;
  item_vat_percentage?: Maybe<Scalars['String']['output']>;
  item_withholding_tax_amount?: Maybe<Scalars['Float']['output']>;
  item_withholding_tax_type?: Maybe<Scalars['String']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  latest_deduction_issue_date?: Maybe<Scalars['DateTime']['output']>;
  latest_payment_date?: Maybe<Scalars['DateTime']['output']>;
  payment_total_amount?: Maybe<Scalars['Float']['output']>;
  price_vat_type?: Maybe<PriceVatType>;
  reference_document?: Maybe<Array<Scalars['String']['output']>>;
  reference_no?: Maybe<Scalars['String']['output']>;
  related_user_list?: Maybe<Array<Scalars['String']['output']>>;
  remark?: Maybe<Scalars['String']['output']>;
  sales_channel?: Maybe<Scalars['String']['output']>;
  sales_item_id: Scalars['Int']['output'];
  sales_type?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tag_list?: Maybe<Array<Scalars['String']['output']>>;
  tax_invoice_no?: Maybe<Scalars['String']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
  unique_id?: Maybe<Scalars['String']['output']>;
};

export type CashSalesUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type CashSalesUpdateInput = {
  account_id?: InputMaybe<Scalars['String']['input']>;
  additional_discount?: InputMaybe<Scalars['Float']['input']>;
  additional_discount_type?: InputMaybe<AdditionalDiscountType>;
  aggrid_status?: InputMaybe<Scalars['String']['input']>;
  approval_step?: InputMaybe<Scalars['Int']['input']>;
  approver_list?: InputMaybe<Array<InputMaybe<Scalars['Json']['input']>>>;
  branch_id?: InputMaybe<Scalars['Int']['input']>;
  contact_person_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  coupon_code_list?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  created_by?: InputMaybe<Scalars['Json']['input']>;
  credit_day?: InputMaybe<Scalars['Int']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  customer_details?: InputMaybe<Scalars['Json']['input']>;
  customer_unique_id?: InputMaybe<Scalars['String']['input']>;
  deduction_document_list?: InputMaybe<Array<SalesDeductionUpsertInput>>;
  deduction_total_amount?: InputMaybe<Scalars['Float']['input']>;
  delivery_date?: InputMaybe<Scalars['DateTime']['input']>;
  due_date?: InputMaybe<Scalars['DateTime']['input']>;
  external_reference_no?: InputMaybe<Scalars['String']['input']>;
  flag_status?: InputMaybe<Array<Scalars['String']['input']>>;
  is_original_print?: InputMaybe<Scalars['Json']['input']>;
  issue_date?: InputMaybe<Scalars['DateTime']['input']>;
  item_list?: InputMaybe<Array<SalesItemUpsertInput>>;
  item_price_list_id?: InputMaybe<Scalars['Int']['input']>;
  last_updated_by?: InputMaybe<Scalars['Json']['input']>;
  main_status?: InputMaybe<Scalars['String']['input']>;
  need_tax_invoice?: InputMaybe<Scalars['Boolean']['input']>;
  net_amount?: InputMaybe<Scalars['Float']['input']>;
  paid_net_amount?: InputMaybe<Scalars['Float']['input']>;
  paid_total_amount?: InputMaybe<Scalars['Float']['input']>;
  payment_list?: InputMaybe<Array<SalesPaymentUpsertInput>>;
  payment_total_amount?: InputMaybe<Scalars['Float']['input']>;
  post_discount_amount?: InputMaybe<Scalars['Float']['input']>;
  pre_vat_amount?: InputMaybe<Scalars['Float']['input']>;
  price_vat_type?: InputMaybe<PriceVatType>;
  promotion_list?: InputMaybe<Array<PromotionAppliedLogUpsertInput>>;
  reference_document_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  reference_no?: InputMaybe<Scalars['String']['input']>;
  related_user_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  remark?: InputMaybe<Scalars['String']['input']>;
  reviewer_list?: InputMaybe<Array<InputMaybe<Scalars['Json']['input']>>>;
  sales_channel_id?: InputMaybe<Scalars['Int']['input']>;
  sales_contact?: InputMaybe<Array<Scalars['Json']['input']>>;
  sales_type?: InputMaybe<Scalars['String']['input']>;
  shipping_cost?: InputMaybe<Scalars['Float']['input']>;
  sub_status?: InputMaybe<Scalars['String']['input']>;
  tag_id_list?: InputMaybe<Array<Scalars['Int']['input']>>;
  tax_invoice_date?: InputMaybe<Scalars['DateTime']['input']>;
  tax_invoice_no?: InputMaybe<Scalars['String']['input']>;
  template_remark_id?: InputMaybe<Scalars['String']['input']>;
  total_amount?: InputMaybe<Scalars['Float']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
  vat_0_percent_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_7_percent_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_exempted_amount?: InputMaybe<Scalars['Float']['input']>;
  withholding_tax_amount?: InputMaybe<Scalars['Float']['input']>;
};

export type CashSalesView = {
  __typename?: 'CashSalesView';
  branch_id?: Maybe<Scalars['Int']['output']>;
  branch_name?: Maybe<Scalars['String']['output']>;
  branch_unique_id?: Maybe<Scalars['String']['output']>;
  cd_deduction_total_amount?: Maybe<Scalars['Float']['output']>;
  cd_last_deduction_date?: Maybe<Scalars['DateTime']['output']>;
  cd_unique_id_list?: Maybe<Array<Scalars['String']['output']>>;
  created_by?: Maybe<Scalars['String']['output']>;
  created_by_object?: Maybe<Scalars['Json']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  customer_name?: Maybe<Scalars['String']['output']>;
  customer_unique_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  issue_date?: Maybe<Scalars['DateTime']['output']>;
  net_amount?: Maybe<Scalars['Float']['output']>;
  reference_id?: Maybe<Scalars['Int']['output']>;
  reference_unique_id?: Maybe<Scalars['String']['output']>;
  related_user_list?: Maybe<Array<Scalars['String']['output']>>;
  related_user_object_list?: Maybe<Array<Scalars['Json']['output']>>;
  sales_channel?: Maybe<Scalars['String']['output']>;
  sales_channel_id?: Maybe<Scalars['Int']['output']>;
  sales_type?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tag_list?: Maybe<Array<Scalars['String']['output']>>;
  tax_invoice_no?: Maybe<Scalars['String']['output']>;
  unique_id: Scalars['String']['output'];
};

export type CashSalesViewAggridOutput = {
  __typename?: 'CashSalesViewAggridOutput';
  count?: Maybe<Scalars['Int']['output']>;
  results: Array<CashSalesView>;
};

export enum CouponType {
  ManyTime = 'many_time',
  OneTime = 'one_time'
}

export type CreatorInputObject = {
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  img_url?: InputMaybe<Array<Scalars['String']['input']>>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  user_unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type CreatorObject = {
  __typename?: 'CreatorObject';
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  img_url?: Maybe<Array<Scalars['String']['output']>>;
  last_name?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
  user_unique_id?: Maybe<Scalars['String']['output']>;
};

export type CustomerDeposit = {
  __typename?: 'CustomerDeposit';
  additional_discount?: Maybe<Scalars['Float']['output']>;
  additional_discount_type?: Maybe<AdditionalDiscountType>;
  aggrid_status?: Maybe<Scalars['String']['output']>;
  branch?: Maybe<Branch>;
  branch_id: Scalars['Int']['output'];
  contact_person_list?: Maybe<Array<Scalars['Json']['output']>>;
  created_by: Scalars['Json']['output'];
  created_date: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  customer_details?: Maybe<Scalars['Json']['output']>;
  customer_unique_id?: Maybe<Scalars['String']['output']>;
  deposit_list?: Maybe<Array<CustomerDepositItem>>;
  due_date: Scalars['DateTime']['output'];
  external_reference_no?: Maybe<Scalars['String']['output']>;
  flag_status?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['Int']['output'];
  is_original_print?: Maybe<Scalars['Json']['output']>;
  issue_date: Scalars['DateTime']['output'];
  last_updated_by?: Maybe<Scalars['Json']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  main_status?: Maybe<Scalars['String']['output']>;
  need_tax_invoice?: Maybe<Scalars['Boolean']['output']>;
  net_amount?: Maybe<Scalars['Float']['output']>;
  paid_net_amount?: Maybe<Scalars['Float']['output']>;
  paid_total_amount?: Maybe<Scalars['Float']['output']>;
  payment_list?: Maybe<Array<SalesPayment>>;
  payment_total_amount?: Maybe<Scalars['Float']['output']>;
  post_discount_amount?: Maybe<Scalars['Float']['output']>;
  pre_vat_amount?: Maybe<Scalars['Float']['output']>;
  price_vat_type?: Maybe<PriceVatType>;
  reference_document_list?: Maybe<Array<Scalars['Json']['output']>>;
  reference_no?: Maybe<Scalars['String']['output']>;
  related_user_list?: Maybe<Array<Scalars['Json']['output']>>;
  remaining_deposit_amount?: Maybe<Scalars['Float']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  sub_status?: Maybe<Scalars['String']['output']>;
  tag_id_list?: Maybe<Array<Scalars['Int']['output']>>;
  tag_list?: Maybe<Array<Tag>>;
  tax_invoice_date?: Maybe<Scalars['DateTime']['output']>;
  tax_invoice_no?: Maybe<Scalars['String']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
  unique_id: Scalars['String']['output'];
  vat_0_percent_amount?: Maybe<Scalars['Float']['output']>;
  vat_7_percent_amount?: Maybe<Scalars['Float']['output']>;
  vat_amount?: Maybe<Scalars['Float']['output']>;
  vat_exempted_amount?: Maybe<Scalars['Float']['output']>;
  withholding_tax_amount?: Maybe<Scalars['Float']['output']>;
};

export type CustomerDepositAggridOutput = {
  __typename?: 'CustomerDepositAggridOutput';
  count?: Maybe<Scalars['Int']['output']>;
  results: Array<CustomerDeposit>;
};

export type CustomerDepositCreateInput = {
  additional_discount?: InputMaybe<Scalars['Float']['input']>;
  additional_discount_type?: InputMaybe<AdditionalDiscountType>;
  aggrid_status?: InputMaybe<Scalars['String']['input']>;
  branch_id: Scalars['Int']['input'];
  contact_person_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  created_by: Scalars['Json']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  customer_details?: InputMaybe<Scalars['Json']['input']>;
  customer_unique_id?: InputMaybe<Scalars['String']['input']>;
  deposit_list?: InputMaybe<Array<CustomerDepositItemCreateInput>>;
  due_date: Scalars['DateTime']['input'];
  external_reference_no?: InputMaybe<Scalars['String']['input']>;
  flag_status?: InputMaybe<Array<Scalars['String']['input']>>;
  is_original_print?: InputMaybe<Scalars['Json']['input']>;
  issue_date: Scalars['DateTime']['input'];
  last_updated_by?: InputMaybe<Scalars['Json']['input']>;
  main_status?: InputMaybe<Scalars['String']['input']>;
  need_tax_invoice?: InputMaybe<Scalars['Boolean']['input']>;
  net_amount?: InputMaybe<Scalars['Float']['input']>;
  paid_net_amount?: InputMaybe<Scalars['Float']['input']>;
  paid_total_amount?: InputMaybe<Scalars['Float']['input']>;
  payment_list?: InputMaybe<Array<SalesPaymentCreateInput>>;
  payment_total_amount?: InputMaybe<Scalars['Float']['input']>;
  post_discount_amount?: InputMaybe<Scalars['Float']['input']>;
  pre_vat_amount?: InputMaybe<Scalars['Float']['input']>;
  price_vat_type?: InputMaybe<PriceVatType>;
  reference_document_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  reference_no?: InputMaybe<Scalars['String']['input']>;
  related_user_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  remaining_deposit_amount?: InputMaybe<Scalars['Float']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  sub_status?: InputMaybe<Scalars['String']['input']>;
  tag_id_list?: InputMaybe<Array<Scalars['Int']['input']>>;
  tax_invoice_date?: InputMaybe<Scalars['DateTime']['input']>;
  tax_invoice_no?: InputMaybe<Scalars['String']['input']>;
  template_remark_id?: InputMaybe<Scalars['String']['input']>;
  total_amount?: InputMaybe<Scalars['Float']['input']>;
  unique_id: Scalars['String']['input'];
  vat_0_percent_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_7_percent_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_exempted_amount?: InputMaybe<Scalars['Float']['input']>;
  withholding_tax_amount?: InputMaybe<Scalars['Float']['input']>;
};

export type CustomerDepositItem = {
  __typename?: 'CustomerDepositItem';
  customer_deposit?: Maybe<CustomerDeposit>;
  customer_deposit_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pre_vat_amount?: Maybe<Scalars['Float']['output']>;
  reference_document_id?: Maybe<Scalars['String']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  vat_percentage?: Maybe<Scalars['String']['output']>;
  withholding_tax_type?: Maybe<Scalars['String']['output']>;
  withholding_tax_value?: Maybe<Scalars['Float']['output']>;
};

export type CustomerDepositItemCreateInput = {
  customer_deposit_id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pre_vat_amount?: InputMaybe<Scalars['Float']['input']>;
  reference_document_id?: InputMaybe<Scalars['String']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  vat_percentage?: InputMaybe<Scalars['String']['input']>;
  withholding_tax_type?: InputMaybe<Scalars['String']['input']>;
  withholding_tax_value?: InputMaybe<Scalars['Float']['input']>;
};

export type CustomerDepositItemExportView = {
  __typename?: 'CustomerDepositItemExportView';
  billing_address?: Maybe<Scalars['String']['output']>;
  billing_address_country?: Maybe<Scalars['String']['output']>;
  billing_address_district?: Maybe<Scalars['String']['output']>;
  billing_address_postal_code?: Maybe<Scalars['String']['output']>;
  billing_address_province?: Maybe<Scalars['String']['output']>;
  billing_address_sub_district?: Maybe<Scalars['String']['output']>;
  branch_id?: Maybe<Scalars['String']['output']>;
  branch_name?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customer_deposit_item_id: Scalars['Int']['output'];
  customer_email?: Maybe<Scalars['String']['output']>;
  customer_fax?: Maybe<Scalars['String']['output']>;
  customer_name?: Maybe<Scalars['String']['output']>;
  customer_phone?: Maybe<Scalars['String']['output']>;
  customer_unique_id?: Maybe<Scalars['String']['output']>;
  deposit_name?: Maybe<Scalars['String']['output']>;
  due_date?: Maybe<Scalars['DateTime']['output']>;
  external_reference_no?: Maybe<Scalars['String']['output']>;
  issue_date?: Maybe<Scalars['DateTime']['output']>;
  item_net_amount?: Maybe<Scalars['Float']['output']>;
  item_pre_vat_amount?: Maybe<Scalars['Float']['output']>;
  item_total_amount?: Maybe<Scalars['Float']['output']>;
  item_vat_0_percent_amount?: Maybe<Scalars['Float']['output']>;
  item_vat_7_percent_amount?: Maybe<Scalars['Float']['output']>;
  item_vat_amount?: Maybe<Scalars['Float']['output']>;
  item_vat_exempted_amount?: Maybe<Scalars['Float']['output']>;
  item_vat_percentage?: Maybe<Scalars['String']['output']>;
  item_withholding_tax_amount?: Maybe<Scalars['Float']['output']>;
  item_withholding_tax_type?: Maybe<Scalars['String']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  latest_payment_date?: Maybe<Scalars['DateTime']['output']>;
  payment_total_amount?: Maybe<Scalars['Float']['output']>;
  price_vat_type?: Maybe<PriceVatType>;
  reference_no?: Maybe<Scalars['String']['output']>;
  related_user_list?: Maybe<Array<Scalars['String']['output']>>;
  remark?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tag_list: Array<Scalars['String']['output']>;
  tax_invoice_no?: Maybe<Scalars['String']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
  unique_id?: Maybe<Scalars['String']['output']>;
};

export type CustomerDepositItemUpsertInput = {
  customer_deposit_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pre_vat_amount?: InputMaybe<Scalars['Float']['input']>;
  reference_document_id?: InputMaybe<Scalars['String']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  vat_percentage?: InputMaybe<Scalars['String']['input']>;
  withholding_tax_type?: InputMaybe<Scalars['String']['input']>;
  withholding_tax_value?: InputMaybe<Scalars['Float']['input']>;
};

export type CustomerDepositUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerDepositUpdateInput = {
  additional_discount?: InputMaybe<Scalars['Float']['input']>;
  additional_discount_type?: InputMaybe<AdditionalDiscountType>;
  aggrid_status?: InputMaybe<Scalars['String']['input']>;
  branch_id: Scalars['Int']['input'];
  contact_person_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  created_by: Scalars['Json']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  customer_details?: InputMaybe<Scalars['Json']['input']>;
  customer_unique_id?: InputMaybe<Scalars['String']['input']>;
  deposit_list?: InputMaybe<Array<CustomerDepositItemUpsertInput>>;
  due_date: Scalars['DateTime']['input'];
  external_reference_no?: InputMaybe<Scalars['String']['input']>;
  flag_status?: InputMaybe<Array<Scalars['String']['input']>>;
  is_original_print?: InputMaybe<Scalars['Json']['input']>;
  issue_date: Scalars['DateTime']['input'];
  last_updated_by?: InputMaybe<Scalars['Json']['input']>;
  main_status?: InputMaybe<Scalars['String']['input']>;
  need_tax_invoice?: InputMaybe<Scalars['Boolean']['input']>;
  net_amount?: InputMaybe<Scalars['Float']['input']>;
  paid_net_amount?: InputMaybe<Scalars['Float']['input']>;
  paid_total_amount?: InputMaybe<Scalars['Float']['input']>;
  payment_list?: InputMaybe<Array<SalesPaymentUpsertInput>>;
  payment_total_amount?: InputMaybe<Scalars['Float']['input']>;
  post_discount_amount?: InputMaybe<Scalars['Float']['input']>;
  pre_vat_amount?: InputMaybe<Scalars['Float']['input']>;
  price_vat_type?: InputMaybe<PriceVatType>;
  reference_document_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  reference_no?: InputMaybe<Scalars['String']['input']>;
  related_user_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  remaining_deposit_amount?: InputMaybe<Scalars['Float']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  sub_status?: InputMaybe<Scalars['String']['input']>;
  tag_id_list?: InputMaybe<Array<Scalars['Int']['input']>>;
  tax_invoice_date?: InputMaybe<Scalars['DateTime']['input']>;
  tax_invoice_no?: InputMaybe<Scalars['String']['input']>;
  total_amount?: InputMaybe<Scalars['Float']['input']>;
  unique_id: Scalars['String']['input'];
  vat_0_percent_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_7_percent_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_exempted_amount?: InputMaybe<Scalars['Float']['input']>;
  withholding_tax_amount?: InputMaybe<Scalars['Float']['input']>;
};

export type CustomerDepositView = {
  __typename?: 'CustomerDepositView';
  branch_id?: Maybe<Scalars['Int']['output']>;
  branch_name?: Maybe<Scalars['String']['output']>;
  branch_unique_id?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  created_by_object?: Maybe<Scalars['Json']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  customer_name?: Maybe<Scalars['String']['output']>;
  customer_unique_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  issue_date?: Maybe<Scalars['DateTime']['output']>;
  net_amount?: Maybe<Scalars['Float']['output']>;
  related_user_list?: Maybe<Array<Scalars['String']['output']>>;
  related_user_object_list?: Maybe<Array<Scalars['Json']['output']>>;
  remaining_deposit_amount?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tag_list?: Maybe<Array<Scalars['String']['output']>>;
  tax_invoice_no?: Maybe<Scalars['String']['output']>;
  unique_id: Scalars['String']['output'];
};

export type CustomerDepositViewAggridOutput = {
  __typename?: 'CustomerDepositViewAggridOutput';
  count?: Maybe<Scalars['Int']['output']>;
  results: Array<CustomerDepositView>;
};

export enum CustomerEligibility {
  All = 'all',
  SpecificCustomers = 'specific_customers',
  SpecificGroups = 'specific_groups'
}

export type DateFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<Scalars['DateTime']['input']>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DeliveryAttribute = {
  __typename?: 'DeliveryAttribute';
  height?: Maybe<Scalars['Float']['output']>;
  height_uom?: Maybe<Unit>;
  height_uom_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  item: Item;
  item_id: Scalars['Int']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  length_uom?: Maybe<Unit>;
  length_uom_id?: Maybe<Scalars['Int']['output']>;
  thick?: Maybe<Scalars['Float']['output']>;
  thick_uom?: Maybe<Unit>;
  thick_uom_id?: Maybe<Scalars['Int']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
  volume_uom?: Maybe<Unit>;
  volume_uom_id?: Maybe<Scalars['Int']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
  weight_uom?: Maybe<Unit>;
  weight_uom_id?: Maybe<Scalars['Int']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
  width_uom?: Maybe<Unit>;
  width_uom_id?: Maybe<Scalars['Int']['output']>;
};

export type DeliveryOrder = {
  __typename?: 'DeliveryOrder';
  aggrid_status?: Maybe<Scalars['String']['output']>;
  branch: Branch;
  branch_id: Scalars['Int']['output'];
  created_by?: Maybe<CreatorObject>;
  created_date: Scalars['DateTime']['output'];
  customer_details?: Maybe<Scalars['Json']['output']>;
  customer_unique_id?: Maybe<Scalars['String']['output']>;
  delivery_date?: Maybe<Scalars['DateTime']['output']>;
  delivery_detail?: Maybe<Scalars['Json']['output']>;
  delivery_type?: Maybe<Scalars['String']['output']>;
  destination_warehouse?: Maybe<Warehouse>;
  destination_warehouse_id?: Maybe<Scalars['Int']['output']>;
  exported_date?: Maybe<Scalars['DateTime']['output']>;
  flag_status?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['Int']['output'];
  issue_date?: Maybe<Scalars['DateTime']['output']>;
  last_updated_by?: Maybe<CreatorObject>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  main_status?: Maybe<Scalars['String']['output']>;
  reference_document_list?: Maybe<Array<ReferenceSalesDocument>>;
  reference_no?: Maybe<Scalars['String']['output']>;
  related_user_list?: Maybe<Array<Scalars['Json']['output']>>;
  remark?: Maybe<Scalars['String']['output']>;
  sub_status?: Maybe<Scalars['String']['output']>;
  tag_id_list?: Maybe<Array<Scalars['Int']['output']>>;
  tag_list?: Maybe<Array<Tag>>;
  template_remark_id?: Maybe<Scalars['String']['output']>;
  trace_entry_list: Array<TraceEntry>;
  trace_entry_unique_id_list: Array<Scalars['String']['output']>;
  tracking_no?: Maybe<Scalars['String']['output']>;
  unique_id: Scalars['String']['output'];
};

export type ExportGenerateInput = {
  end_date?: InputMaybe<Scalars['DateTime']['input']>;
  export_type: SalesExportType;
  params?: InputMaybe<Scalars['Json']['input']>;
  start_date?: InputMaybe<Scalars['DateTime']['input']>;
  user_unique_id?: InputMaybe<Scalars['String']['input']>;
};

export enum GenderType {
  Female = 'female',
  Male = 'male'
}

export enum InventoryDocumentType {
  GoodsAdjust = 'goods_adjust',
  GoodsIssue = 'goods_issue',
  GoodsReceive = 'goods_receive',
  GoodsReturn = 'goods_return',
  GoodsTransfer = 'goods_transfer'
}

export type InventoryReferenceLineItem = {
  __typename?: 'InventoryReferenceLineItem';
  line_item_document_type: Scalars['String']['output'];
  line_item_unique_id: Scalars['String']['output'];
};

export type InventoryReferenceLineItemInput = {
  line_item_document_type: Scalars['String']['input'];
  line_item_unique_id: Scalars['String']['input'];
};

export type Item = {
  __typename?: 'Item';
  attribute_list: Array<Scalars['Json']['output']>;
  barcode: Scalars['String']['output'];
  brand?: Maybe<Scalars['String']['output']>;
  bundle_item_detail_list: Array<BundleItemDetail>;
  category_group?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['Json']['output']>;
  created_date: Scalars['DateTime']['output'];
  customer_insurance_duration?: Maybe<Scalars['Int']['output']>;
  deliver_uom?: Maybe<Unit>;
  deliver_uom_id?: Maybe<Scalars['Int']['output']>;
  delivery_attribute?: Maybe<DeliveryAttribute>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  img_url: Array<Scalars['String']['output']>;
  inactive_date?: Maybe<Scalars['DateTime']['output']>;
  insurance_detail?: Maybe<Scalars['String']['output']>;
  insurance_name?: Maybe<Scalars['String']['output']>;
  is_active: Scalars['Int']['output'];
  is_purchasable?: Maybe<Scalars['Boolean']['output']>;
  is_saleable?: Maybe<Scalars['Boolean']['output']>;
  is_stockable?: Maybe<Scalars['Boolean']['output']>;
  item_variant_key_list: Array<ItemVariantKey>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  main_category?: Maybe<Scalars['String']['output']>;
  max_stock_qty?: Maybe<Scalars['Float']['output']>;
  min_purchase_request_qty?: Maybe<Scalars['Int']['output']>;
  min_stock_qty?: Maybe<Scalars['Float']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  pre_sale?: Maybe<Scalars['Boolean']['output']>;
  purchase_standard_price?: Maybe<Scalars['Float']['output']>;
  purchase_uom?: Maybe<Unit>;
  purchase_uom_id?: Maybe<Scalars['Int']['output']>;
  purchase_vat_type?: Maybe<Scalars['String']['output']>;
  remark_status?: Maybe<Scalars['String']['output']>;
  reorder_point?: Maybe<Scalars['Float']['output']>;
  replenishment_stock?: Maybe<Scalars['Boolean']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_vat_type?: Maybe<Scalars['String']['output']>;
  sales_uom?: Maybe<Unit>;
  sales_uom_id?: Maybe<Scalars['Int']['output']>;
  segment?: Maybe<Scalars['String']['output']>;
  seller_insurance_duration?: Maybe<Scalars['Int']['output']>;
  seller_unique_id: Scalars['String']['output'];
  selling_point_list: Array<Scalars['Json']['output']>;
  series?: Maybe<Scalars['String']['output']>;
  set_attribute?: Maybe<Scalars['Json']['output']>;
  sku_detail_list: Array<ItemSkuDetail>;
  sku_list: Array<ItemSkuValue>;
  special_price?: Maybe<Scalars['Float']['output']>;
  stock_uom?: Maybe<Unit>;
  stock_uom_id?: Maybe<Scalars['Int']['output']>;
  sub_category?: Maybe<Scalars['String']['output']>;
  tag_id_list: Array<Scalars['Int']['output']>;
  tag_list: Array<Tag>;
  tracability?: Maybe<Tracability>;
  type?: Maybe<ItemType>;
  unique_id: Scalars['String']['output'];
  uom_group?: Maybe<UomGroup>;
  uom_group_id?: Maybe<Scalars['Int']['output']>;
  vendor_contact?: Maybe<Scalars['Json']['output']>;
};

export type ItemAdjustment = {
  __typename?: 'ItemAdjustment';
  adjusted_price?: Maybe<Scalars['Float']['output']>;
  current_price?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  item_name: Scalars['String']['output'];
  item_price_list?: Maybe<ItemPriceList>;
  item_price_list_id: Scalars['Int']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  reference_unique_id?: Maybe<Scalars['String']['output']>;
  sku_name: Scalars['String']['output'];
};

export type ItemDeleteOutput = {
  __typename?: 'ItemDeleteOutput';
  active_document_list?: Maybe<Array<Scalars['String']['output']>>;
  is_deletable?: Maybe<Scalars['Boolean']['output']>;
  item?: Maybe<Item>;
};

export type ItemPriceList = {
  __typename?: 'ItemPriceList';
  adjusted_item_list?: Maybe<Array<Maybe<ItemAdjustment>>>;
  adjusted_price?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  end_date?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  is_active: Scalars['Int']['output'];
  is_increase: Scalars['Int']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  sales_channel?: Maybe<SalesChannel>;
  sales_channel_id?: Maybe<Scalars['Int']['output']>;
  start_date?: Maybe<Scalars['DateTime']['output']>;
  type: Scalars['String']['output'];
  unique_id: Scalars['String']['output'];
};

export type ItemSkuDetail = {
  __typename?: 'ItemSkuDetail';
  available_qty?: Maybe<Scalars['Int']['output']>;
  barcode?: Maybe<Scalars['String']['output']>;
  bundle_item_detail_list: Array<BundleItemDetail>;
  id: Scalars['Int']['output'];
  img_url: Array<Scalars['String']['output']>;
  item: Item;
  item_sku: ItemSkuValue;
  item_sku_qty?: Maybe<Array<ItemSkuQty>>;
  item_unique_id: Scalars['String']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  purchase_ordered_qty?: Maybe<Scalars['Int']['output']>;
  purchase_standard_price?: Maybe<Scalars['Float']['output']>;
  sale_committed_qty?: Maybe<Scalars['Int']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sku_name: Scalars['String']['output'];
  special_price?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  stock_qty?: Maybe<Scalars['Int']['output']>;
  total_sku_qty?: Maybe<Scalars['Json']['output']>;
};

export type ItemSkuQty = {
  __typename?: 'ItemSkuQty';
  available_qty: Scalars['Int']['output'];
  barcode: Scalars['String']['output'];
  bin_id?: Maybe<Scalars['Int']['output']>;
  bin_location?: Maybe<BinLocation>;
  bin_name?: Maybe<Scalars['String']['output']>;
  expired_date?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  item_sku_detail?: Maybe<ItemSkuDetail>;
  item_unique_id?: Maybe<Scalars['String']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  lot_date?: Maybe<Scalars['DateTime']['output']>;
  manufactured_date?: Maybe<Scalars['DateTime']['output']>;
  purchase_ordered_qty: Scalars['Int']['output'];
  sale_committed_qty: Scalars['Int']['output'];
  serial_no?: Maybe<Scalars['String']['output']>;
  sku_name: Scalars['String']['output'];
  stock_qty: Scalars['Int']['output'];
  transit_qty: Scalars['Int']['output'];
  warehouse?: Maybe<Warehouse>;
  warehouse_id?: Maybe<Scalars['Int']['output']>;
};

export enum ItemSkuQtyScalarFieldEnum {
  BinId = 'bin_id',
  Id = 'id',
  SkuName = 'sku_name',
  WarehouseId = 'warehouse_id'
}

export type ItemSkuValue = {
  __typename?: 'ItemSkuValue';
  id: Scalars['Int']['output'];
  item?: Maybe<Item>;
  item_unique_id?: Maybe<Scalars['String']['output']>;
  item_variant_value: Array<ItemVariantValue>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  sku_detail?: Maybe<ItemSkuDetail>;
  sku_name: Scalars['String']['output'];
  variant_key_id: Scalars['Int']['output'];
  variant_value_id: Scalars['Int']['output'];
};

export enum ItemType {
  Bundle = 'bundle',
  Normal = 'normal',
  Service = 'service',
  Variant = 'variant'
}

export type ItemVariantKey = {
  __typename?: 'ItemVariantKey';
  id: Scalars['Int']['output'];
  item: Item;
  item_unique_id: Scalars['String']['output'];
  item_variant_value_list: Array<ItemVariantValue>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  variant_key_name: Scalars['String']['output'];
};

export type ItemVariantValue = {
  __typename?: 'ItemVariantValue';
  id: Scalars['Int']['output'];
  item_sku: Array<ItemSkuValue>;
  item_unique_id: Scalars['String']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  variant_key: ItemVariantKey;
  variant_key_name: Scalars['String']['output'];
  variant_value_name: Scalars['String']['output'];
};

export enum MarketingModelType {
  PromotionSetting = 'promotion_setting'
}

export type Mutation = {
  __typename?: 'Mutation';
  ActivityLogCreate?: Maybe<ActivityLog>;
  CashSalesCreate: CashSales;
  CashSalesDelete: CashSales;
  CashSalesUpdate: CashSales;
  CustomerDepositCreate: CustomerDeposit;
  CustomerDepositDelete: CustomerDeposit;
  CustomerDepositUpdate: CustomerDeposit;
  QuotationCreate: Quotation;
  QuotationDelete: Quotation;
  QuotationUpdate: Quotation;
  SalesInvoiceCreate: SalesInvoice;
  SalesInvoiceDelete: SalesInvoice;
  SalesInvoiceUpdate: SalesInvoice;
  SalesOrderCreate: SalesOrder;
  SalesOrderDelete: SalesOrder;
  SalesOrderUpdate: SalesOrder;
  SalesOriginalPrint?: Maybe<SalesOriginalPrintOutput>;
  SalesReturnCreate: SalesReturn;
  SalesReturnDelete: SalesReturn;
  SalesReturnUpdate: SalesReturn;
};


export type MutationActivityLogCreateArgs = {
  data: ActivityLogCreateInput;
};


export type MutationCashSalesCreateArgs = {
  createInput: CashSalesCreateInput;
};


export type MutationCashSalesDeleteArgs = {
  uniqueInput: CashSalesUniqueInput;
};


export type MutationCashSalesUpdateArgs = {
  uniqueInput: CashSalesUniqueInput;
  updateInput: CashSalesUpdateInput;
};


export type MutationCustomerDepositCreateArgs = {
  input: CustomerDepositCreateInput;
};


export type MutationCustomerDepositDeleteArgs = {
  uniqueInput: CustomerDepositUniqueInput;
};


export type MutationCustomerDepositUpdateArgs = {
  input: CustomerDepositUpdateInput;
  uniqueInput: CustomerDepositUniqueInput;
};


export type MutationQuotationCreateArgs = {
  input: QuotationCreateInput;
};


export type MutationQuotationDeleteArgs = {
  uniqueInput: QuotationUniqueInput;
};


export type MutationQuotationUpdateArgs = {
  input: QuotationUpdateInput;
  uniqueInput: QuotationUniqueInput;
};


export type MutationSalesInvoiceCreateArgs = {
  input: SalesInvoiceCreateInput;
};


export type MutationSalesInvoiceDeleteArgs = {
  uniqueInput: SalesInvoiceUniqueInput;
};


export type MutationSalesInvoiceUpdateArgs = {
  input: SalesInvoiceUpdateInput;
  uniqueInput: SalesInvoiceUniqueInput;
};


export type MutationSalesOrderCreateArgs = {
  input: SalesOrderCreateInput;
};


export type MutationSalesOrderDeleteArgs = {
  uniqueInput: SalesOrderUniqueInput;
};


export type MutationSalesOrderUpdateArgs = {
  input: SalesOrderUpdateInput;
  uniqueInput: SalesOrderUniqueInput;
};


export type MutationSalesOriginalPrintArgs = {
  input: SalesOriginalPrintInput;
};


export type MutationSalesReturnCreateArgs = {
  input: SalesReturnCreateInput;
};


export type MutationSalesReturnDeleteArgs = {
  uniqueInput: SalesReturnUniqueInput;
};


export type MutationSalesReturnUpdateArgs = {
  input: SalesReturnUpdateInput;
  uniqueInput: SalesReturnUniqueInput;
};

export enum PriceVatType {
  ExcludeVat = 'exclude_vat',
  IncludeVat = 'include_vat'
}

export type PromotionAppliedLog = {
  __typename?: 'PromotionAppliedLog';
  cash_sales?: Maybe<CashSales>;
  cash_sales_id?: Maybe<Scalars['Int']['output']>;
  conditional_item_id_list: Array<Scalars['Int']['output']>;
  coupon_code: Scalars['String']['output'];
  discount_rate?: Maybe<Scalars['Decimal']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  promotion_id: Scalars['Int']['output'];
  promotion_unique_id?: Maybe<Scalars['String']['output']>;
  receive_type?: Maybe<ReceiveType>;
  redeem_item_list: Array<Scalars['Json']['output']>;
  total_discount_amount?: Maybe<Scalars['Decimal']['output']>;
};

export type PromotionAppliedLogUpsertInput = {
  conditional_item_id_list: Array<Scalars['Int']['input']>;
  coupon_code: Scalars['String']['input'];
  discount_rate?: InputMaybe<Scalars['Decimal']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  promotion_id: Scalars['Int']['input'];
  promotion_unique_id?: InputMaybe<Scalars['String']['input']>;
  receive_type?: InputMaybe<ReceiveType>;
  redeem_item_list: Array<Scalars['Json']['input']>;
  total_discount_amount?: InputMaybe<Scalars['Decimal']['input']>;
};

export enum PromotionCategory {
  DiscountFixPrice = 'discount_fix_price',
  DiscountOrder = 'discount_order',
  DiscountProduct = 'discount_product',
  FreeGift = 'free_gift'
}

export enum PromotionStatus {
  Active = 'active',
  Inactive = 'inactive'
}

export enum PromotionType {
  AllPromotions = 'all_promotions',
  SingleCategoryPromotion = 'single_category_promotion',
  SinglePromotion = 'single_promotion'
}

export enum PurchaseCondition {
  AllItems = 'all_items',
  SpecificItems = 'specific_items'
}

export enum PurchaseDocumentType {
  PurchaseOrder = 'purchase_order',
  PurchaseRequest = 'purchase_request',
  PurchaseReturn = 'purchase_return'
}

export type PurchaseItem = {
  __typename?: 'PurchaseItem';
  barcode: Scalars['String']['output'];
  discount?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  item_img_url?: Maybe<Array<Scalars['String']['output']>>;
  item_name: Scalars['String']['output'];
  item_sku_desc?: Maybe<Scalars['String']['output']>;
  item_sku_name: Scalars['String']['output'];
  item_unique_id: Scalars['String']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  po_qty?: Maybe<Scalars['Float']['output']>;
  pre_vat_amount?: Maybe<Scalars['Float']['output']>;
  price_per_unit?: Maybe<Scalars['Float']['output']>;
  qty: Scalars['Float']['output'];
  qty_issued?: Maybe<Scalars['Float']['output']>;
  qty_ordered?: Maybe<Scalars['Float']['output']>;
  qty_received?: Maybe<Scalars['Float']['output']>;
  reference_document_type: PurchaseDocumentType;
  reference_line_item?: Maybe<ReferencePurchaseLineItem>;
  reference_unique_id: Scalars['String']['output'];
  remark?: Maybe<Scalars['String']['output']>;
  stock_qty?: Maybe<Scalars['Float']['output']>;
  tracability: TraceAbilityEnum;
  unique_id: Scalars['String']['output'];
  uom_id: Scalars['Int']['output'];
  uom_name: Scalars['String']['output'];
  vat_percentage?: Maybe<Scalars['String']['output']>;
  withholding_tax_type?: Maybe<Scalars['String']['output']>;
  withholding_tax_value?: Maybe<Scalars['Float']['output']>;
};

export type PurchaseOrder = {
  __typename?: 'PurchaseOrder';
  additional_discount?: Maybe<Scalars['Float']['output']>;
  additional_discount_type?: Maybe<AdditionalDiscountType>;
  aggrid_status?: Maybe<Scalars['String']['output']>;
  approval_step?: Maybe<Scalars['Int']['output']>;
  approver_list?: Maybe<Array<Scalars['Json']['output']>>;
  branch: Branch;
  branch_id: Scalars['Int']['output'];
  created_by?: Maybe<CreatorObject>;
  created_date: Scalars['DateTime']['output'];
  credit_day?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  currency_display_name?: Maybe<Scalars['String']['output']>;
  delivery_address?: Maybe<Scalars['Json']['output']>;
  destination_warehouse?: Maybe<Warehouse>;
  destination_warehouse_id?: Maybe<Scalars['Int']['output']>;
  exchange_rate?: Maybe<Scalars['Float']['output']>;
  expected_date?: Maybe<Scalars['DateTime']['output']>;
  flag_status?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['Int']['output'];
  issue_date?: Maybe<Scalars['DateTime']['output']>;
  item_list?: Maybe<Array<PurchaseItem>>;
  last_updated_by?: Maybe<CreatorObject>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  main_status?: Maybe<Scalars['String']['output']>;
  net_amount?: Maybe<Scalars['Float']['output']>;
  post_discount_amount?: Maybe<Scalars['Float']['output']>;
  pre_vat_amount?: Maybe<Scalars['Float']['output']>;
  price_vat_type?: Maybe<PriceVatType>;
  reference_document_id?: Maybe<Scalars['String']['output']>;
  reference_document_list?: Maybe<Array<PurchaseReferenceDocument>>;
  reference_no?: Maybe<Scalars['String']['output']>;
  related_user_list?: Maybe<Array<Scalars['Json']['output']>>;
  remark?: Maybe<Scalars['String']['output']>;
  reviewer_list?: Maybe<Array<Scalars['Json']['output']>>;
  sub_status?: Maybe<Scalars['String']['output']>;
  tag_id_list?: Maybe<Array<Scalars['Int']['output']>>;
  tag_list?: Maybe<Array<Tag>>;
  template_remark_id?: Maybe<Scalars['String']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
  unique_id: Scalars['String']['output'];
  vat_0_percent_amount?: Maybe<Scalars['Float']['output']>;
  vat_7_percent_amount?: Maybe<Scalars['Float']['output']>;
  vat_amount?: Maybe<Scalars['Float']['output']>;
  vat_exempted_amount?: Maybe<Scalars['Float']['output']>;
  vendor_details?: Maybe<Scalars['Json']['output']>;
  vendor_unique_id?: Maybe<Scalars['String']['output']>;
  withholding_tax_amount?: Maybe<Scalars['Float']['output']>;
  within_date?: Maybe<Scalars['DateTime']['output']>;
};

export type PurchaseReferenceDocument = {
  __typename?: 'PurchaseReferenceDocument';
  document_id?: Maybe<Scalars['Int']['output']>;
  document_type?: Maybe<PurchaseReferenceType>;
  document_unique_id?: Maybe<Scalars['String']['output']>;
};

export type PurchaseReferenceDocumentInput = {
  document_id?: InputMaybe<Scalars['Int']['input']>;
  document_type?: InputMaybe<PurchaseReferenceType>;
  document_unique_id?: InputMaybe<Scalars['String']['input']>;
};

export enum PurchaseReferenceType {
  PurchaseOrder = 'purchase_order',
  PurchaseRequest = 'purchase_request',
  PurchaseReturn = 'purchase_return',
  SalesOrder = 'sales_order'
}

export type PurchaseRequest = {
  __typename?: 'PurchaseRequest';
  accepted_remark?: Maybe<Scalars['String']['output']>;
  aggrid_status?: Maybe<Scalars['String']['output']>;
  approval_step?: Maybe<Scalars['Int']['output']>;
  approver_list?: Maybe<Array<Scalars['Json']['output']>>;
  attachment_list?: Maybe<Array<Scalars['Json']['output']>>;
  branch: Branch;
  branch_id: Scalars['Int']['output'];
  created_by?: Maybe<CreatorObject>;
  created_date: Scalars['DateTime']['output'];
  delivery_address?: Maybe<Scalars['Json']['output']>;
  expected_date?: Maybe<Scalars['DateTime']['output']>;
  flag_status?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['Int']['output'];
  issue_date?: Maybe<Scalars['DateTime']['output']>;
  item_list?: Maybe<Array<PurchaseItem>>;
  last_updated_by?: Maybe<CreatorObject>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  main_status?: Maybe<Scalars['String']['output']>;
  reference_document_list?: Maybe<Array<PurchaseReferenceDocument>>;
  reference_no?: Maybe<Scalars['String']['output']>;
  related_user_list?: Maybe<Array<Scalars['Json']['output']>>;
  remark?: Maybe<Scalars['String']['output']>;
  requester?: Maybe<Scalars['Json']['output']>;
  reviewer_list?: Maybe<Array<Scalars['Json']['output']>>;
  sub_status?: Maybe<Scalars['String']['output']>;
  tag_id_list?: Maybe<Array<Scalars['Int']['output']>>;
  tag_list?: Maybe<Array<Tag>>;
  template_remark_id?: Maybe<Scalars['String']['output']>;
  unique_id: Scalars['String']['output'];
  within_date?: Maybe<Scalars['DateTime']['output']>;
};

export type PurchaseReturn = {
  __typename?: 'PurchaseReturn';
  additional_discount?: Maybe<Scalars['Float']['output']>;
  additional_discount_type?: Maybe<AdditionalDiscountType>;
  aggrid_status?: Maybe<Scalars['String']['output']>;
  approval_step?: Maybe<Scalars['Int']['output']>;
  approver_list?: Maybe<Array<Scalars['Json']['output']>>;
  branch: Branch;
  branch_id: Scalars['Int']['output'];
  created_by?: Maybe<CreatorObject>;
  created_date: Scalars['DateTime']['output'];
  credit_day?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  currency_display_name?: Maybe<Scalars['String']['output']>;
  delivery_address?: Maybe<Scalars['Json']['output']>;
  delivery_date?: Maybe<Scalars['DateTime']['output']>;
  exchange_rate?: Maybe<Scalars['Float']['output']>;
  flag_status?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['Int']['output'];
  issue_date?: Maybe<Scalars['DateTime']['output']>;
  item_list?: Maybe<Array<PurchaseItem>>;
  last_updated_by?: Maybe<CreatorObject>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  main_status?: Maybe<Scalars['String']['output']>;
  net_amount?: Maybe<Scalars['Float']['output']>;
  post_discount_amount?: Maybe<Scalars['Float']['output']>;
  pre_vat_amount?: Maybe<Scalars['Float']['output']>;
  price_vat_type?: Maybe<PriceVatType>;
  reason_to_return?: Maybe<Scalars['String']['output']>;
  reference_document_list?: Maybe<Array<PurchaseReferenceDocument>>;
  reference_no?: Maybe<Scalars['String']['output']>;
  related_user_list?: Maybe<Array<Scalars['Json']['output']>>;
  remark?: Maybe<Scalars['String']['output']>;
  reviewer_list?: Maybe<Array<Scalars['Json']['output']>>;
  sub_status?: Maybe<Scalars['String']['output']>;
  tag_id_list?: Maybe<Array<Scalars['Int']['output']>>;
  tag_list?: Maybe<Array<Tag>>;
  template_remark_id?: Maybe<Scalars['String']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
  unique_id: Scalars['String']['output'];
  vat_0_percent_amount?: Maybe<Scalars['Float']['output']>;
  vat_7_percent_amount?: Maybe<Scalars['Float']['output']>;
  vat_amount?: Maybe<Scalars['Float']['output']>;
  vat_exempted_amount?: Maybe<Scalars['Float']['output']>;
  vendor_details?: Maybe<Scalars['Json']['output']>;
  vendor_unique_id?: Maybe<Scalars['String']['output']>;
  withholding_tax_amount?: Maybe<Scalars['Float']['output']>;
};

export type Query = {
  __typename?: 'Query';
  ActivityLogFindManyAggrid: ActivityLogFindManyAggrid;
  ActivityLogFindManyByReferenceId: Array<ActivityLog>;
  ActivityLogFindUnique?: Maybe<ActivityLog>;
  CashSalesAggrid: CashSalesAggridOutput;
  CashSalesFindAll?: Maybe<Array<CashSales>>;
  CashSalesFindUnique: CashSales;
  CashSalesViewsAggrid: CashSalesViewAggridOutput;
  CustomerDepositFindUnique: CustomerDeposit;
  CustomerDepositViewsAggrid: CustomerDepositViewAggridOutput;
  CustomerDepositsAggrid: CustomerDepositAggridOutput;
  CustomerDepositsFindAll?: Maybe<Array<CustomerDeposit>>;
  GenerateExport: Scalars['String']['output'];
  QuotationFindUnique: Quotation;
  QuotationViewsAggrid: QuotationViewAggridOutput;
  QuotationsAggrid: QuotationAggridOutput;
  QuotationsFindAll?: Maybe<Array<Quotation>>;
  SalesByCustomerExportViewsAggrid: SalesByCustomerExportViewAggridOutput;
  SalesInvoiceFindUnique: SalesInvoice;
  SalesInvoiceViewsAggrid: SalesInvoiceViewAggridOutput;
  SalesInvoicesAggrid: SalesInvoiceAggridOutput;
  SalesInvoicesFindAll?: Maybe<Array<SalesInvoice>>;
  SalesItemByBranchExportViewsAggrid: SalesItemByBranchExportViewAggridOutput;
  SalesItemExportViewsAggrid: SalesItemExportViewAggridOutput;
  SalesItemFindMany?: Maybe<Array<Maybe<SalesItem>>>;
  SalesOrderCanCreatePurchaseRequest: Scalars['Boolean']['output'];
  SalesOrderFindUnique: SalesOrder;
  SalesOrderSalesItemReportViewsAggrid: SalesOrderSalesItemReportViewAggridOutput;
  SalesOrderViewsAggrid: SalesOrderViewAggridOutput;
  SalesOrdersAggrid: SalesOrderAggridOutput;
  SalesOrdersFindAll?: Maybe<Array<SalesOrder>>;
  SalesReturnFindUnique: SalesReturn;
  SalesReturnViewsAggrid: SalesReturnViewAggridOutput;
  SalesReturnsAggrid: SalesReturnAggridOutput;
  SalesReturnsFindAll?: Maybe<Array<SalesReturn>>;
  SalesValidateCancelable: Scalars['Any']['output'];
  UniqueIdGenerate: Scalars['String']['output'];
  UniqueIdIsExist: Scalars['Boolean']['output'];
};


export type QueryActivityLogFindManyAggridArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryActivityLogFindManyByReferenceIdArgs = {
  findManyInput: ActivityLogByRefereceIdInput;
};


export type QueryActivityLogFindUniqueArgs = {
  uniqueInput?: InputMaybe<ActivityLogUniqueInput>;
};


export type QueryCashSalesAggridArgs = {
  aggridInput: Scalars['AnyAggridInput']['input'];
};


export type QueryCashSalesFindUniqueArgs = {
  uniqueInput: CashSalesUniqueInput;
};


export type QueryCashSalesViewsAggridArgs = {
  aggridInput: Scalars['AnyAggridInput']['input'];
};


export type QueryCustomerDepositFindUniqueArgs = {
  uniqueInput: CustomerDepositUniqueInput;
};


export type QueryCustomerDepositViewsAggridArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryCustomerDepositsAggridArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryGenerateExportArgs = {
  input?: InputMaybe<ExportGenerateInput>;
};


export type QueryQuotationFindUniqueArgs = {
  uniqueInput: QuotationUniqueInput;
};


export type QueryQuotationViewsAggridArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryQuotationsAggridArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QuerySalesByCustomerExportViewsAggridArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QuerySalesInvoiceFindUniqueArgs = {
  uniqueInput: SalesInvoiceUniqueInput;
};


export type QuerySalesInvoiceViewsAggridArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QuerySalesInvoicesAggridArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QuerySalesItemByBranchExportViewsAggridArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QuerySalesItemExportViewsAggridArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QuerySalesItemFindManyArgs = {
  input?: InputMaybe<SalesItemFindManyInput>;
};


export type QuerySalesOrderCanCreatePurchaseRequestArgs = {
  uniqueInput: SalesOrderUniqueInput;
};


export type QuerySalesOrderFindUniqueArgs = {
  uniqueInput: SalesOrderUniqueInput;
};


export type QuerySalesOrderSalesItemReportViewsAggridArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QuerySalesOrderViewsAggridArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QuerySalesOrdersAggridArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QuerySalesReturnFindUniqueArgs = {
  uniqueInput: SalesReturnUniqueInput;
};


export type QuerySalesReturnViewsAggridArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QuerySalesReturnsAggridArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QuerySalesValidateCancelableArgs = {
  input: SalesValidateCancelableInput;
};


export type QueryUniqueIdGenerateArgs = {
  modelType: SalesModelType;
  usePreorderQuota?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryUniqueIdIsExistArgs = {
  modelType: SalesModelType;
  uniqueId: Scalars['String']['input'];
};

export type Quotation = {
  __typename?: 'Quotation';
  accepted_date?: Maybe<Scalars['DateTime']['output']>;
  accepted_remark?: Maybe<Scalars['String']['output']>;
  account_id?: Maybe<Scalars['String']['output']>;
  additional_discount?: Maybe<Scalars['Float']['output']>;
  additional_discount_type?: Maybe<AdditionalDiscountType>;
  aggrid_status?: Maybe<Scalars['String']['output']>;
  approval_step?: Maybe<Scalars['Int']['output']>;
  approver_list?: Maybe<Array<Maybe<Scalars['Json']['output']>>>;
  attachment_list?: Maybe<Array<Maybe<Scalars['Json']['output']>>>;
  branch: Branch;
  branch_id: Scalars['Int']['output'];
  contact_person_list?: Maybe<Array<Scalars['Json']['output']>>;
  contact_unique_id?: Maybe<Scalars['String']['output']>;
  created_by: Scalars['Json']['output'];
  created_date: Scalars['DateTime']['output'];
  credit_day?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customer_details?: Maybe<Scalars['Json']['output']>;
  customer_unique_id?: Maybe<Scalars['String']['output']>;
  due_date?: Maybe<Scalars['DateTime']['output']>;
  flag_status?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['Int']['output'];
  issue_date?: Maybe<Scalars['DateTime']['output']>;
  item_list?: Maybe<Array<Maybe<SalesItem>>>;
  item_price_list?: Maybe<ItemPriceList>;
  item_price_list_id?: Maybe<Scalars['Int']['output']>;
  last_updated_by?: Maybe<Scalars['Json']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  main_status?: Maybe<Scalars['String']['output']>;
  net_amount?: Maybe<Scalars['Float']['output']>;
  post_discount_amount?: Maybe<Scalars['Float']['output']>;
  pre_vat_amount?: Maybe<Scalars['Float']['output']>;
  price_vat_type?: Maybe<PriceVatType>;
  reference_no?: Maybe<Scalars['String']['output']>;
  related_user_list?: Maybe<Array<Scalars['Json']['output']>>;
  remark?: Maybe<Scalars['String']['output']>;
  reviewer_list?: Maybe<Array<Maybe<Scalars['Json']['output']>>>;
  sales_channel?: Maybe<SalesChannel>;
  sales_channel_id?: Maybe<Scalars['Int']['output']>;
  sales_contact?: Maybe<Array<Scalars['Json']['output']>>;
  sales_type?: Maybe<Scalars['String']['output']>;
  shipping_cost?: Maybe<Scalars['Float']['output']>;
  sub_status?: Maybe<Scalars['String']['output']>;
  tag_id_list?: Maybe<Array<Scalars['Int']['output']>>;
  tag_list?: Maybe<Array<Maybe<Tag>>>;
  template_remark_id?: Maybe<Scalars['String']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
  unique_id: Scalars['String']['output'];
  vat_0_percent_amount?: Maybe<Scalars['Float']['output']>;
  vat_7_percent_amount?: Maybe<Scalars['Float']['output']>;
  vat_amount?: Maybe<Scalars['Float']['output']>;
  vat_exempted_amount?: Maybe<Scalars['Float']['output']>;
  withholding_tax_amount?: Maybe<Scalars['Float']['output']>;
};

export type QuotationAggridOutput = {
  __typename?: 'QuotationAggridOutput';
  count?: Maybe<Scalars['Int']['output']>;
  results: Array<Quotation>;
};

export type QuotationCreateInput = {
  accepted_date?: InputMaybe<Scalars['DateTime']['input']>;
  accepted_remark?: InputMaybe<Scalars['String']['input']>;
  account_id?: InputMaybe<Scalars['String']['input']>;
  additional_discount?: InputMaybe<Scalars['Float']['input']>;
  additional_discount_type?: InputMaybe<AdditionalDiscountType>;
  aggrid_status?: InputMaybe<Scalars['String']['input']>;
  approval_step?: InputMaybe<Scalars['Int']['input']>;
  approver_list?: InputMaybe<Array<InputMaybe<Scalars['Json']['input']>>>;
  attachment_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  branch_id: Scalars['Int']['input'];
  contact_person_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  created_by: Scalars['Json']['input'];
  credit_day?: InputMaybe<Scalars['Int']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  customer_details?: InputMaybe<Scalars['Json']['input']>;
  customer_unique_id?: InputMaybe<Scalars['String']['input']>;
  due_date?: InputMaybe<Scalars['DateTime']['input']>;
  flag_status?: InputMaybe<Array<Scalars['String']['input']>>;
  issue_date?: InputMaybe<Scalars['DateTime']['input']>;
  item_list?: InputMaybe<Array<SalesItemCreateInput>>;
  item_price_list_id?: InputMaybe<Scalars['Int']['input']>;
  last_updated_by?: InputMaybe<Scalars['Json']['input']>;
  main_status?: InputMaybe<Scalars['String']['input']>;
  net_amount?: InputMaybe<Scalars['Float']['input']>;
  post_discount_amount?: InputMaybe<Scalars['Float']['input']>;
  pre_vat_amount?: InputMaybe<Scalars['Float']['input']>;
  price_vat_type?: InputMaybe<PriceVatType>;
  reference_no?: InputMaybe<Scalars['String']['input']>;
  related_user_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  remark?: InputMaybe<Scalars['String']['input']>;
  reviewer_list?: InputMaybe<Array<InputMaybe<Scalars['Json']['input']>>>;
  sales_channel_id?: InputMaybe<Scalars['Int']['input']>;
  sales_contact?: InputMaybe<Array<Scalars['Json']['input']>>;
  sales_type?: InputMaybe<Scalars['String']['input']>;
  shipping_cost?: InputMaybe<Scalars['Float']['input']>;
  sub_status?: InputMaybe<Scalars['String']['input']>;
  tag_id_list?: InputMaybe<Array<Scalars['Int']['input']>>;
  template_remark_id?: InputMaybe<Scalars['String']['input']>;
  total_amount?: InputMaybe<Scalars['Float']['input']>;
  unique_id: Scalars['String']['input'];
  vat_0_percent_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_7_percent_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_exempted_amount?: InputMaybe<Scalars['Float']['input']>;
  withholding_tax_amount?: InputMaybe<Scalars['Float']['input']>;
};

export type QuotationSalesItemExportView = {
  __typename?: 'QuotationSalesItemExportView';
  accepted_date?: Maybe<Scalars['DateTime']['output']>;
  accepted_remark?: Maybe<Scalars['String']['output']>;
  additional_discount?: Maybe<Scalars['Float']['output']>;
  billing_address?: Maybe<Scalars['String']['output']>;
  billing_address_country?: Maybe<Scalars['String']['output']>;
  billing_address_district?: Maybe<Scalars['String']['output']>;
  billing_address_postal_code?: Maybe<Scalars['String']['output']>;
  billing_address_province?: Maybe<Scalars['String']['output']>;
  billing_address_sub_district?: Maybe<Scalars['String']['output']>;
  branch_id?: Maybe<Scalars['Int']['output']>;
  branch_name?: Maybe<Scalars['String']['output']>;
  branch_unique_id?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  credit_day?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customer_email?: Maybe<Scalars['String']['output']>;
  customer_fax?: Maybe<Scalars['String']['output']>;
  customer_name?: Maybe<Scalars['String']['output']>;
  customer_phone?: Maybe<Scalars['String']['output']>;
  customer_unique_id?: Maybe<Scalars['String']['output']>;
  delivery_address?: Maybe<Scalars['String']['output']>;
  delivery_address_contact_name?: Maybe<Scalars['String']['output']>;
  delivery_address_contact_phone?: Maybe<Scalars['String']['output']>;
  delivery_address_country?: Maybe<Scalars['String']['output']>;
  delivery_address_district?: Maybe<Scalars['String']['output']>;
  delivery_address_postal_code?: Maybe<Scalars['String']['output']>;
  delivery_address_province?: Maybe<Scalars['String']['output']>;
  delivery_address_sub_district?: Maybe<Scalars['String']['output']>;
  due_date?: Maybe<Scalars['DateTime']['output']>;
  issue_date?: Maybe<Scalars['DateTime']['output']>;
  item_additional_discount?: Maybe<Scalars['Float']['output']>;
  item_discount?: Maybe<Scalars['Float']['output']>;
  item_name?: Maybe<Scalars['String']['output']>;
  item_net_amount?: Maybe<Scalars['Float']['output']>;
  item_post_discount_amount?: Maybe<Scalars['Float']['output']>;
  item_pre_discount_amount?: Maybe<Scalars['Float']['output']>;
  item_pre_vat_amount?: Maybe<Scalars['Float']['output']>;
  item_price_list?: Maybe<Scalars['String']['output']>;
  item_price_per_unit?: Maybe<Scalars['Float']['output']>;
  item_qty?: Maybe<Scalars['Float']['output']>;
  item_remark?: Maybe<Scalars['String']['output']>;
  item_sku_desc?: Maybe<Scalars['String']['output']>;
  item_stock_qty?: Maybe<Scalars['Float']['output']>;
  item_unique_id?: Maybe<Scalars['String']['output']>;
  item_uom?: Maybe<Scalars['String']['output']>;
  item_vat_0_percent_amount?: Maybe<Scalars['Float']['output']>;
  item_vat_7_percent_amount?: Maybe<Scalars['Float']['output']>;
  item_vat_amount?: Maybe<Scalars['Float']['output']>;
  item_vat_exempted_amount?: Maybe<Scalars['Float']['output']>;
  item_vat_percentage?: Maybe<Scalars['String']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  price_standing_day?: Maybe<Scalars['Int']['output']>;
  price_vat_type?: Maybe<PriceVatType>;
  reference_no?: Maybe<Scalars['String']['output']>;
  related_user_list?: Maybe<Array<Scalars['String']['output']>>;
  remark?: Maybe<Scalars['String']['output']>;
  sales_channel?: Maybe<Scalars['String']['output']>;
  sales_item_id: Scalars['Int']['output'];
  sales_type?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tag_list: Array<Scalars['String']['output']>;
  total_net_amount?: Maybe<Scalars['Float']['output']>;
  total_vat_amount?: Maybe<Scalars['Float']['output']>;
  unique_id?: Maybe<Scalars['String']['output']>;
};

export type QuotationUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type QuotationUpdateInput = {
  accepted_date?: InputMaybe<Scalars['DateTime']['input']>;
  accepted_remark?: InputMaybe<Scalars['String']['input']>;
  account_id?: InputMaybe<Scalars['String']['input']>;
  additional_discount?: InputMaybe<Scalars['Float']['input']>;
  additional_discount_type?: InputMaybe<AdditionalDiscountType>;
  aggrid_status?: InputMaybe<Scalars['String']['input']>;
  approval_step?: InputMaybe<Scalars['Int']['input']>;
  approver_list?: InputMaybe<Array<InputMaybe<Scalars['Json']['input']>>>;
  attachment_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  branch_id?: InputMaybe<Scalars['Int']['input']>;
  contact_person_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  credit_day?: InputMaybe<Scalars['Int']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  customer_details?: InputMaybe<Scalars['Json']['input']>;
  customer_unique_id?: InputMaybe<Scalars['String']['input']>;
  due_date?: InputMaybe<Scalars['DateTime']['input']>;
  flag_status?: InputMaybe<Array<Scalars['String']['input']>>;
  issue_date?: InputMaybe<Scalars['DateTime']['input']>;
  item_list?: InputMaybe<Array<SalesItemUpsertInput>>;
  item_price_list_id: Scalars['Int']['input'];
  last_updated_by?: InputMaybe<Scalars['Json']['input']>;
  main_status?: InputMaybe<Scalars['String']['input']>;
  net_amount?: InputMaybe<Scalars['Float']['input']>;
  post_discount_amount?: InputMaybe<Scalars['Float']['input']>;
  pre_vat_amount?: InputMaybe<Scalars['Float']['input']>;
  price_vat_type?: InputMaybe<PriceVatType>;
  reference_no?: InputMaybe<Scalars['String']['input']>;
  related_user_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  remark?: InputMaybe<Scalars['String']['input']>;
  reviewer_list?: InputMaybe<Array<InputMaybe<Scalars['Json']['input']>>>;
  sales_channel_id?: InputMaybe<Scalars['Int']['input']>;
  sales_contact?: InputMaybe<Array<Scalars['Json']['input']>>;
  sales_type?: InputMaybe<Scalars['String']['input']>;
  shipping_cost?: InputMaybe<Scalars['Float']['input']>;
  sub_status?: InputMaybe<Scalars['String']['input']>;
  tag_id_list?: InputMaybe<Array<Scalars['Int']['input']>>;
  template_remark_id?: InputMaybe<Scalars['String']['input']>;
  total_amount?: InputMaybe<Scalars['Float']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
  vat_0_percent_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_7_percent_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_exempted_amount?: InputMaybe<Scalars['Float']['input']>;
  withholding_tax_amount?: InputMaybe<Scalars['Float']['input']>;
};

export type QuotationView = {
  __typename?: 'QuotationView';
  branch_id?: Maybe<Scalars['Int']['output']>;
  branch_name?: Maybe<Scalars['String']['output']>;
  branch_unique_id?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  created_by_object?: Maybe<Scalars['Json']['output']>;
  created_by_unique_id?: Maybe<Scalars['String']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  customer_name?: Maybe<Scalars['String']['output']>;
  customer_unique_id?: Maybe<Scalars['String']['output']>;
  due_date?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  issue_date?: Maybe<Scalars['DateTime']['output']>;
  net_amount?: Maybe<Scalars['Float']['output']>;
  related_user_list?: Maybe<Array<Scalars['String']['output']>>;
  related_user_object_list?: Maybe<Array<Scalars['Json']['output']>>;
  related_user_unique_id_list?: Maybe<Array<Scalars['String']['output']>>;
  sales_channel?: Maybe<Scalars['String']['output']>;
  sales_channel_id?: Maybe<Scalars['Int']['output']>;
  sales_type?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tag_list?: Maybe<Array<Scalars['String']['output']>>;
  unique_id: Scalars['String']['output'];
};

export type QuotationViewAggridOutput = {
  __typename?: 'QuotationViewAggridOutput';
  count?: Maybe<Scalars['Int']['output']>;
  results: Array<QuotationView>;
};

export enum ReceiveType {
  Amount = 'amount',
  Percent = 'percent'
}

export type ReferencePurchaseLineItem = {
  __typename?: 'ReferencePurchaseLineItem';
  line_item_document_type: Scalars['String']['output'];
  line_item_document_unique_id: Scalars['String']['output'];
  line_item_unique_id: Scalars['String']['output'];
};

export type ReferencePurchaseLineItemInput = {
  line_item_document_type: Scalars['String']['input'];
  line_item_document_unique_id: Scalars['String']['input'];
  line_item_unique_id: Scalars['String']['input'];
};

export type ReferenceSalesDocument = {
  __typename?: 'ReferenceSalesDocument';
  document_id?: Maybe<Scalars['Int']['output']>;
  document_type?: Maybe<SalesReferenceDocumentType>;
  document_unique_id?: Maybe<Scalars['String']['output']>;
};

export type ReferenceSalesDocumentInput = {
  document_id?: InputMaybe<Scalars['Int']['input']>;
  document_type?: InputMaybe<SalesReferenceDocumentType>;
  document_unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type ReferenceSalesLineItem = {
  __typename?: 'ReferenceSalesLineItem';
  line_item_document_type: Scalars['String']['output'];
  line_item_unique_id: Scalars['String']['output'];
};

export type ReferenceSalesLineItemInput = {
  line_item_document_type: Scalars['String']['input'];
  line_item_unique_id: Scalars['String']['input'];
};

export type RolePermission = {
  __typename?: 'RolePermission';
  approval?: Maybe<AccessPermission>;
  branch?: Maybe<AccessPermission>;
  cash_sales?: Maybe<AccessPermission>;
  company?: Maybe<AccessPermission>;
  contact?: Maybe<AccessPermission>;
  contact_export?: Maybe<AccessPermission>;
  contact_setting?: Maybe<AccessPermission>;
  customer?: Maybe<AccessPermission>;
  customer_deposit?: Maybe<AccessPermission>;
  delivery_order?: Maybe<AccessPermission>;
  employee?: Maybe<AccessPermission>;
  goods_adjust?: Maybe<AccessPermission>;
  goods_issue?: Maybe<AccessPermission>;
  goods_receive?: Maybe<AccessPermission>;
  goods_return?: Maybe<AccessPermission>;
  goods_transfer?: Maybe<AccessPermission>;
  inventory?: Maybe<AccessPermission>;
  inventory_export?: Maybe<AccessPermission>;
  inventory_report?: Maybe<AccessPermission>;
  inventory_setting?: Maybe<AccessPermission>;
  item?: Maybe<AccessPermission>;
  logistic?: Maybe<AccessPermission>;
  logistic_export?: Maybe<AccessPermission>;
  logistic_report?: Maybe<AccessPermission>;
  logistic_setting?: Maybe<AccessPermission>;
  marketing?: Maybe<AccessPermission>;
  marketing_export?: Maybe<AccessPermission>;
  price_list?: Maybe<AccessPermission>;
  promotion?: Maybe<AccessPermission>;
  purchase?: Maybe<AccessPermission>;
  purchase_export?: Maybe<AccessPermission>;
  purchase_order?: Maybe<AccessPermission>;
  purchase_report?: Maybe<AccessPermission>;
  purchase_request?: Maybe<AccessPermission>;
  purchase_return?: Maybe<AccessPermission>;
  quotation?: Maybe<AccessPermission>;
  role?: Maybe<AccessPermission>;
  sales?: Maybe<AccessPermission>;
  sales_export?: Maybe<AccessPermission>;
  sales_invoice?: Maybe<AccessPermission>;
  sales_order?: Maybe<AccessPermission>;
  sales_report?: Maybe<AccessPermission>;
  sales_return?: Maybe<AccessPermission>;
  sales_setting?: Maybe<AccessPermission>;
  setting?: Maybe<AccessPermission>;
  user_account?: Maybe<AccessPermission>;
  user_export?: Maybe<AccessPermission>;
  vendor?: Maybe<AccessPermission>;
  zone?: Maybe<AccessPermission>;
};

export type RolePermissionInput = {
  approval?: InputMaybe<AccessPermissionInput>;
  branch?: InputMaybe<AccessPermissionInput>;
  cash_sales?: InputMaybe<AccessPermissionInput>;
  company?: InputMaybe<AccessPermissionInput>;
  contact?: InputMaybe<AccessPermissionInput>;
  contact_export?: InputMaybe<AccessPermissionInput>;
  contact_setting?: InputMaybe<AccessPermissionInput>;
  customer?: InputMaybe<AccessPermissionInput>;
  customer_deposit?: InputMaybe<AccessPermissionInput>;
  delivery_order?: InputMaybe<AccessPermissionInput>;
  employee?: InputMaybe<AccessPermissionInput>;
  goods_adjust?: InputMaybe<AccessPermissionInput>;
  goods_issue?: InputMaybe<AccessPermissionInput>;
  goods_receive?: InputMaybe<AccessPermissionInput>;
  goods_return?: InputMaybe<AccessPermissionInput>;
  goods_transfer?: InputMaybe<AccessPermissionInput>;
  inventory?: InputMaybe<AccessPermissionInput>;
  inventory_export?: InputMaybe<AccessPermissionInput>;
  inventory_report?: InputMaybe<AccessPermissionInput>;
  inventory_setting?: InputMaybe<AccessPermissionInput>;
  item?: InputMaybe<AccessPermissionInput>;
  logistic?: InputMaybe<AccessPermissionInput>;
  logistic_export?: InputMaybe<AccessPermissionInput>;
  logistic_report?: InputMaybe<AccessPermissionInput>;
  logistic_setting?: InputMaybe<AccessPermissionInput>;
  marketing?: InputMaybe<AccessPermissionInput>;
  marketing_export?: InputMaybe<AccessPermissionInput>;
  price_list?: InputMaybe<AccessPermissionInput>;
  promotion?: InputMaybe<AccessPermissionInput>;
  purchase?: InputMaybe<AccessPermissionInput>;
  purchase_export?: InputMaybe<AccessPermissionInput>;
  purchase_order?: InputMaybe<AccessPermissionInput>;
  purchase_report?: InputMaybe<AccessPermissionInput>;
  purchase_request?: InputMaybe<AccessPermissionInput>;
  purchase_return?: InputMaybe<AccessPermissionInput>;
  quotation?: InputMaybe<AccessPermissionInput>;
  role?: InputMaybe<AccessPermissionInput>;
  sales?: InputMaybe<AccessPermissionInput>;
  sales_export?: InputMaybe<AccessPermissionInput>;
  sales_invoice?: InputMaybe<AccessPermissionInput>;
  sales_order?: InputMaybe<AccessPermissionInput>;
  sales_report?: InputMaybe<AccessPermissionInput>;
  sales_return?: InputMaybe<AccessPermissionInput>;
  sales_setting?: InputMaybe<AccessPermissionInput>;
  setting?: InputMaybe<AccessPermissionInput>;
  user_account?: InputMaybe<AccessPermissionInput>;
  user_export?: InputMaybe<AccessPermissionInput>;
  vendor?: InputMaybe<AccessPermissionInput>;
  zone?: InputMaybe<AccessPermissionInput>;
};

export type SalesByCustomerExportView = {
  __typename?: 'SalesByCustomerExportView';
  additional_discount?: Maybe<Scalars['Float']['output']>;
  customer_id: Scalars['String']['output'];
  customer_name?: Maybe<Scalars['String']['output']>;
  document_type?: Maybe<Scalars['String']['output']>;
  item_discount?: Maybe<Scalars['Float']['output']>;
  item_pre_discount_amount?: Maybe<Scalars['Float']['output']>;
  net_amount?: Maybe<Scalars['Float']['output']>;
  post_discount_amount?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
  total_document?: Maybe<Scalars['Int']['output']>;
  vat_amount?: Maybe<Scalars['Float']['output']>;
  withholding_tax_amount?: Maybe<Scalars['Float']['output']>;
};

export type SalesByCustomerExportViewAggridOutput = {
  __typename?: 'SalesByCustomerExportViewAggridOutput';
  count?: Maybe<Scalars['Int']['output']>;
  results: Array<SalesByCustomerExportView>;
};

export type SalesChannel = {
  __typename?: 'SalesChannel';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  item_price_list?: Maybe<Array<Maybe<ItemPriceList>>>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  name_en: Scalars['String']['output'];
  name_th: Scalars['String']['output'];
  quotation_list?: Maybe<Array<Maybe<Quotation>>>;
  unique_id: Scalars['String']['output'];
};

export enum SalesChannelType {
  All = 'all',
  SpecificChannels = 'specific_channels',
  SpecificSales = 'specific_sales'
}

export type SalesDeduction = {
  __typename?: 'SalesDeduction';
  branch_id: Scalars['Int']['output'];
  credit_balance?: Maybe<Scalars['Float']['output']>;
  deduction_amount?: Maybe<Scalars['Float']['output']>;
  deduction_issue_date?: Maybe<Scalars['DateTime']['output']>;
  document_type?: Maybe<Scalars['String']['output']>;
  document_unique_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  reference_document_type: SalesReferenceDocumentType;
  reference_unique_id: Scalars['String']['output'];
  remark?: Maybe<Scalars['String']['output']>;
};

export type SalesDeductionCreateInput = {
  branch_id: Scalars['Int']['input'];
  credit_balance?: InputMaybe<Scalars['Float']['input']>;
  deduction_amount?: InputMaybe<Scalars['Float']['input']>;
  deduction_issue_date?: InputMaybe<Scalars['DateTime']['input']>;
  document_type?: InputMaybe<Scalars['String']['input']>;
  document_unique_id?: InputMaybe<Scalars['String']['input']>;
  reference_document_type: SalesReferenceDocumentType;
  reference_unique_id: Scalars['String']['input'];
  remark?: InputMaybe<Scalars['String']['input']>;
};

export type SalesDeductionExportView = {
  __typename?: 'SalesDeductionExportView';
  branch_id?: Maybe<Scalars['String']['output']>;
  branch_name?: Maybe<Scalars['String']['output']>;
  deduction_amount?: Maybe<Scalars['Float']['output']>;
  deposit_type?: Maybe<Scalars['String']['output']>;
  deposit_unique_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  issue_date?: Maybe<Scalars['DateTime']['output']>;
  reference_document_id?: Maybe<Scalars['String']['output']>;
  reference_document_type?: Maybe<Scalars['String']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
};

export type SalesDeductionUpsertInput = {
  branch_id: Scalars['Int']['input'];
  credit_balance?: InputMaybe<Scalars['Float']['input']>;
  deduction_amount?: InputMaybe<Scalars['Float']['input']>;
  deduction_issue_date?: InputMaybe<Scalars['DateTime']['input']>;
  document_type?: InputMaybe<Scalars['String']['input']>;
  document_unique_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  reference_document_type: SalesReferenceDocumentType;
  reference_unique_id: Scalars['String']['input'];
  remark?: InputMaybe<Scalars['String']['input']>;
};

export enum SalesExportType {
  CashSales = 'cash_sales',
  CashSalesDeduction = 'cash_sales_deduction',
  CashSalesPayment = 'cash_sales_payment',
  CustomerDeposit = 'customer_deposit',
  CustomerDepositPayment = 'customer_deposit_payment',
  Deduction = 'deduction',
  Payment = 'payment',
  Quotation = 'quotation',
  SalesByCustomer = 'sales_by_customer',
  SalesInvoice = 'sales_invoice',
  SalesInvoiceDeduction = 'sales_invoice_deduction',
  SalesInvoicePayment = 'sales_invoice_payment',
  SalesItem = 'sales_item',
  SalesItemByBranch = 'sales_item_by_branch',
  SalesOrder = 'sales_order',
  SalesReturn = 'sales_return'
}

export type SalesInvoice = {
  __typename?: 'SalesInvoice';
  additional_discount?: Maybe<Scalars['Float']['output']>;
  additional_discount_type?: Maybe<AdditionalDiscountType>;
  aggrid_status?: Maybe<Scalars['String']['output']>;
  approval_step?: Maybe<Scalars['Int']['output']>;
  approver_list?: Maybe<Array<Scalars['Json']['output']>>;
  branch?: Maybe<Branch>;
  branch_id: Scalars['Int']['output'];
  contact_person_list?: Maybe<Array<Scalars['Json']['output']>>;
  created_by: Scalars['Json']['output'];
  created_date: Scalars['DateTime']['output'];
  credit_day?: Maybe<Scalars['Int']['output']>;
  currency: Scalars['String']['output'];
  customer_details: Scalars['Json']['output'];
  customer_unique_id: Scalars['String']['output'];
  deduction_document_list?: Maybe<Array<SalesDeduction>>;
  deduction_total_amount?: Maybe<Scalars['Float']['output']>;
  due_date: Scalars['DateTime']['output'];
  external_reference_no?: Maybe<Scalars['String']['output']>;
  flag_status?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['Int']['output'];
  is_original_print?: Maybe<Scalars['Json']['output']>;
  issue_date: Scalars['DateTime']['output'];
  item_list?: Maybe<Array<SalesItem>>;
  item_price_list?: Maybe<ItemPriceList>;
  item_price_list_id?: Maybe<Scalars['Int']['output']>;
  last_updated_by?: Maybe<Scalars['Json']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  main_status?: Maybe<Scalars['String']['output']>;
  need_tax_invoice?: Maybe<Scalars['Boolean']['output']>;
  net_amount?: Maybe<Scalars['Float']['output']>;
  paid_net_amount?: Maybe<Scalars['Float']['output']>;
  paid_total_amount?: Maybe<Scalars['Float']['output']>;
  payment_list?: Maybe<Array<SalesPayment>>;
  payment_total_amount?: Maybe<Scalars['Float']['output']>;
  post_discount_amount?: Maybe<Scalars['Float']['output']>;
  pre_vat_amount?: Maybe<Scalars['Float']['output']>;
  price_vat_type: PriceVatType;
  reference_document_list?: Maybe<Array<Scalars['Json']['output']>>;
  reference_no?: Maybe<Scalars['String']['output']>;
  related_user_list?: Maybe<Array<Scalars['Json']['output']>>;
  remark?: Maybe<Scalars['String']['output']>;
  reviewer_list?: Maybe<Array<Scalars['Json']['output']>>;
  sales_channel?: Maybe<SalesChannel>;
  sales_channel_id?: Maybe<Scalars['Int']['output']>;
  sales_contact?: Maybe<Array<Scalars['Json']['output']>>;
  sales_type?: Maybe<Scalars['String']['output']>;
  sub_status?: Maybe<Scalars['String']['output']>;
  tag_id_list?: Maybe<Array<Scalars['Int']['output']>>;
  tag_list?: Maybe<Array<Tag>>;
  tax_invoice_date?: Maybe<Scalars['DateTime']['output']>;
  tax_invoice_no?: Maybe<Scalars['String']['output']>;
  template_remark_id?: Maybe<Scalars['String']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
  unique_id: Scalars['String']['output'];
  vat_0_percent_amount?: Maybe<Scalars['Float']['output']>;
  vat_7_percent_amount?: Maybe<Scalars['Float']['output']>;
  vat_amount?: Maybe<Scalars['Float']['output']>;
  vat_exempted_amount?: Maybe<Scalars['Float']['output']>;
  withholding_tax_amount?: Maybe<Scalars['Float']['output']>;
};

export type SalesInvoiceAggridOutput = {
  __typename?: 'SalesInvoiceAggridOutput';
  count?: Maybe<Scalars['Int']['output']>;
  results: Array<SalesInvoice>;
};

export type SalesInvoiceCreateInput = {
  additional_discount?: InputMaybe<Scalars['Float']['input']>;
  additional_discount_type?: InputMaybe<AdditionalDiscountType>;
  aggrid_status?: InputMaybe<Scalars['String']['input']>;
  approval_step?: InputMaybe<Scalars['Int']['input']>;
  approver_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  branch_id: Scalars['Int']['input'];
  contact_person_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  created_by: Scalars['Json']['input'];
  credit_day?: InputMaybe<Scalars['Int']['input']>;
  currency: Scalars['String']['input'];
  customer_details: Scalars['Json']['input'];
  customer_unique_id: Scalars['String']['input'];
  deduction_document_list?: InputMaybe<Array<SalesDeductionCreateInput>>;
  deduction_total_amount?: InputMaybe<Scalars['Float']['input']>;
  due_date: Scalars['DateTime']['input'];
  external_reference_no?: InputMaybe<Scalars['String']['input']>;
  flag_status?: InputMaybe<Array<Scalars['String']['input']>>;
  is_original_print?: InputMaybe<Scalars['Json']['input']>;
  issue_date: Scalars['DateTime']['input'];
  item_list?: InputMaybe<Array<SalesItemCreateInput>>;
  item_price_list_id?: InputMaybe<Scalars['Int']['input']>;
  last_updated_by?: InputMaybe<Scalars['Json']['input']>;
  main_status?: InputMaybe<Scalars['String']['input']>;
  need_tax_invoice?: InputMaybe<Scalars['Boolean']['input']>;
  net_amount?: InputMaybe<Scalars['Float']['input']>;
  paid_net_amount?: InputMaybe<Scalars['Float']['input']>;
  paid_total_amount?: InputMaybe<Scalars['Float']['input']>;
  payment_list?: InputMaybe<Array<SalesPaymentCreateInput>>;
  payment_total_amount?: InputMaybe<Scalars['Float']['input']>;
  post_discount_amount?: InputMaybe<Scalars['Float']['input']>;
  pre_vat_amount?: InputMaybe<Scalars['Float']['input']>;
  price_vat_type: PriceVatType;
  reference_document_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  reference_no?: InputMaybe<Scalars['String']['input']>;
  related_user_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  remark?: InputMaybe<Scalars['String']['input']>;
  reviewer_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  sales_channel_id?: InputMaybe<Scalars['Int']['input']>;
  sales_contact?: InputMaybe<Array<Scalars['Json']['input']>>;
  sales_type?: InputMaybe<Scalars['String']['input']>;
  sub_status?: InputMaybe<Scalars['String']['input']>;
  tag_id_list?: InputMaybe<Array<Scalars['Int']['input']>>;
  tax_invoice_date?: InputMaybe<Scalars['DateTime']['input']>;
  tax_invoice_no?: InputMaybe<Scalars['String']['input']>;
  template_remark_id?: InputMaybe<Scalars['String']['input']>;
  total_amount?: InputMaybe<Scalars['Float']['input']>;
  unique_id: Scalars['String']['input'];
  vat_0_percent_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_7_percent_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_exempted_amount?: InputMaybe<Scalars['Float']['input']>;
  withholding_tax_amount?: InputMaybe<Scalars['Float']['input']>;
};

export type SalesInvoiceExportView = {
  __typename?: 'SalesInvoiceExportView';
  additional_discount?: Maybe<Scalars['Float']['output']>;
  billing_address?: Maybe<Scalars['String']['output']>;
  billing_address_country?: Maybe<Scalars['String']['output']>;
  billing_address_district?: Maybe<Scalars['String']['output']>;
  billing_address_postal_code?: Maybe<Scalars['String']['output']>;
  billing_address_province?: Maybe<Scalars['String']['output']>;
  billing_address_sub_district?: Maybe<Scalars['String']['output']>;
  branch_name: Scalars['String']['output'];
  branch_unique_id: Scalars['String']['output'];
  created_by?: Maybe<Scalars['String']['output']>;
  created_date: Scalars['DateTime']['output'];
  credit_day?: Maybe<Scalars['Int']['output']>;
  currency: Scalars['String']['output'];
  customer_email?: Maybe<Scalars['String']['output']>;
  customer_fax?: Maybe<Scalars['String']['output']>;
  customer_name?: Maybe<Scalars['String']['output']>;
  customer_phone?: Maybe<Scalars['String']['output']>;
  customer_unique_id?: Maybe<Scalars['String']['output']>;
  deduction_issue_date?: Maybe<Scalars['DateTime']['output']>;
  deduction_total_amount?: Maybe<Scalars['Float']['output']>;
  delivery_address?: Maybe<Scalars['String']['output']>;
  delivery_address_contact_name?: Maybe<Scalars['String']['output']>;
  delivery_address_contact_phone?: Maybe<Scalars['String']['output']>;
  delivery_address_country?: Maybe<Scalars['String']['output']>;
  delivery_address_district?: Maybe<Scalars['String']['output']>;
  delivery_address_postal_code?: Maybe<Scalars['String']['output']>;
  delivery_address_province?: Maybe<Scalars['String']['output']>;
  delivery_address_sub_district?: Maybe<Scalars['String']['output']>;
  due_date: Scalars['DateTime']['output'];
  external_reference_no?: Maybe<Scalars['String']['output']>;
  issue_date: Scalars['DateTime']['output'];
  item_additional_discount?: Maybe<Scalars['Float']['output']>;
  item_discount?: Maybe<Scalars['Float']['output']>;
  item_name?: Maybe<Scalars['String']['output']>;
  item_net_amount?: Maybe<Scalars['Float']['output']>;
  item_pre_discount_amount?: Maybe<Scalars['Float']['output']>;
  item_pre_vat_amount?: Maybe<Scalars['Float']['output']>;
  item_price_list?: Maybe<Scalars['String']['output']>;
  item_price_per_unit?: Maybe<Scalars['Float']['output']>;
  item_qty: Scalars['Float']['output'];
  item_remark?: Maybe<Scalars['String']['output']>;
  item_sku_desc?: Maybe<Scalars['String']['output']>;
  item_stock_qty?: Maybe<Scalars['Float']['output']>;
  item_total_amount?: Maybe<Scalars['Float']['output']>;
  item_unique_id: Scalars['String']['output'];
  item_uom?: Maybe<Scalars['String']['output']>;
  item_vat_0_percent_amount?: Maybe<Scalars['Float']['output']>;
  item_vat_7_percent_amount?: Maybe<Scalars['Float']['output']>;
  item_vat_amount?: Maybe<Scalars['Float']['output']>;
  item_vat_exempted_amount?: Maybe<Scalars['Float']['output']>;
  item_vat_percentage?: Maybe<Scalars['String']['output']>;
  item_withholding_tax_type?: Maybe<Scalars['String']['output']>;
  item_withholding_tax_value?: Maybe<Scalars['Float']['output']>;
  last_payment_date?: Maybe<Scalars['DateTime']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  payment_total_amount?: Maybe<Scalars['Float']['output']>;
  price_vat_type: Scalars['String']['output'];
  reference_document: Array<Scalars['String']['output']>;
  reference_no?: Maybe<Scalars['String']['output']>;
  related_user_list: Array<Scalars['String']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  sales_channel?: Maybe<Scalars['String']['output']>;
  sales_type?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tag_list: Array<Scalars['String']['output']>;
  tax_invoice_date?: Maybe<Scalars['DateTime']['output']>;
  tax_invoice_no?: Maybe<Scalars['String']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
  unique_id: Scalars['String']['output'];
};

export type SalesInvoiceUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type SalesInvoiceUpdateInput = {
  additional_discount?: InputMaybe<Scalars['Float']['input']>;
  additional_discount_type?: InputMaybe<AdditionalDiscountType>;
  aggrid_status?: InputMaybe<Scalars['String']['input']>;
  approval_step?: InputMaybe<Scalars['Int']['input']>;
  approver_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  branch_id?: InputMaybe<Scalars['Int']['input']>;
  contact_person_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  credit_day?: InputMaybe<Scalars['Int']['input']>;
  currency: Scalars['String']['input'];
  customer_details?: InputMaybe<Scalars['Json']['input']>;
  customer_unique_id?: InputMaybe<Scalars['String']['input']>;
  deduction_document_list?: InputMaybe<Array<SalesDeductionUpsertInput>>;
  deduction_total_amount?: InputMaybe<Scalars['Float']['input']>;
  due_date?: InputMaybe<Scalars['DateTime']['input']>;
  external_reference_no?: InputMaybe<Scalars['String']['input']>;
  flag_status?: InputMaybe<Array<Scalars['String']['input']>>;
  is_original_print?: InputMaybe<Scalars['Json']['input']>;
  issue_date?: InputMaybe<Scalars['DateTime']['input']>;
  item_list?: InputMaybe<Array<SalesItemUpsertInput>>;
  item_price_list_id?: InputMaybe<Scalars['Int']['input']>;
  last_updated_by?: InputMaybe<Scalars['Json']['input']>;
  main_status?: InputMaybe<Scalars['String']['input']>;
  need_tax_invoice?: InputMaybe<Scalars['Boolean']['input']>;
  net_amount?: InputMaybe<Scalars['Float']['input']>;
  paid_net_amount?: InputMaybe<Scalars['Float']['input']>;
  paid_total_amount?: InputMaybe<Scalars['Float']['input']>;
  payment_list?: InputMaybe<Array<SalesPaymentUpsertInput>>;
  payment_total_amount?: InputMaybe<Scalars['Float']['input']>;
  post_discount_amount?: InputMaybe<Scalars['Float']['input']>;
  pre_vat_amount?: InputMaybe<Scalars['Float']['input']>;
  price_vat_type: PriceVatType;
  reference_document_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  reference_no?: InputMaybe<Scalars['String']['input']>;
  related_user_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  remark?: InputMaybe<Scalars['String']['input']>;
  reviewer_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  sales_channel_id?: InputMaybe<Scalars['Int']['input']>;
  sales_contact?: InputMaybe<Array<Scalars['Json']['input']>>;
  sales_type?: InputMaybe<Scalars['String']['input']>;
  sub_status?: InputMaybe<Scalars['String']['input']>;
  tag_id_list?: InputMaybe<Array<Scalars['Int']['input']>>;
  tax_invoice_date?: InputMaybe<Scalars['DateTime']['input']>;
  tax_invoice_no?: InputMaybe<Scalars['String']['input']>;
  template_remark_id?: InputMaybe<Scalars['String']['input']>;
  total_amount?: InputMaybe<Scalars['Float']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
  vat_0_percent_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_7_percent_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_exempted_amount?: InputMaybe<Scalars['Float']['input']>;
  withholding_tax_amount?: InputMaybe<Scalars['Float']['input']>;
};

export type SalesInvoiceView = {
  __typename?: 'SalesInvoiceView';
  branch_id?: Maybe<Scalars['Int']['output']>;
  branch_name?: Maybe<Scalars['String']['output']>;
  branch_unique_id?: Maybe<Scalars['String']['output']>;
  cd_deduction_total_amount?: Maybe<Scalars['Float']['output']>;
  cd_last_deduction_date?: Maybe<Scalars['DateTime']['output']>;
  cd_unique_id_list?: Maybe<Array<Scalars['String']['output']>>;
  created_by?: Maybe<Scalars['String']['output']>;
  created_by_object?: Maybe<Scalars['Json']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  customer_name?: Maybe<Scalars['String']['output']>;
  customer_unique_id?: Maybe<Scalars['String']['output']>;
  due_date?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  issue_date?: Maybe<Scalars['DateTime']['output']>;
  net_amount?: Maybe<Scalars['Float']['output']>;
  paid_total_amount?: Maybe<Scalars['Float']['output']>;
  reference_id?: Maybe<Scalars['Int']['output']>;
  reference_unique_id?: Maybe<Scalars['String']['output']>;
  related_user_list?: Maybe<Array<Scalars['String']['output']>>;
  related_user_object_list?: Maybe<Array<Scalars['Json']['output']>>;
  sales_channel?: Maybe<Scalars['String']['output']>;
  sales_channel_id?: Maybe<Scalars['Int']['output']>;
  sales_type?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tag_list?: Maybe<Array<Scalars['String']['output']>>;
  tax_invoice_no?: Maybe<Scalars['String']['output']>;
  unique_id: Scalars['String']['output'];
};

export type SalesInvoiceViewAggridOutput = {
  __typename?: 'SalesInvoiceViewAggridOutput';
  count?: Maybe<Scalars['Int']['output']>;
  results: Array<SalesInvoiceView>;
};

export type SalesItem = {
  __typename?: 'SalesItem';
  applied_preorder_quota_setting_id?: Maybe<Scalars['Int']['output']>;
  barcode?: Maybe<Scalars['String']['output']>;
  branch_id: Scalars['Int']['output'];
  discount?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  item_id?: Maybe<Scalars['Int']['output']>;
  item_img_url?: Maybe<Array<Scalars['String']['output']>>;
  item_name?: Maybe<Scalars['String']['output']>;
  item_sku_desc?: Maybe<Scalars['String']['output']>;
  item_sku_name: Scalars['String']['output'];
  item_unique_id: Scalars['String']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  pre_vat_amount?: Maybe<Scalars['Float']['output']>;
  price_per_unit?: Maybe<Scalars['Float']['output']>;
  promotion_discount?: Maybe<Scalars['Float']['output']>;
  qty: Scalars['Float']['output'];
  qty_invoiced?: Maybe<Scalars['Float']['output']>;
  qty_issued?: Maybe<Scalars['Float']['output']>;
  qty_received?: Maybe<Scalars['Float']['output']>;
  qty_returned?: Maybe<Scalars['Float']['output']>;
  qty_shipped?: Maybe<Scalars['Float']['output']>;
  qty_to_ship?: Maybe<Scalars['Float']['output']>;
  reference_document_type: SalesReferenceDocumentType;
  reference_line_item?: Maybe<ReferenceSalesLineItem>;
  reference_unique_id: Scalars['String']['output'];
  remark?: Maybe<Scalars['String']['output']>;
  so_qty?: Maybe<Scalars['Float']['output']>;
  stock_qty?: Maybe<Scalars['Float']['output']>;
  tracability: TraceAbilityEnum;
  unique_id: Scalars['String']['output'];
  uom_id?: Maybe<Scalars['Int']['output']>;
  uom_name?: Maybe<Scalars['String']['output']>;
  vat_percentage?: Maybe<Scalars['String']['output']>;
  volume: Scalars['Float']['output'];
  weight: Scalars['Float']['output'];
  withholding_tax_type?: Maybe<Scalars['String']['output']>;
  withholding_tax_value?: Maybe<Scalars['Float']['output']>;
};

export type SalesItemByBranchExportView = {
  __typename?: 'SalesItemByBranchExportView';
  branch_id: Scalars['String']['output'];
  branch_name?: Maybe<Scalars['String']['output']>;
  item_additional_discount?: Maybe<Scalars['Float']['output']>;
  item_discount?: Maybe<Scalars['Float']['output']>;
  item_name?: Maybe<Scalars['String']['output']>;
  item_net_amount?: Maybe<Scalars['Float']['output']>;
  item_pre_discount_amount?: Maybe<Scalars['Float']['output']>;
  item_qty_invoiced?: Maybe<Scalars['Float']['output']>;
  item_qty_returned?: Maybe<Scalars['Float']['output']>;
  item_qty_shipped?: Maybe<Scalars['Float']['output']>;
  item_qty_to_ship?: Maybe<Scalars['Float']['output']>;
  item_vat_amount?: Maybe<Scalars['Float']['output']>;
  item_withholding_tax_amount?: Maybe<Scalars['Float']['output']>;
  post_discount_amount?: Maybe<Scalars['Float']['output']>;
  qty?: Maybe<Scalars['Float']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
  unique_id: Scalars['String']['output'];
  uom_name?: Maybe<Scalars['String']['output']>;
};

export type SalesItemByBranchExportViewAggridOutput = {
  __typename?: 'SalesItemByBranchExportViewAggridOutput';
  count?: Maybe<Scalars['Int']['output']>;
  results: Array<SalesItemByBranchExportView>;
};

export type SalesItemCreateInput = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  branch_id: Scalars['Int']['input'];
  discount?: InputMaybe<Scalars['Float']['input']>;
  item_id?: InputMaybe<Scalars['Int']['input']>;
  item_img_url?: InputMaybe<Array<Scalars['String']['input']>>;
  item_name?: InputMaybe<Scalars['String']['input']>;
  item_sku_desc?: InputMaybe<Scalars['String']['input']>;
  item_sku_name: Scalars['String']['input'];
  item_unique_id: Scalars['String']['input'];
  pre_vat_amount?: InputMaybe<Scalars['Float']['input']>;
  price_per_unit?: InputMaybe<Scalars['Float']['input']>;
  promotion_discount?: InputMaybe<Scalars['Float']['input']>;
  qty: Scalars['Float']['input'];
  qty_invoiced?: InputMaybe<Scalars['Float']['input']>;
  qty_issued?: InputMaybe<Scalars['Float']['input']>;
  qty_received?: InputMaybe<Scalars['Float']['input']>;
  qty_returned?: InputMaybe<Scalars['Float']['input']>;
  qty_shipped?: InputMaybe<Scalars['Float']['input']>;
  qty_to_ship?: InputMaybe<Scalars['Float']['input']>;
  reference_document_type: SalesReferenceDocumentType;
  reference_line_item?: InputMaybe<ReferenceSalesLineItemInput>;
  reference_unique_id: Scalars['String']['input'];
  remark?: InputMaybe<Scalars['String']['input']>;
  so_qty?: InputMaybe<Scalars['Float']['input']>;
  stock_qty?: InputMaybe<Scalars['Float']['input']>;
  tracability: TraceAbilityEnum;
  unique_id: Scalars['String']['input'];
  uom_id?: InputMaybe<Scalars['Int']['input']>;
  uom_name?: InputMaybe<Scalars['String']['input']>;
  vat_percentage?: InputMaybe<Scalars['String']['input']>;
  volume: Scalars['Float']['input'];
  weight: Scalars['Float']['input'];
  withholding_tax_type?: InputMaybe<Scalars['String']['input']>;
  withholding_tax_value?: InputMaybe<Scalars['Float']['input']>;
};

export type SalesItemExportView = {
  __typename?: 'SalesItemExportView';
  item_additional_discount?: Maybe<Scalars['Float']['output']>;
  item_discount?: Maybe<Scalars['Float']['output']>;
  item_name?: Maybe<Scalars['String']['output']>;
  item_net_amount?: Maybe<Scalars['Float']['output']>;
  item_pre_discount_amount?: Maybe<Scalars['Float']['output']>;
  item_qty_invoiced?: Maybe<Scalars['Float']['output']>;
  item_qty_returned?: Maybe<Scalars['Float']['output']>;
  item_qty_shipped?: Maybe<Scalars['Float']['output']>;
  item_qty_to_ship?: Maybe<Scalars['Float']['output']>;
  item_vat_amount?: Maybe<Scalars['Float']['output']>;
  item_withholding_tax_amount?: Maybe<Scalars['Float']['output']>;
  post_discount_amount?: Maybe<Scalars['Float']['output']>;
  qty?: Maybe<Scalars['Float']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
  unique_id: Scalars['String']['output'];
  uom_name?: Maybe<Scalars['String']['output']>;
};

export type SalesItemExportViewAggridOutput = {
  __typename?: 'SalesItemExportViewAggridOutput';
  count?: Maybe<Scalars['Int']['output']>;
  results: Array<SalesItemExportView>;
};

export type SalesItemFindManyByLineItemInput = {
  line_item_document_type: Scalars['String']['input'];
  line_item_unique_id: Scalars['String']['input'];
};

export type SalesItemFindManyInput = {
  reference_document_type?: InputMaybe<SalesReferenceDocumentType>;
  reference_line_item?: InputMaybe<SalesItemFindManyByLineItemInput>;
  reference_unique_id?: InputMaybe<Scalars['String']['input']>;
  unique_id_list?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SalesItemUniqueInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type SalesItemUpsertInput = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  branch_id: Scalars['Int']['input'];
  discount?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  item_id?: InputMaybe<Scalars['Int']['input']>;
  item_img_url?: InputMaybe<Array<Scalars['String']['input']>>;
  item_name?: InputMaybe<Scalars['String']['input']>;
  item_sku_desc?: InputMaybe<Scalars['String']['input']>;
  item_sku_name: Scalars['String']['input'];
  item_unique_id: Scalars['String']['input'];
  pre_vat_amount?: InputMaybe<Scalars['Float']['input']>;
  price_per_unit?: InputMaybe<Scalars['Float']['input']>;
  promotion_discount?: InputMaybe<Scalars['Float']['input']>;
  qty: Scalars['Float']['input'];
  qty_invoiced?: InputMaybe<Scalars['Float']['input']>;
  qty_issued?: InputMaybe<Scalars['Float']['input']>;
  qty_received?: InputMaybe<Scalars['Float']['input']>;
  qty_returned?: InputMaybe<Scalars['Float']['input']>;
  qty_shipped?: InputMaybe<Scalars['Float']['input']>;
  qty_to_ship?: InputMaybe<Scalars['Float']['input']>;
  reference_document_type: SalesReferenceDocumentType;
  reference_line_item?: InputMaybe<ReferenceSalesLineItemInput>;
  reference_unique_id: Scalars['String']['input'];
  remark?: InputMaybe<Scalars['String']['input']>;
  so_qty?: InputMaybe<Scalars['Float']['input']>;
  stock_qty?: InputMaybe<Scalars['Float']['input']>;
  tracability: TraceAbilityEnum;
  unique_id: Scalars['String']['input'];
  uom_id?: InputMaybe<Scalars['Int']['input']>;
  uom_name?: InputMaybe<Scalars['String']['input']>;
  vat_percentage?: InputMaybe<Scalars['String']['input']>;
  volume: Scalars['Float']['input'];
  weight: Scalars['Float']['input'];
  withholding_tax_type?: InputMaybe<Scalars['String']['input']>;
  withholding_tax_value?: InputMaybe<Scalars['Float']['input']>;
};

export enum SalesModelType {
  CashSales = 'cash_sales',
  CashSalesTax = 'cash_sales_tax',
  CustomerDeposit = 'customer_deposit',
  CustomerDepositTax = 'customer_deposit_tax',
  Quotation = 'quotation',
  SalesInvoice = 'sales_invoice',
  SalesInvoiceTax = 'sales_invoice_tax',
  SalesOrder = 'sales_order',
  SalesReturn = 'sales_return'
}

export type SalesOrder = {
  __typename?: 'SalesOrder';
  account_id?: Maybe<Scalars['String']['output']>;
  additional_discount?: Maybe<Scalars['Float']['output']>;
  additional_discount_type?: Maybe<AdditionalDiscountType>;
  aggrid_status?: Maybe<Scalars['String']['output']>;
  approval_step?: Maybe<Scalars['Int']['output']>;
  approver_list?: Maybe<Array<Maybe<Scalars['Json']['output']>>>;
  branch: Branch;
  branch_id: Scalars['Int']['output'];
  contact_person_list?: Maybe<Array<Scalars['Json']['output']>>;
  created_by: Scalars['Json']['output'];
  created_date: Scalars['DateTime']['output'];
  credit_day?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customer_details?: Maybe<Scalars['Json']['output']>;
  customer_unique_id?: Maybe<Scalars['String']['output']>;
  delivery_date?: Maybe<Scalars['DateTime']['output']>;
  delivery_status?: Maybe<Scalars['String']['output']>;
  due_date?: Maybe<Scalars['DateTime']['output']>;
  external_reference_no?: Maybe<Scalars['String']['output']>;
  flag_status?: Maybe<Array<Scalars['String']['output']>>;
  good_issue_status?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  issue_date?: Maybe<Scalars['DateTime']['output']>;
  item_list?: Maybe<Array<SalesItem>>;
  item_price_list?: Maybe<ItemPriceList>;
  item_price_list_id?: Maybe<Scalars['Int']['output']>;
  last_updated_by?: Maybe<Scalars['Json']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  main_status?: Maybe<Scalars['String']['output']>;
  net_amount?: Maybe<Scalars['Float']['output']>;
  payments_receipt_status?: Maybe<Scalars['String']['output']>;
  post_discount_amount?: Maybe<Scalars['Float']['output']>;
  pre_vat_amount?: Maybe<Scalars['Float']['output']>;
  price_vat_type?: Maybe<PriceVatType>;
  reference_document_list?: Maybe<Array<Scalars['Json']['output']>>;
  reference_no?: Maybe<Scalars['String']['output']>;
  related_user_list?: Maybe<Array<Scalars['Json']['output']>>;
  remark?: Maybe<Scalars['String']['output']>;
  reviewer_list?: Maybe<Array<Maybe<Scalars['Json']['output']>>>;
  sales_channel?: Maybe<SalesChannel>;
  sales_channel_id?: Maybe<Scalars['Int']['output']>;
  sales_contact?: Maybe<Array<Scalars['Json']['output']>>;
  sales_invoice_status?: Maybe<Scalars['String']['output']>;
  sales_type?: Maybe<Scalars['String']['output']>;
  shipping_cost?: Maybe<Scalars['Float']['output']>;
  sub_status?: Maybe<Scalars['String']['output']>;
  tag_id_list?: Maybe<Array<Scalars['Int']['output']>>;
  tag_list?: Maybe<Array<Tag>>;
  template_remark_id?: Maybe<Scalars['String']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
  unique_id: Scalars['String']['output'];
  use_preorder_quota?: Maybe<Scalars['Boolean']['output']>;
  vat_0_percent_amount?: Maybe<Scalars['Float']['output']>;
  vat_7_percent_amount?: Maybe<Scalars['Float']['output']>;
  vat_amount?: Maybe<Scalars['Float']['output']>;
  vat_exempted_amount?: Maybe<Scalars['Float']['output']>;
  withholding_tax_amount?: Maybe<Scalars['Float']['output']>;
};

export type SalesOrderAggridOutput = {
  __typename?: 'SalesOrderAggridOutput';
  count?: Maybe<Scalars['Int']['output']>;
  results: Array<SalesOrder>;
};

export type SalesOrderCreateInput = {
  accepted_date?: InputMaybe<Scalars['DateTime']['input']>;
  accepted_remark?: InputMaybe<Scalars['String']['input']>;
  account_id?: InputMaybe<Scalars['String']['input']>;
  additional_discount?: InputMaybe<Scalars['Float']['input']>;
  additional_discount_type?: InputMaybe<AdditionalDiscountType>;
  aggrid_status?: InputMaybe<Scalars['String']['input']>;
  approval_step?: InputMaybe<Scalars['Int']['input']>;
  approver_list?: InputMaybe<Array<InputMaybe<Scalars['Json']['input']>>>;
  branch_id: Scalars['Int']['input'];
  contact_person_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  created_by: Scalars['Json']['input'];
  credit_day?: InputMaybe<Scalars['Int']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  customer_details?: InputMaybe<Scalars['Json']['input']>;
  customer_unique_id?: InputMaybe<Scalars['String']['input']>;
  delivery_date?: InputMaybe<Scalars['DateTime']['input']>;
  due_date?: InputMaybe<Scalars['DateTime']['input']>;
  external_reference_no?: InputMaybe<Scalars['String']['input']>;
  flag_status?: InputMaybe<Array<Scalars['String']['input']>>;
  issue_date?: InputMaybe<Scalars['DateTime']['input']>;
  item_list?: InputMaybe<Array<SalesItemCreateInput>>;
  item_price_list_id?: InputMaybe<Scalars['Int']['input']>;
  last_updated_by?: InputMaybe<Scalars['Json']['input']>;
  main_status?: InputMaybe<Scalars['String']['input']>;
  net_amount?: InputMaybe<Scalars['Float']['input']>;
  post_discount_amount?: InputMaybe<Scalars['Float']['input']>;
  pre_vat_amount?: InputMaybe<Scalars['Float']['input']>;
  price_vat_type?: InputMaybe<PriceVatType>;
  reference_document_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  reference_no?: InputMaybe<Scalars['String']['input']>;
  related_user_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  remark?: InputMaybe<Scalars['String']['input']>;
  reviewer_list?: InputMaybe<Array<InputMaybe<Scalars['Json']['input']>>>;
  sales_channel_id?: InputMaybe<Scalars['Int']['input']>;
  sales_contact?: InputMaybe<Array<Scalars['Json']['input']>>;
  sales_type?: InputMaybe<Scalars['String']['input']>;
  shipping_cost?: InputMaybe<Scalars['Float']['input']>;
  sub_status?: InputMaybe<Scalars['String']['input']>;
  tag_id_list?: InputMaybe<Array<Scalars['Int']['input']>>;
  template_remark_id?: InputMaybe<Scalars['String']['input']>;
  total_amount?: InputMaybe<Scalars['Float']['input']>;
  unique_id: Scalars['String']['input'];
  use_preorder_quota?: InputMaybe<Scalars['Boolean']['input']>;
  vat_0_percent_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_7_percent_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_exempted_amount?: InputMaybe<Scalars['Float']['input']>;
  withholding_tax_amount?: InputMaybe<Scalars['Float']['input']>;
};

export type SalesOrderSalesItemReportView = {
  __typename?: 'SalesOrderSalesItemReportView';
  additional_discount?: Maybe<Scalars['Float']['output']>;
  billing_address?: Maybe<Scalars['String']['output']>;
  billing_address_country?: Maybe<Scalars['String']['output']>;
  billing_address_district?: Maybe<Scalars['String']['output']>;
  billing_address_postal_code?: Maybe<Scalars['String']['output']>;
  billing_address_province?: Maybe<Scalars['String']['output']>;
  billing_address_sub_district?: Maybe<Scalars['String']['output']>;
  branch_name?: Maybe<Scalars['String']['output']>;
  branch_unique_id?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  credit_day?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customer_email?: Maybe<Scalars['String']['output']>;
  customer_fax?: Maybe<Scalars['String']['output']>;
  customer_name?: Maybe<Scalars['String']['output']>;
  customer_phone?: Maybe<Scalars['String']['output']>;
  customer_unique_id?: Maybe<Scalars['String']['output']>;
  delivery_address?: Maybe<Scalars['String']['output']>;
  delivery_address_contact_name?: Maybe<Scalars['String']['output']>;
  delivery_address_contact_phone?: Maybe<Scalars['String']['output']>;
  delivery_address_country?: Maybe<Scalars['String']['output']>;
  delivery_address_district?: Maybe<Scalars['String']['output']>;
  delivery_address_postal_code?: Maybe<Scalars['String']['output']>;
  delivery_address_province?: Maybe<Scalars['String']['output']>;
  delivery_address_sub_district?: Maybe<Scalars['String']['output']>;
  delivery_date?: Maybe<Scalars['DateTime']['output']>;
  due_date?: Maybe<Scalars['DateTime']['output']>;
  external_reference_no?: Maybe<Scalars['String']['output']>;
  issue_date?: Maybe<Scalars['DateTime']['output']>;
  item_additional_discount?: Maybe<Scalars['Float']['output']>;
  item_discount?: Maybe<Scalars['Float']['output']>;
  item_name?: Maybe<Scalars['String']['output']>;
  item_net_amount?: Maybe<Scalars['String']['output']>;
  item_post_discount_amount?: Maybe<Scalars['Float']['output']>;
  item_pre_discount_amount?: Maybe<Scalars['Float']['output']>;
  item_price_list?: Maybe<Scalars['String']['output']>;
  item_price_per_unit?: Maybe<Scalars['Float']['output']>;
  item_qty?: Maybe<Scalars['Float']['output']>;
  item_qty_invoiced?: Maybe<Scalars['Float']['output']>;
  item_qty_returned?: Maybe<Scalars['Float']['output']>;
  item_qty_shipped?: Maybe<Scalars['Float']['output']>;
  item_qty_to_ship?: Maybe<Scalars['Float']['output']>;
  item_remark?: Maybe<Scalars['String']['output']>;
  item_sku_desc?: Maybe<Scalars['String']['output']>;
  item_stock_qty?: Maybe<Scalars['Float']['output']>;
  item_total_amount?: Maybe<Scalars['Float']['output']>;
  item_unique_id?: Maybe<Scalars['String']['output']>;
  item_uom?: Maybe<Scalars['String']['output']>;
  item_vat_0_percent_amount?: Maybe<Scalars['Float']['output']>;
  item_vat_7_percent_amount?: Maybe<Scalars['Float']['output']>;
  item_vat_amount?: Maybe<Scalars['Float']['output']>;
  item_vat_exempted_amount?: Maybe<Scalars['Float']['output']>;
  item_vat_percentage?: Maybe<Scalars['String']['output']>;
  item_withholding_tax_amount?: Maybe<Scalars['Float']['output']>;
  item_withholding_tax_type?: Maybe<Scalars['String']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  price_vat_type?: Maybe<PriceVatType>;
  reference_document?: Maybe<Array<Scalars['String']['output']>>;
  reference_no?: Maybe<Scalars['String']['output']>;
  related_user_list?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  remark?: Maybe<Scalars['String']['output']>;
  sales_channel?: Maybe<Scalars['String']['output']>;
  sales_item_id?: Maybe<Scalars['Int']['output']>;
  sales_item_unique_id?: Maybe<Scalars['String']['output']>;
  sales_type?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  total_amount?: Maybe<Scalars['Float']['output']>;
  unique_id?: Maybe<Scalars['String']['output']>;
};

export type SalesOrderSalesItemReportViewAggridOutput = {
  __typename?: 'SalesOrderSalesItemReportViewAggridOutput';
  count?: Maybe<Scalars['Int']['output']>;
  results: Array<SalesOrderSalesItemReportView>;
};

export type SalesOrderUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type SalesOrderUpdateInput = {
  accepted_date?: InputMaybe<Scalars['DateTime']['input']>;
  accepted_remark?: InputMaybe<Scalars['String']['input']>;
  account_id?: InputMaybe<Scalars['String']['input']>;
  additional_discount?: InputMaybe<Scalars['Float']['input']>;
  additional_discount_type?: InputMaybe<AdditionalDiscountType>;
  aggrid_status?: InputMaybe<Scalars['String']['input']>;
  approval_step?: InputMaybe<Scalars['Int']['input']>;
  approver_list?: InputMaybe<Array<InputMaybe<Scalars['Json']['input']>>>;
  branch_id?: InputMaybe<Scalars['Int']['input']>;
  contact_person_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  created_by?: InputMaybe<Scalars['Json']['input']>;
  credit_day?: InputMaybe<Scalars['Int']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  customer_details?: InputMaybe<Scalars['Json']['input']>;
  customer_unique_id?: InputMaybe<Scalars['String']['input']>;
  delivery_date?: InputMaybe<Scalars['DateTime']['input']>;
  due_date?: InputMaybe<Scalars['DateTime']['input']>;
  external_reference_no?: InputMaybe<Scalars['String']['input']>;
  flag_status?: InputMaybe<Array<Scalars['String']['input']>>;
  issue_date?: InputMaybe<Scalars['DateTime']['input']>;
  item_list?: InputMaybe<Array<SalesItemUpsertInput>>;
  item_price_list_id?: InputMaybe<Scalars['Int']['input']>;
  last_updated_by?: InputMaybe<Scalars['Json']['input']>;
  main_status?: InputMaybe<Scalars['String']['input']>;
  net_amount?: InputMaybe<Scalars['Float']['input']>;
  post_discount_amount?: InputMaybe<Scalars['Float']['input']>;
  pre_vat_amount?: InputMaybe<Scalars['Float']['input']>;
  price_vat_type?: InputMaybe<PriceVatType>;
  reference_document_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  reference_no?: InputMaybe<Scalars['String']['input']>;
  related_user_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  remark?: InputMaybe<Scalars['String']['input']>;
  reviewer_list?: InputMaybe<Array<InputMaybe<Scalars['Json']['input']>>>;
  sales_channel_id?: InputMaybe<Scalars['Int']['input']>;
  sales_contact?: InputMaybe<Array<Scalars['Json']['input']>>;
  sales_type?: InputMaybe<Scalars['String']['input']>;
  shipping_cost?: InputMaybe<Scalars['Float']['input']>;
  sub_status?: InputMaybe<Scalars['String']['input']>;
  tag_id_list?: InputMaybe<Array<Scalars['Int']['input']>>;
  template_remark_id?: InputMaybe<Scalars['String']['input']>;
  total_amount?: InputMaybe<Scalars['Float']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
  use_preorder_quota?: InputMaybe<Scalars['Boolean']['input']>;
  vat_0_percent_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_7_percent_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_exempted_amount?: InputMaybe<Scalars['Float']['input']>;
  withholding_tax_amount?: InputMaybe<Scalars['Float']['input']>;
};

export type SalesOrderView = {
  __typename?: 'SalesOrderView';
  branch_id?: Maybe<Scalars['Int']['output']>;
  branch_name?: Maybe<Scalars['String']['output']>;
  branch_unique_id?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  created_by_object?: Maybe<Scalars['Json']['output']>;
  created_by_unique_id?: Maybe<Scalars['String']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  customer_name?: Maybe<Scalars['String']['output']>;
  customer_unique_id?: Maybe<Scalars['String']['output']>;
  delivery_date?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  issue_date?: Maybe<Scalars['DateTime']['output']>;
  item_list?: Maybe<Array<SalesItem>>;
  net_amount?: Maybe<Scalars['Float']['output']>;
  reference_id?: Maybe<Scalars['Int']['output']>;
  reference_unique_id?: Maybe<Scalars['String']['output']>;
  related_user_list?: Maybe<Array<Scalars['String']['output']>>;
  related_user_object_list?: Maybe<Array<Scalars['Json']['output']>>;
  related_user_unique_id_list?: Maybe<Array<Scalars['String']['output']>>;
  sales_channel?: Maybe<Scalars['String']['output']>;
  sales_channel_id?: Maybe<Scalars['Int']['output']>;
  sales_type?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tag_list?: Maybe<Array<Scalars['String']['output']>>;
  unique_id: Scalars['String']['output'];
};

export type SalesOrderViewAggridOutput = {
  __typename?: 'SalesOrderViewAggridOutput';
  count?: Maybe<Scalars['Int']['output']>;
  results: Array<SalesOrderView>;
};

export type SalesOriginalPrintInput = {
  document_id: Scalars['Int']['input'];
  document_type: SalesReferenceDocumentType;
  key: Scalars['String']['input'];
};

export type SalesOriginalPrintOutput = {
  __typename?: 'SalesOriginalPrintOutput';
  id: Scalars['Int']['output'];
  is_original_print?: Maybe<Scalars['Json']['output']>;
  unique_id: Scalars['String']['output'];
};

export type SalesPayment = {
  __typename?: 'SalesPayment';
  branch_id: Scalars['Int']['output'];
  cheque_date?: Maybe<Scalars['DateTime']['output']>;
  cheque_no?: Maybe<Scalars['String']['output']>;
  cheque_provider?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  is_withholding_tax?: Maybe<Scalars['Boolean']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  payment_amount?: Maybe<Scalars['Float']['output']>;
  payment_channel_id?: Maybe<Scalars['Int']['output']>;
  payment_channel_name?: Maybe<Scalars['String']['output']>;
  payment_channel_payment_name?: Maybe<Scalars['String']['output']>;
  payment_channel_unique_id?: Maybe<Scalars['String']['output']>;
  payment_date?: Maybe<Scalars['DateTime']['output']>;
  reference_document_type: SalesReferenceDocumentType;
  reference_unique_id: Scalars['String']['output'];
  remark?: Maybe<Scalars['String']['output']>;
  withholding_tax_amount?: Maybe<Scalars['Float']['output']>;
  withholding_tax_rate?: Maybe<Scalars['String']['output']>;
};

export type SalesPaymentCreateInput = {
  branch_id: Scalars['Int']['input'];
  cheque_date?: InputMaybe<Scalars['DateTime']['input']>;
  cheque_no?: InputMaybe<Scalars['String']['input']>;
  cheque_provider?: InputMaybe<Scalars['String']['input']>;
  is_withholding_tax?: InputMaybe<Scalars['Boolean']['input']>;
  payment_amount?: InputMaybe<Scalars['Float']['input']>;
  payment_channel_id?: InputMaybe<Scalars['Int']['input']>;
  payment_channel_name?: InputMaybe<Scalars['String']['input']>;
  payment_channel_payment_name?: InputMaybe<Scalars['String']['input']>;
  payment_channel_unique_id?: InputMaybe<Scalars['String']['input']>;
  payment_date?: InputMaybe<Scalars['DateTime']['input']>;
  reference_document_type: SalesReferenceDocumentType;
  reference_unique_id: Scalars['String']['input'];
  remark?: InputMaybe<Scalars['String']['input']>;
  withholding_tax_amount?: InputMaybe<Scalars['Float']['input']>;
  withholding_tax_rate?: InputMaybe<Scalars['String']['input']>;
};

export type SalesPaymentExportView = {
  __typename?: 'SalesPaymentExportView';
  branch_id?: Maybe<Scalars['String']['output']>;
  branch_name?: Maybe<Scalars['String']['output']>;
  cheque_date?: Maybe<Scalars['DateTime']['output']>;
  cheque_no?: Maybe<Scalars['String']['output']>;
  cheque_provider?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  payment_amount?: Maybe<Scalars['Float']['output']>;
  payment_channel_id?: Maybe<Scalars['Int']['output']>;
  payment_channel_name?: Maybe<Scalars['String']['output']>;
  payment_channel_payment_name?: Maybe<Scalars['String']['output']>;
  payment_channel_unique_id?: Maybe<Scalars['String']['output']>;
  payment_date?: Maybe<Scalars['DateTime']['output']>;
  reference_document_id?: Maybe<Scalars['String']['output']>;
  reference_document_type?: Maybe<Scalars['String']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
  withholding_tax_amount?: Maybe<Scalars['Float']['output']>;
};

export type SalesPaymentUpsertInput = {
  branch_id: Scalars['Int']['input'];
  cheque_date?: InputMaybe<Scalars['DateTime']['input']>;
  cheque_no?: InputMaybe<Scalars['String']['input']>;
  cheque_provider?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_withholding_tax?: InputMaybe<Scalars['Boolean']['input']>;
  payment_amount?: InputMaybe<Scalars['Float']['input']>;
  payment_channel_id?: InputMaybe<Scalars['Int']['input']>;
  payment_channel_name?: InputMaybe<Scalars['String']['input']>;
  payment_channel_payment_name?: InputMaybe<Scalars['String']['input']>;
  payment_channel_unique_id?: InputMaybe<Scalars['String']['input']>;
  payment_date?: InputMaybe<Scalars['DateTime']['input']>;
  reference_document_type: SalesReferenceDocumentType;
  reference_unique_id: Scalars['String']['input'];
  remark?: InputMaybe<Scalars['String']['input']>;
  withholding_tax_amount?: InputMaybe<Scalars['Float']['input']>;
  withholding_tax_rate?: InputMaybe<Scalars['String']['input']>;
};

export enum SalesReferenceDocumentType {
  CashSales = 'cash_sales',
  CustomerDeposit = 'customer_deposit',
  Quotation = 'quotation',
  SalesInvoice = 'sales_invoice',
  SalesOrder = 'sales_order',
  SalesReturn = 'sales_return',
  TaxInvoice = 'tax_invoice'
}

export type SalesReturn = {
  __typename?: 'SalesReturn';
  additional_discount?: Maybe<Scalars['Float']['output']>;
  additional_discount_type?: Maybe<AdditionalDiscountType>;
  aggrid_status?: Maybe<Scalars['String']['output']>;
  approval_step?: Maybe<Scalars['Int']['output']>;
  approver_list?: Maybe<Array<Scalars['Json']['output']>>;
  branch?: Maybe<Branch>;
  branch_id: Scalars['Int']['output'];
  contact_person_list?: Maybe<Array<Scalars['Json']['output']>>;
  created_by: Scalars['Json']['output'];
  created_date: Scalars['DateTime']['output'];
  credit_day?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customer_details?: Maybe<Scalars['Json']['output']>;
  customer_unique_id?: Maybe<Scalars['String']['output']>;
  due_date: Scalars['DateTime']['output'];
  external_reference_no?: Maybe<Scalars['String']['output']>;
  flag_status?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['Int']['output'];
  is_effect_stock?: Maybe<Scalars['Boolean']['output']>;
  issue_date: Scalars['DateTime']['output'];
  item_list?: Maybe<Array<SalesItem>>;
  item_price_list?: Maybe<ItemPriceList>;
  item_price_list_id?: Maybe<Scalars['Int']['output']>;
  last_updated_by?: Maybe<Scalars['Json']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  main_status?: Maybe<Scalars['String']['output']>;
  net_amount?: Maybe<Scalars['Float']['output']>;
  post_discount_amount?: Maybe<Scalars['Float']['output']>;
  pre_vat_amount?: Maybe<Scalars['Float']['output']>;
  price_vat_type?: Maybe<PriceVatType>;
  reason_to_return?: Maybe<Scalars['String']['output']>;
  reference_document_list?: Maybe<Array<Scalars['Json']['output']>>;
  reference_no?: Maybe<Scalars['String']['output']>;
  related_user_list?: Maybe<Array<Scalars['Json']['output']>>;
  remark?: Maybe<Scalars['String']['output']>;
  reviewer_list?: Maybe<Array<Scalars['Json']['output']>>;
  sales_channel?: Maybe<SalesChannel>;
  sales_channel_id?: Maybe<Scalars['Int']['output']>;
  sales_contact?: Maybe<Array<Scalars['Json']['output']>>;
  sales_type?: Maybe<Scalars['String']['output']>;
  sub_status?: Maybe<Scalars['String']['output']>;
  tag_id_list?: Maybe<Array<Scalars['Int']['output']>>;
  tag_list?: Maybe<Array<Tag>>;
  template_remark_id?: Maybe<Scalars['String']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
  unique_id: Scalars['String']['output'];
  vat_0_percent_amount?: Maybe<Scalars['Float']['output']>;
  vat_7_percent_amount?: Maybe<Scalars['Float']['output']>;
  vat_amount?: Maybe<Scalars['Float']['output']>;
  vat_exempted_amount?: Maybe<Scalars['Float']['output']>;
  withholding_tax_amount?: Maybe<Scalars['Float']['output']>;
};

export type SalesReturnAggridOutput = {
  __typename?: 'SalesReturnAggridOutput';
  count?: Maybe<Scalars['Int']['output']>;
  results: Array<SalesReturn>;
};

export type SalesReturnCreateInput = {
  additional_discount?: InputMaybe<Scalars['Float']['input']>;
  additional_discount_type?: InputMaybe<AdditionalDiscountType>;
  aggrid_status?: InputMaybe<Scalars['String']['input']>;
  approval_step?: InputMaybe<Scalars['Int']['input']>;
  approver_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  branch_id: Scalars['Int']['input'];
  contact_person_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  created_by: Scalars['Json']['input'];
  credit_day?: InputMaybe<Scalars['Int']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  customer_details?: InputMaybe<Scalars['Json']['input']>;
  customer_unique_id?: InputMaybe<Scalars['String']['input']>;
  due_date: Scalars['DateTime']['input'];
  external_reference_no?: InputMaybe<Scalars['String']['input']>;
  flag_status?: InputMaybe<Array<Scalars['String']['input']>>;
  is_effect_stock?: InputMaybe<Scalars['Boolean']['input']>;
  issue_date: Scalars['DateTime']['input'];
  item_list?: InputMaybe<Array<SalesItemCreateInput>>;
  item_price_list_id?: InputMaybe<Scalars['Int']['input']>;
  last_updated_by?: InputMaybe<Scalars['Json']['input']>;
  main_status?: InputMaybe<Scalars['String']['input']>;
  net_amount?: InputMaybe<Scalars['Float']['input']>;
  post_discount_amount?: InputMaybe<Scalars['Float']['input']>;
  pre_vat_amount?: InputMaybe<Scalars['Float']['input']>;
  price_vat_type?: InputMaybe<PriceVatType>;
  reason_to_return?: InputMaybe<Scalars['String']['input']>;
  reference_document_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  reference_no?: InputMaybe<Scalars['String']['input']>;
  related_user_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  remark?: InputMaybe<Scalars['String']['input']>;
  reviewer_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  sales_channel_id?: InputMaybe<Scalars['Int']['input']>;
  sales_contact?: InputMaybe<Array<Scalars['Json']['input']>>;
  sales_type?: InputMaybe<Scalars['String']['input']>;
  sub_status?: InputMaybe<Scalars['String']['input']>;
  tag_id_list?: InputMaybe<Array<Scalars['Int']['input']>>;
  template_remark_id?: InputMaybe<Scalars['String']['input']>;
  total_amount?: InputMaybe<Scalars['Float']['input']>;
  unique_id: Scalars['String']['input'];
  vat_0_percent_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_7_percent_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_exempted_amount?: InputMaybe<Scalars['Float']['input']>;
  withholding_tax_amount?: InputMaybe<Scalars['Float']['input']>;
};

export type SalesReturnExportView = {
  __typename?: 'SalesReturnExportView';
  additional_discount?: Maybe<Scalars['Float']['output']>;
  billing_address?: Maybe<Scalars['String']['output']>;
  billing_address_country?: Maybe<Scalars['String']['output']>;
  billing_address_district?: Maybe<Scalars['String']['output']>;
  billing_address_postal_code?: Maybe<Scalars['String']['output']>;
  billing_address_province?: Maybe<Scalars['String']['output']>;
  billing_address_sub_district?: Maybe<Scalars['String']['output']>;
  branch_name: Scalars['String']['output'];
  branch_unique_id: Scalars['String']['output'];
  created_by?: Maybe<Scalars['String']['output']>;
  created_date: Scalars['DateTime']['output'];
  credit_day?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customer_fax?: Maybe<Scalars['String']['output']>;
  customer_name?: Maybe<Scalars['String']['output']>;
  customer_phone?: Maybe<Scalars['String']['output']>;
  customer_unique_id?: Maybe<Scalars['String']['output']>;
  delivery_address?: Maybe<Scalars['String']['output']>;
  delivery_address_contact_name?: Maybe<Scalars['String']['output']>;
  delivery_address_contact_phone?: Maybe<Scalars['String']['output']>;
  delivery_address_country?: Maybe<Scalars['String']['output']>;
  delivery_address_district?: Maybe<Scalars['String']['output']>;
  delivery_address_postal_code?: Maybe<Scalars['String']['output']>;
  delivery_address_province?: Maybe<Scalars['String']['output']>;
  delivery_address_sub_district?: Maybe<Scalars['String']['output']>;
  due_date: Scalars['DateTime']['output'];
  external_reference_no?: Maybe<Scalars['String']['output']>;
  is_effect_stock?: Maybe<Scalars['Boolean']['output']>;
  issue_date: Scalars['DateTime']['output'];
  item_additional_discount?: Maybe<Scalars['Float']['output']>;
  item_discount?: Maybe<Scalars['Float']['output']>;
  item_name?: Maybe<Scalars['String']['output']>;
  item_net_amount?: Maybe<Scalars['Float']['output']>;
  item_pre_discount_amount?: Maybe<Scalars['Float']['output']>;
  item_pre_vat_amount?: Maybe<Scalars['Float']['output']>;
  item_price_list?: Maybe<Scalars['String']['output']>;
  item_price_per_unit?: Maybe<Scalars['Float']['output']>;
  item_qty: Scalars['Float']['output'];
  item_sku_desc?: Maybe<Scalars['String']['output']>;
  item_so_qty?: Maybe<Scalars['Float']['output']>;
  item_stock_qty?: Maybe<Scalars['Float']['output']>;
  item_total_amount?: Maybe<Scalars['Float']['output']>;
  item_unique_id: Scalars['String']['output'];
  item_uom?: Maybe<Scalars['String']['output']>;
  item_vat_0_percent_amount?: Maybe<Scalars['Float']['output']>;
  item_vat_7_percent_amount?: Maybe<Scalars['Float']['output']>;
  item_vat_amount?: Maybe<Scalars['Float']['output']>;
  item_vat_exempted_amount?: Maybe<Scalars['Float']['output']>;
  item_vat_percentage?: Maybe<Scalars['String']['output']>;
  item_withholding_tax_type?: Maybe<Scalars['String']['output']>;
  item_withholding_tax_value?: Maybe<Scalars['Float']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  price_vat_type?: Maybe<PriceVatType>;
  reason_to_return?: Maybe<Scalars['String']['output']>;
  reference_document?: Maybe<Scalars['String']['output']>;
  reference_document_type?: Maybe<Scalars['String']['output']>;
  reference_no?: Maybe<Scalars['String']['output']>;
  related_user_list: Array<Scalars['String']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  sales_channel?: Maybe<Scalars['String']['output']>;
  sales_contact?: Maybe<Scalars['String']['output']>;
  sales_type?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tag_list: Array<Scalars['String']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
  unique_id: Scalars['String']['output'];
};

export type SalesReturnUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type SalesReturnUpdateInput = {
  additional_discount?: InputMaybe<Scalars['Float']['input']>;
  additional_discount_type?: InputMaybe<AdditionalDiscountType>;
  aggrid_status?: InputMaybe<Scalars['String']['input']>;
  approval_step?: InputMaybe<Scalars['Int']['input']>;
  approver_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  branch_id?: InputMaybe<Scalars['Int']['input']>;
  contact_person_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  credit_day?: InputMaybe<Scalars['Int']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  customer_details?: InputMaybe<Scalars['Json']['input']>;
  customer_unique_id?: InputMaybe<Scalars['String']['input']>;
  due_date?: InputMaybe<Scalars['DateTime']['input']>;
  external_reference_no?: InputMaybe<Scalars['String']['input']>;
  flag_status?: InputMaybe<Array<Scalars['String']['input']>>;
  is_effect_stock?: InputMaybe<Scalars['Boolean']['input']>;
  issue_date?: InputMaybe<Scalars['DateTime']['input']>;
  item_list?: InputMaybe<Array<SalesItemUpsertInput>>;
  item_price_list_id?: InputMaybe<Scalars['Int']['input']>;
  last_updated_by?: InputMaybe<Scalars['Json']['input']>;
  main_status?: InputMaybe<Scalars['String']['input']>;
  net_amount?: InputMaybe<Scalars['Float']['input']>;
  post_discount_amount?: InputMaybe<Scalars['Float']['input']>;
  pre_vat_amount?: InputMaybe<Scalars['Float']['input']>;
  price_vat_type?: InputMaybe<PriceVatType>;
  reason_to_return?: InputMaybe<Scalars['String']['input']>;
  reference_document_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  reference_no?: InputMaybe<Scalars['String']['input']>;
  related_user_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  remark?: InputMaybe<Scalars['String']['input']>;
  reviewer_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  sales_channel_id?: InputMaybe<Scalars['Int']['input']>;
  sales_contact?: InputMaybe<Array<Scalars['Json']['input']>>;
  sales_type?: InputMaybe<Scalars['String']['input']>;
  sub_status?: InputMaybe<Scalars['String']['input']>;
  tag_id_list?: InputMaybe<Array<Scalars['Int']['input']>>;
  template_remark_id?: InputMaybe<Scalars['String']['input']>;
  total_amount?: InputMaybe<Scalars['Float']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
  vat_0_percent_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_7_percent_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_exempted_amount?: InputMaybe<Scalars['Float']['input']>;
  withholding_tax_amount?: InputMaybe<Scalars['Float']['input']>;
};

export type SalesReturnView = {
  __typename?: 'SalesReturnView';
  branch_id?: Maybe<Scalars['Int']['output']>;
  branch_name?: Maybe<Scalars['String']['output']>;
  branch_unique_id?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  created_by_object?: Maybe<Scalars['Json']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  customer_name?: Maybe<Scalars['String']['output']>;
  customer_unique_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  issue_date?: Maybe<Scalars['DateTime']['output']>;
  net_amount?: Maybe<Scalars['Float']['output']>;
  reference_id?: Maybe<Scalars['Int']['output']>;
  reference_unique_id?: Maybe<Scalars['String']['output']>;
  related_user_list?: Maybe<Array<Scalars['String']['output']>>;
  related_user_object_list?: Maybe<Array<Scalars['Json']['output']>>;
  sales_channel?: Maybe<Scalars['String']['output']>;
  sales_channel_id?: Maybe<Scalars['Int']['output']>;
  sales_type?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tag_list?: Maybe<Array<Scalars['String']['output']>>;
  unique_id: Scalars['String']['output'];
};

export type SalesReturnViewAggridOutput = {
  __typename?: 'SalesReturnViewAggridOutput';
  count?: Maybe<Scalars['Int']['output']>;
  results: Array<SalesReturnView>;
};

export type SalesValidateCancelableInput = {
  document_id: Scalars['Int']['input'];
  document_type: SalesReferenceDocumentType;
  document_unique_id: Scalars['String']['input'];
};

export type SalesValidateCancelableOutput = {
  __typename?: 'SalesValidateCancelableOutput';
  is_cancelable: Scalars['Boolean']['output'];
  meta?: Maybe<Scalars['Any']['output']>;
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type Tag = {
  __typename?: 'Tag';
  document_type: TagDocumentType;
  id: Scalars['Int']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
};

export enum TagDocumentType {
  Batch = 'batch',
  CashSales = 'cash_sales',
  Contact = 'contact',
  CreditNote = 'credit_note',
  Customer = 'customer',
  CustomerDeposit = 'customer_deposit',
  DeliveryOrder = 'delivery_order',
  DeliveryTrip = 'delivery_trip',
  Employee = 'employee',
  Event = 'event',
  GoodsAdjust = 'goods_adjust',
  GoodsIssue = 'goods_issue',
  GoodsReceive = 'goods_receive',
  GoodsTransfer = 'goods_transfer',
  Inventory = 'inventory',
  Item = 'item',
  PaymentMade = 'payment_made',
  PaymentReceive = 'payment_receive',
  Project = 'project',
  Promotion = 'promotion',
  Purchase = 'purchase',
  PurchaseInvoice = 'purchase_invoice',
  PurchaseOrder = 'purchase_order',
  PurchaseRequest = 'purchase_request',
  PurchaseReturn = 'purchase_return',
  Quotation = 'quotation',
  Role = 'role',
  Sale = 'sale',
  SalesInvoice = 'sales_invoice',
  SalesOrder = 'sales_order',
  SalesReturn = 'sales_return',
  Serial = 'serial',
  Task = 'task',
  Vendor = 'vendor'
}

export enum Tracability {
  Lot = 'lot',
  Normal = 'normal',
  Serial = 'serial'
}

export enum TraceAbilityEnum {
  Lot = 'lot',
  Normal = 'normal',
  Serial = 'serial'
}

export type TraceEntry = {
  __typename?: 'TraceEntry';
  additional_cost?: Maybe<Scalars['Float']['output']>;
  barcode?: Maybe<Scalars['String']['output']>;
  cost_price?: Maybe<Scalars['Float']['output']>;
  created_date: Scalars['DateTime']['output'];
  delivery_order_unique_id?: Maybe<Scalars['String']['output']>;
  destination_bin_location?: Maybe<BinLocation>;
  destination_bin_location_id?: Maybe<Scalars['Int']['output']>;
  destination_scanned_by?: Maybe<Scalars['Json']['output']>;
  destination_scanned_date?: Maybe<Scalars['DateTime']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  document_item_qty?: Maybe<Scalars['Int']['output']>;
  expired_date?: Maybe<Scalars['DateTime']['output']>;
  goods_adjust_unique_id?: Maybe<Scalars['String']['output']>;
  goods_issue_unique_id?: Maybe<Scalars['String']['output']>;
  goods_receive_unique_id?: Maybe<Scalars['String']['output']>;
  goods_return_unique_id?: Maybe<Scalars['String']['output']>;
  goods_transfer_unique_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  is_stockable: Scalars['Boolean']['output'];
  item_img_url: Array<Scalars['String']['output']>;
  item_name: Scalars['String']['output'];
  item_unique_id: Scalars['String']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  lot_date?: Maybe<Scalars['DateTime']['output']>;
  manufactured_date?: Maybe<Scalars['DateTime']['output']>;
  po_reference_unique_id?: Maybe<Scalars['String']['output']>;
  posted_date?: Maybe<Scalars['DateTime']['output']>;
  posted_qty?: Maybe<Scalars['Int']['output']>;
  qty: Scalars['Int']['output'];
  reference_line_item?: Maybe<InventoryReferenceLineItem>;
  reference_unique_id?: Maybe<Scalars['String']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  scanned_by?: Maybe<Scalars['Json']['output']>;
  serial_no?: Maybe<Scalars['String']['output']>;
  sku_name: Scalars['String']['output'];
  source_bin_location?: Maybe<BinLocation>;
  source_bin_location_id?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  stock_qty?: Maybe<Scalars['Int']['output']>;
  tracability: Tracability;
  type: InventoryDocumentType;
  unique_id: Scalars['String']['output'];
  uom?: Maybe<Unit>;
  uom_id?: Maybe<Scalars['Int']['output']>;
};

export type TraceEntryCreateInput = {
  additional_cost?: InputMaybe<Scalars['Float']['input']>;
  barcode?: InputMaybe<Scalars['String']['input']>;
  cost_price?: InputMaybe<Scalars['Float']['input']>;
  delivery_order_unique_id?: InputMaybe<Scalars['String']['input']>;
  destination_bin_location_id?: InputMaybe<Scalars['Int']['input']>;
  destination_scanned_by?: InputMaybe<Scalars['Json']['input']>;
  destination_scanned_date?: InputMaybe<Scalars['DateTime']['input']>;
  discount?: InputMaybe<Scalars['Float']['input']>;
  document_item_qty?: InputMaybe<Scalars['Int']['input']>;
  expired_date?: InputMaybe<Scalars['DateTime']['input']>;
  goods_adjust_unique_id?: InputMaybe<Scalars['String']['input']>;
  goods_issue_unique_id?: InputMaybe<Scalars['String']['input']>;
  goods_receive_unique_id?: InputMaybe<Scalars['String']['input']>;
  goods_return_unique_id?: InputMaybe<Scalars['String']['input']>;
  goods_transfer_unique_id?: InputMaybe<Scalars['String']['input']>;
  is_stockable?: InputMaybe<Scalars['Boolean']['input']>;
  item_img_url?: InputMaybe<Array<Scalars['String']['input']>>;
  item_name: Scalars['String']['input'];
  item_unique_id: Scalars['String']['input'];
  lot_date?: InputMaybe<Scalars['DateTime']['input']>;
  manufactured_date?: InputMaybe<Scalars['DateTime']['input']>;
  po_reference_unique_id?: InputMaybe<Scalars['String']['input']>;
  posted_date?: InputMaybe<Scalars['DateTime']['input']>;
  posted_qty?: InputMaybe<Scalars['Int']['input']>;
  qty: Scalars['Int']['input'];
  reference_line_item?: InputMaybe<InventoryReferenceLineItemInput>;
  reference_unique_id?: InputMaybe<Scalars['String']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  scanned_by?: InputMaybe<Scalars['Json']['input']>;
  serial_no?: InputMaybe<Scalars['String']['input']>;
  sku_name: Scalars['String']['input'];
  source_bin_location_id?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  stock_qty?: InputMaybe<Scalars['Int']['input']>;
  tracability: Tracability;
  type?: InputMaybe<InventoryDocumentType>;
  unique_id: Scalars['String']['input'];
  uom_id?: InputMaybe<Scalars['Int']['input']>;
};

export type Unit = {
  __typename?: 'Unit';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  name_en?: Maybe<Scalars['String']['output']>;
  name_th: Scalars['String']['output'];
  unique_id: Scalars['String']['output'];
};

export enum UnitScalarField {
  NameTh = 'name_th',
  UniqueId = 'unique_id'
}

export type UomConversion = {
  __typename?: 'UomConversion';
  base_uom_rate: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  target_uom: Unit;
  target_uom_id: Scalars['Int']['output'];
  target_uom_rate: Scalars['Float']['output'];
  uom_group: UomGroup;
  uom_group_id: Scalars['Int']['output'];
};

export type UomGroup = {
  __typename?: 'UomGroup';
  base_uom: Unit;
  base_uom_id: Scalars['Int']['output'];
  convertable_uom_list: Array<Unit>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  unique_id: Scalars['String']['output'];
  uom_conversion_list: Array<UomConversion>;
};

export enum UsageLimitType {
  Limited = 'limited',
  NoLimit = 'no_limit'
}

export type User = {
  __typename?: 'User';
  company_name?: Maybe<Scalars['String']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  employee_type?: Maybe<Scalars['String']['output']>;
  first_name: Scalars['String']['output'];
  gender?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  img_url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  inactive_date?: Maybe<Scalars['DateTime']['output']>;
  is_sales_employee?: Maybe<Scalars['Boolean']['output']>;
  last_login_branch?: Maybe<Scalars['Int']['output']>;
  last_name: Scalars['String']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  nick_name?: Maybe<Scalars['String']['output']>;
  original_branch: Scalars['Int']['output'];
  original_branch_object?: Maybe<Branch>;
  phone?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  remark_status?: Maybe<Scalars['String']['output']>;
  role_id_list?: Maybe<Array<Scalars['Int']['output']>>;
  start_date?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['Int']['output'];
  title_name?: Maybe<Scalars['String']['output']>;
  unique_id: Scalars['String']['output'];
  user_permission?: Maybe<UserPermission>;
};

export type UserPermission = {
  __typename?: 'UserPermission';
  approval?: Maybe<AccessPermission>;
  branch?: Maybe<AccessPermission>;
  cash_sales?: Maybe<AccessPermission>;
  company?: Maybe<AccessPermission>;
  contact?: Maybe<AccessPermission>;
  contact_export?: Maybe<AccessPermission>;
  contact_setting?: Maybe<AccessPermission>;
  customer?: Maybe<AccessPermission>;
  customer_deposit?: Maybe<AccessPermission>;
  delivery_order?: Maybe<AccessPermission>;
  employee?: Maybe<AccessPermission>;
  goods_adjust?: Maybe<AccessPermission>;
  goods_issue?: Maybe<AccessPermission>;
  goods_receive?: Maybe<AccessPermission>;
  goods_return?: Maybe<AccessPermission>;
  goods_transfer?: Maybe<AccessPermission>;
  id: Scalars['Int']['output'];
  inventory?: Maybe<AccessPermission>;
  inventory_export?: Maybe<AccessPermission>;
  inventory_report?: Maybe<AccessPermission>;
  inventory_setting?: Maybe<AccessPermission>;
  is_custom: Scalars['Boolean']['output'];
  item?: Maybe<AccessPermission>;
  logistic?: Maybe<AccessPermission>;
  logistic_export?: Maybe<AccessPermission>;
  logistic_report?: Maybe<AccessPermission>;
  logistic_setting?: Maybe<AccessPermission>;
  marketing?: Maybe<AccessPermission>;
  marketing_export?: Maybe<AccessPermission>;
  price_list?: Maybe<AccessPermission>;
  promotion?: Maybe<AccessPermission>;
  purchase?: Maybe<AccessPermission>;
  purchase_export?: Maybe<AccessPermission>;
  purchase_order?: Maybe<AccessPermission>;
  purchase_report?: Maybe<AccessPermission>;
  purchase_request?: Maybe<AccessPermission>;
  purchase_return?: Maybe<AccessPermission>;
  quotation?: Maybe<AccessPermission>;
  role?: Maybe<AccessPermission>;
  sales?: Maybe<AccessPermission>;
  sales_export?: Maybe<AccessPermission>;
  sales_invoice?: Maybe<AccessPermission>;
  sales_order?: Maybe<AccessPermission>;
  sales_report?: Maybe<AccessPermission>;
  sales_return?: Maybe<AccessPermission>;
  sales_setting?: Maybe<AccessPermission>;
  setting?: Maybe<AccessPermission>;
  user_account?: Maybe<AccessPermission>;
  user_export?: Maybe<AccessPermission>;
  user_id: Scalars['Int']['output'];
  vendor?: Maybe<AccessPermission>;
  zone?: Maybe<AccessPermission>;
};

export type UserPermissionInput = {
  approval?: InputMaybe<AccessPermissionInput>;
  branch?: InputMaybe<AccessPermissionInput>;
  cash_sales?: InputMaybe<AccessPermissionInput>;
  company?: InputMaybe<AccessPermissionInput>;
  contact?: InputMaybe<AccessPermissionInput>;
  contact_export?: InputMaybe<AccessPermissionInput>;
  contact_setting?: InputMaybe<AccessPermissionInput>;
  customer?: InputMaybe<AccessPermissionInput>;
  customer_deposit?: InputMaybe<AccessPermissionInput>;
  delivery_order?: InputMaybe<AccessPermissionInput>;
  employee?: InputMaybe<AccessPermissionInput>;
  goods_adjust?: InputMaybe<AccessPermissionInput>;
  goods_issue?: InputMaybe<AccessPermissionInput>;
  goods_receive?: InputMaybe<AccessPermissionInput>;
  goods_return?: InputMaybe<AccessPermissionInput>;
  goods_transfer?: InputMaybe<AccessPermissionInput>;
  inventory?: InputMaybe<AccessPermissionInput>;
  inventory_export?: InputMaybe<AccessPermissionInput>;
  inventory_report?: InputMaybe<AccessPermissionInput>;
  inventory_setting?: InputMaybe<AccessPermissionInput>;
  is_custom: Scalars['Boolean']['input'];
  item?: InputMaybe<AccessPermissionInput>;
  logistic?: InputMaybe<AccessPermissionInput>;
  logistic_export?: InputMaybe<AccessPermissionInput>;
  logistic_report?: InputMaybe<AccessPermissionInput>;
  logistic_setting?: InputMaybe<AccessPermissionInput>;
  marketing?: InputMaybe<AccessPermissionInput>;
  marketing_export?: InputMaybe<AccessPermissionInput>;
  price_list?: InputMaybe<AccessPermissionInput>;
  promotion?: InputMaybe<AccessPermissionInput>;
  purchase?: InputMaybe<AccessPermissionInput>;
  purchase_export?: InputMaybe<AccessPermissionInput>;
  purchase_order?: InputMaybe<AccessPermissionInput>;
  purchase_report?: InputMaybe<AccessPermissionInput>;
  purchase_request?: InputMaybe<AccessPermissionInput>;
  purchase_return?: InputMaybe<AccessPermissionInput>;
  quotation?: InputMaybe<AccessPermissionInput>;
  role?: InputMaybe<AccessPermissionInput>;
  sales?: InputMaybe<AccessPermissionInput>;
  sales_export?: InputMaybe<AccessPermissionInput>;
  sales_invoice?: InputMaybe<AccessPermissionInput>;
  sales_order?: InputMaybe<AccessPermissionInput>;
  sales_report?: InputMaybe<AccessPermissionInput>;
  sales_return?: InputMaybe<AccessPermissionInput>;
  sales_setting?: InputMaybe<AccessPermissionInput>;
  setting?: InputMaybe<AccessPermissionInput>;
  user_account?: InputMaybe<AccessPermissionInput>;
  user_export?: InputMaybe<AccessPermissionInput>;
  vendor?: InputMaybe<AccessPermissionInput>;
  zone?: InputMaybe<AccessPermissionInput>;
};

export type Warehouse = {
  __typename?: 'Warehouse';
  address?: Maybe<Scalars['Json']['output']>;
  branch: Branch;
  branch_id: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  is_consignment?: Maybe<Scalars['Boolean']['output']>;
  is_same_as_branch?: Maybe<Scalars['Boolean']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  unique_id: Scalars['String']['output'];
  user: User;
  user_id: Scalars['Int']['output'];
  warehouse_level_1_list: Array<WarehouseLevel1>;
};

export type WarehouseLevel1 = {
  __typename?: 'WarehouseLevel1';
  id: Scalars['Int']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  warehouse: Warehouse;
  warehouse_level_2_list?: Maybe<Array<WarehouseLevel2>>;
};

export type WarehouseLevel2 = {
  __typename?: 'WarehouseLevel2';
  id: Scalars['Int']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  warehouse_level_1: WarehouseLevel1;
  warehouse_level_3_list?: Maybe<Array<WarehouseLevel3>>;
};

export type WarehouseLevel3 = {
  __typename?: 'WarehouseLevel3';
  bin_location_list?: Maybe<Array<BinLocation>>;
  id: Scalars['Int']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  warehouse_level_2: WarehouseLevel2;
};

export type WorkflowTemplate = {
  __typename?: 'WorkflowTemplate';
  approval_template_list?: Maybe<Array<ApprovalTemplate>>;
  document_type: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  main_status: Scalars['String']['output'];
  step_number: Scalars['Int']['output'];
  sub_status?: Maybe<Scalars['String']['output']>;
};

export enum UomConversionScalarField {
  BaseUomRate = 'base_uom_rate',
  Id = 'id',
  TargetUomRate = 'target_uom_rate'
}

export type CashSalesCreateMutationVariables = Exact<{
  createInput: CashSalesCreateInput;
}>;


export type CashSalesCreateMutation = { __typename?: 'Mutation', CashSalesCreate: { __typename?: 'CashSales', id: number, unique_id: string, branch_id: number, reference_document_list?: Array<any> | null, reference_no?: string | null, external_reference_no?: string | null, related_user_list?: Array<any> | null, sales_contact?: Array<any> | null, created_date: any, created_by: any, last_updated_date?: any | null, issue_date?: any | null, due_date?: any | null, need_tax_invoice?: boolean | null, tax_invoice_no?: string | null, credit_day?: number | null, price_vat_type?: PriceVatType | null, currency?: string | null, item_price_list_id?: number | null, pre_vat_amount?: number | null, shipping_cost?: number | null, additional_discount?: number | null, additional_discount_type?: AdditionalDiscountType | null, post_discount_amount?: number | null, vat_exempted_amount?: number | null, vat_0_percent_amount?: number | null, vat_7_percent_amount?: number | null, vat_amount?: number | null, net_amount?: number | null, withholding_tax_amount?: number | null, total_amount?: number | null, remark?: string | null, main_status?: string | null, sub_status?: string | null, flag_status?: Array<string> | null, aggrid_status?: string | null, customer_unique_id?: string | null, customer_details?: any | null, sales_type?: string | null, sales_channel_id?: number | null, tag_id_list?: Array<number> | null, approval_step?: number | null, approver_list?: Array<any | null> | null, reviewer_list?: Array<any | null> | null, paid_total_amount?: number | null, paid_net_amount?: number | null, payment_total_amount?: number | null, deduction_total_amount?: number | null, contact_person_list?: Array<any> | null, is_original_print?: any | null, branch: { __typename?: 'Branch', id: number, name: string, unique_id: string, is_hq: boolean }, item_price_list?: { __typename?: 'ItemPriceList', adjusted_price?: number | null, is_increase: number, name: string, is_active: number, end_date?: any | null, description?: string | null, currency?: string | null, adjusted_item_list?: Array<{ __typename?: 'ItemAdjustment', id: number, sku_name: string, item_name: string, reference_unique_id?: string | null, current_price?: number | null, adjusted_price?: number | null } | null> | null } | null, sales_channel?: { __typename?: 'SalesChannel', id: number, name_en: string, name_th: string, unique_id: string } | null, tag_list?: Array<{ __typename?: 'Tag', document_type: TagDocumentType, id: number, name: string }> | null, item_list?: Array<{ __typename?: 'SalesItem', id: number, unique_id: string, reference_unique_id: string, reference_document_type: SalesReferenceDocumentType, item_id?: number | null, item_unique_id: string, item_sku_name: string, item_name?: string | null, item_sku_desc?: string | null, item_img_url?: Array<string> | null, tracability: TraceAbilityEnum, barcode?: string | null, qty: number, so_qty?: number | null, uom_id?: number | null, uom_name?: string | null, price_per_unit?: number | null, discount?: number | null, promotion_discount?: number | null, vat_percentage?: string | null, volume: number, weight: number, pre_vat_amount?: number | null, withholding_tax_type?: string | null, withholding_tax_value?: number | null, remark?: string | null, stock_qty?: number | null, qty_shipped?: number | null, qty_to_ship?: number | null, qty_invoiced?: number | null, qty_returned?: number | null, qty_issued?: number | null, qty_received?: number | null, branch_id: number, reference_line_item?: { __typename?: 'ReferenceSalesLineItem', line_item_unique_id: string, line_item_document_type: string } | null }> | null, deduction_document_list?: Array<{ __typename?: 'SalesDeduction', id: number, reference_unique_id: string, reference_document_type: SalesReferenceDocumentType, branch_id: number, document_type?: string | null, document_unique_id?: string | null, deduction_amount?: number | null, credit_balance?: number | null, deduction_issue_date?: any | null, remark?: string | null }> | null, payment_list?: Array<{ __typename?: 'SalesPayment', id: number, reference_unique_id: string, reference_document_type: SalesReferenceDocumentType, branch_id: number, payment_channel_id?: number | null, payment_channel_unique_id?: string | null, payment_channel_payment_name?: string | null, payment_channel_name?: string | null, payment_amount?: number | null, payment_date?: any | null, cheque_provider?: string | null, cheque_no?: string | null, cheque_date?: any | null, is_withholding_tax?: boolean | null, withholding_tax_rate?: string | null, withholding_tax_amount?: number | null, remark?: string | null }> | null, promotion_list?: Array<{ __typename?: 'PromotionAppliedLog', id: number, promotion_id: number, promotion_unique_id?: string | null, name?: string | null, coupon_code: string, discount_rate?: any | null, total_discount_amount?: any | null, priority?: number | null, receive_type?: ReceiveType | null, redeem_item_list: Array<any>, conditional_item_id_list: Array<number> }> | null } };

export type CashSalesFindUniqueQueryVariables = Exact<{
  uniqueInput: CashSalesUniqueInput;
}>;


export type CashSalesFindUniqueQuery = { __typename?: 'Query', CashSalesFindUnique: { __typename?: 'CashSales', id: number, unique_id: string, branch_id: number, reference_document_list?: Array<any> | null, reference_no?: string | null, external_reference_no?: string | null, related_user_list?: Array<any> | null, sales_contact?: Array<any> | null, created_date: any, created_by: any, last_updated_date?: any | null, issue_date?: any | null, due_date?: any | null, need_tax_invoice?: boolean | null, tax_invoice_no?: string | null, credit_day?: number | null, price_vat_type?: PriceVatType | null, currency?: string | null, item_price_list_id?: number | null, pre_vat_amount?: number | null, additional_discount?: number | null, additional_discount_type?: AdditionalDiscountType | null, post_discount_amount?: number | null, vat_exempted_amount?: number | null, vat_0_percent_amount?: number | null, vat_7_percent_amount?: number | null, vat_amount?: number | null, net_amount?: number | null, withholding_tax_amount?: number | null, total_amount?: number | null, remark?: string | null, main_status?: string | null, sub_status?: string | null, flag_status?: Array<string> | null, aggrid_status?: string | null, customer_unique_id?: string | null, customer_details?: any | null, sales_type?: string | null, sales_channel_id?: number | null, tag_id_list?: Array<number> | null, approval_step?: number | null, approver_list?: Array<any | null> | null, reviewer_list?: Array<any | null> | null, paid_total_amount?: number | null, paid_net_amount?: number | null, payment_total_amount?: number | null, deduction_total_amount?: number | null, contact_person_list?: Array<any> | null, is_original_print?: any | null, branch: { __typename?: 'Branch', id: number, name: string, unique_id: string, is_hq: boolean }, item_price_list?: { __typename?: 'ItemPriceList', adjusted_price?: number | null, is_increase: number, name: string, is_active: number, end_date?: any | null, description?: string | null, currency?: string | null, adjusted_item_list?: Array<{ __typename?: 'ItemAdjustment', id: number, sku_name: string, item_name: string, reference_unique_id?: string | null, current_price?: number | null, adjusted_price?: number | null } | null> | null } | null, sales_channel?: { __typename?: 'SalesChannel', id: number, name_en: string, name_th: string, unique_id: string } | null, tag_list?: Array<{ __typename?: 'Tag', document_type: TagDocumentType, id: number, name: string }> | null, item_list?: Array<{ __typename?: 'SalesItem', id: number, unique_id: string, reference_unique_id: string, reference_document_type: SalesReferenceDocumentType, item_id?: number | null, item_unique_id: string, item_sku_name: string, item_name?: string | null, item_sku_desc?: string | null, item_img_url?: Array<string> | null, tracability: TraceAbilityEnum, barcode?: string | null, qty: number, so_qty?: number | null, uom_id?: number | null, uom_name?: string | null, price_per_unit?: number | null, discount?: number | null, promotion_discount?: number | null, vat_percentage?: string | null, volume: number, weight: number, pre_vat_amount?: number | null, withholding_tax_type?: string | null, withholding_tax_value?: number | null, remark?: string | null, stock_qty?: number | null, qty_shipped?: number | null, qty_to_ship?: number | null, qty_invoiced?: number | null, qty_returned?: number | null, qty_issued?: number | null, qty_received?: number | null, branch_id: number, reference_line_item?: { __typename?: 'ReferenceSalesLineItem', line_item_unique_id: string, line_item_document_type: string } | null }> | null, deduction_document_list?: Array<{ __typename?: 'SalesDeduction', id: number, reference_unique_id: string, reference_document_type: SalesReferenceDocumentType, branch_id: number, document_type?: string | null, document_unique_id?: string | null, deduction_amount?: number | null, credit_balance?: number | null, deduction_issue_date?: any | null, remark?: string | null }> | null, payment_list?: Array<{ __typename?: 'SalesPayment', id: number, reference_unique_id: string, reference_document_type: SalesReferenceDocumentType, branch_id: number, payment_channel_id?: number | null, payment_channel_unique_id?: string | null, payment_channel_payment_name?: string | null, payment_channel_name?: string | null, payment_amount?: number | null, payment_date?: any | null, cheque_provider?: string | null, cheque_no?: string | null, cheque_date?: any | null, is_withholding_tax?: boolean | null, withholding_tax_rate?: string | null, withholding_tax_amount?: number | null, remark?: string | null }> | null, promotion_list?: Array<{ __typename?: 'PromotionAppliedLog', id: number, promotion_id: number, promotion_unique_id?: string | null, name?: string | null, coupon_code: string, discount_rate?: any | null, total_discount_amount?: any | null, priority?: number | null, receive_type?: ReceiveType | null, redeem_item_list: Array<any>, conditional_item_id_list: Array<number> }> | null } };

export type CashSalesUpdateMutationVariables = Exact<{
  uniqueInput: CashSalesUniqueInput;
  updateInput: CashSalesUpdateInput;
}>;


export type CashSalesUpdateMutation = { __typename?: 'Mutation', CashSalesUpdate: { __typename?: 'CashSales', id: number, unique_id: string, branch_id: number, reference_document_list?: Array<any> | null, reference_no?: string | null, external_reference_no?: string | null, related_user_list?: Array<any> | null, sales_contact?: Array<any> | null, created_date: any, created_by: any, last_updated_date?: any | null, issue_date?: any | null, due_date?: any | null, need_tax_invoice?: boolean | null, tax_invoice_no?: string | null, credit_day?: number | null, price_vat_type?: PriceVatType | null, currency?: string | null, item_price_list_id?: number | null, pre_vat_amount?: number | null, additional_discount?: number | null, additional_discount_type?: AdditionalDiscountType | null, post_discount_amount?: number | null, vat_exempted_amount?: number | null, vat_0_percent_amount?: number | null, vat_7_percent_amount?: number | null, vat_amount?: number | null, net_amount?: number | null, withholding_tax_amount?: number | null, total_amount?: number | null, remark?: string | null, main_status?: string | null, sub_status?: string | null, flag_status?: Array<string> | null, aggrid_status?: string | null, customer_unique_id?: string | null, customer_details?: any | null, sales_type?: string | null, sales_channel_id?: number | null, tag_id_list?: Array<number> | null, approval_step?: number | null, approver_list?: Array<any | null> | null, reviewer_list?: Array<any | null> | null, paid_total_amount?: number | null, paid_net_amount?: number | null, payment_total_amount?: number | null, deduction_total_amount?: number | null, contact_person_list?: Array<any> | null, is_original_print?: any | null, branch: { __typename?: 'Branch', id: number, name: string, unique_id: string, is_hq: boolean }, item_price_list?: { __typename?: 'ItemPriceList', adjusted_price?: number | null, is_increase: number, name: string, is_active: number, end_date?: any | null, description?: string | null, currency?: string | null, adjusted_item_list?: Array<{ __typename?: 'ItemAdjustment', id: number, sku_name: string, item_name: string, reference_unique_id?: string | null, current_price?: number | null, adjusted_price?: number | null } | null> | null } | null, sales_channel?: { __typename?: 'SalesChannel', id: number, name_en: string, name_th: string, unique_id: string } | null, tag_list?: Array<{ __typename?: 'Tag', document_type: TagDocumentType, id: number, name: string }> | null, item_list?: Array<{ __typename?: 'SalesItem', id: number, unique_id: string, reference_unique_id: string, reference_document_type: SalesReferenceDocumentType, item_id?: number | null, item_unique_id: string, item_sku_name: string, item_name?: string | null, item_sku_desc?: string | null, item_img_url?: Array<string> | null, tracability: TraceAbilityEnum, barcode?: string | null, qty: number, so_qty?: number | null, uom_id?: number | null, uom_name?: string | null, price_per_unit?: number | null, discount?: number | null, promotion_discount?: number | null, vat_percentage?: string | null, volume: number, weight: number, pre_vat_amount?: number | null, withholding_tax_type?: string | null, withholding_tax_value?: number | null, remark?: string | null, stock_qty?: number | null, qty_shipped?: number | null, qty_to_ship?: number | null, qty_invoiced?: number | null, qty_returned?: number | null, qty_issued?: number | null, qty_received?: number | null, branch_id: number, reference_line_item?: { __typename?: 'ReferenceSalesLineItem', line_item_unique_id: string, line_item_document_type: string } | null }> | null, deduction_document_list?: Array<{ __typename?: 'SalesDeduction', id: number, reference_unique_id: string, reference_document_type: SalesReferenceDocumentType, branch_id: number, document_type?: string | null, document_unique_id?: string | null, deduction_amount?: number | null, credit_balance?: number | null, deduction_issue_date?: any | null, remark?: string | null }> | null, payment_list?: Array<{ __typename?: 'SalesPayment', id: number, reference_unique_id: string, reference_document_type: SalesReferenceDocumentType, branch_id: number, payment_channel_id?: number | null, payment_channel_unique_id?: string | null, payment_channel_payment_name?: string | null, payment_channel_name?: string | null, payment_amount?: number | null, payment_date?: any | null, cheque_provider?: string | null, cheque_no?: string | null, cheque_date?: any | null, is_withholding_tax?: boolean | null, withholding_tax_rate?: string | null, withholding_tax_amount?: number | null, remark?: string | null }> | null, promotion_list?: Array<{ __typename?: 'PromotionAppliedLog', id: number, promotion_id: number, promotion_unique_id?: string | null, name?: string | null, coupon_code: string, discount_rate?: any | null, total_discount_amount?: any | null, priority?: number | null, receive_type?: ReceiveType | null, redeem_item_list: Array<any>, conditional_item_id_list: Array<number> }> | null } };

export type CustomerDepositCreateMutationVariables = Exact<{
  input: CustomerDepositCreateInput;
}>;


export type CustomerDepositCreateMutation = { __typename?: 'Mutation', CustomerDepositCreate: { __typename?: 'CustomerDeposit', id: number, unique_id: string, branch_id: number, reference_document_list?: Array<any> | null, reference_no?: string | null, external_reference_no?: string | null, created_date: any, created_by: any, issue_date: any, due_date: any, need_tax_invoice?: boolean | null, tax_invoice_no?: string | null, tax_invoice_date?: any | null, related_user_list?: Array<any> | null, customer_unique_id?: string | null, customer_details?: any | null, price_vat_type?: PriceVatType | null, currency?: string | null, pre_vat_amount?: number | null, additional_discount?: number | null, additional_discount_type?: AdditionalDiscountType | null, post_discount_amount?: number | null, vat_exempted_amount?: number | null, vat_0_percent_amount?: number | null, vat_7_percent_amount?: number | null, vat_amount?: number | null, net_amount?: number | null, withholding_tax_amount?: number | null, total_amount?: number | null, paid_net_amount?: number | null, paid_total_amount?: number | null, payment_total_amount?: number | null, remaining_deposit_amount?: number | null, remark?: string | null, main_status?: string | null, sub_status?: string | null, flag_status?: Array<string> | null, aggrid_status?: string | null, last_updated_date?: any | null, last_updated_by?: any | null, contact_person_list?: Array<any> | null, is_original_print?: any | null, branch?: { __typename?: 'Branch', id: number, name: string, unique_id: string, is_hq: boolean } | null, deposit_list?: Array<{ __typename?: 'CustomerDepositItem', id: number, reference_document_id?: string | null, name?: string | null, vat_percentage?: string | null, pre_vat_amount?: number | null, withholding_tax_type?: string | null, withholding_tax_value?: number | null, remark?: string | null }> | null, tag_list?: Array<{ __typename?: 'Tag', document_type: TagDocumentType, id: number, name: string }> | null, payment_list?: Array<{ __typename?: 'SalesPayment', id: number, reference_unique_id: string, reference_document_type: SalesReferenceDocumentType, branch_id: number, payment_channel_id?: number | null, payment_channel_unique_id?: string | null, payment_channel_payment_name?: string | null, payment_channel_name?: string | null, payment_amount?: number | null, payment_date?: any | null, cheque_provider?: string | null, cheque_no?: string | null, cheque_date?: any | null, is_withholding_tax?: boolean | null, withholding_tax_rate?: string | null, withholding_tax_amount?: number | null, remark?: string | null }> | null } };

export type CustomerDepositFindUniqueQueryVariables = Exact<{
  uniqueInput: CustomerDepositUniqueInput;
}>;


export type CustomerDepositFindUniqueQuery = { __typename?: 'Query', CustomerDepositFindUnique: { __typename?: 'CustomerDeposit', id: number, unique_id: string, branch_id: number, reference_document_list?: Array<any> | null, reference_no?: string | null, external_reference_no?: string | null, created_date: any, created_by: any, issue_date: any, due_date: any, need_tax_invoice?: boolean | null, tax_invoice_no?: string | null, tax_invoice_date?: any | null, related_user_list?: Array<any> | null, customer_unique_id?: string | null, customer_details?: any | null, price_vat_type?: PriceVatType | null, currency?: string | null, pre_vat_amount?: number | null, additional_discount?: number | null, additional_discount_type?: AdditionalDiscountType | null, post_discount_amount?: number | null, vat_exempted_amount?: number | null, vat_0_percent_amount?: number | null, vat_7_percent_amount?: number | null, vat_amount?: number | null, net_amount?: number | null, withholding_tax_amount?: number | null, total_amount?: number | null, paid_net_amount?: number | null, paid_total_amount?: number | null, payment_total_amount?: number | null, remaining_deposit_amount?: number | null, remark?: string | null, main_status?: string | null, sub_status?: string | null, flag_status?: Array<string> | null, aggrid_status?: string | null, last_updated_date?: any | null, last_updated_by?: any | null, contact_person_list?: Array<any> | null, is_original_print?: any | null, branch?: { __typename?: 'Branch', id: number, name: string, unique_id: string, is_hq: boolean } | null, deposit_list?: Array<{ __typename?: 'CustomerDepositItem', id: number, reference_document_id?: string | null, name?: string | null, vat_percentage?: string | null, pre_vat_amount?: number | null, withholding_tax_type?: string | null, withholding_tax_value?: number | null, remark?: string | null }> | null, tag_list?: Array<{ __typename?: 'Tag', document_type: TagDocumentType, id: number, name: string }> | null, payment_list?: Array<{ __typename?: 'SalesPayment', id: number, reference_unique_id: string, reference_document_type: SalesReferenceDocumentType, branch_id: number, payment_channel_id?: number | null, payment_channel_unique_id?: string | null, payment_channel_payment_name?: string | null, payment_channel_name?: string | null, payment_amount?: number | null, payment_date?: any | null, cheque_provider?: string | null, cheque_no?: string | null, cheque_date?: any | null, is_withholding_tax?: boolean | null, withholding_tax_rate?: string | null, withholding_tax_amount?: number | null, remark?: string | null }> | null } };

export type CustomerDepositUpdateMutationVariables = Exact<{
  uniqueInput: CustomerDepositUniqueInput;
  input: CustomerDepositUpdateInput;
}>;


export type CustomerDepositUpdateMutation = { __typename?: 'Mutation', CustomerDepositUpdate: { __typename?: 'CustomerDeposit', id: number, unique_id: string, branch_id: number, reference_document_list?: Array<any> | null, reference_no?: string | null, external_reference_no?: string | null, created_date: any, created_by: any, issue_date: any, due_date: any, need_tax_invoice?: boolean | null, tax_invoice_no?: string | null, tax_invoice_date?: any | null, related_user_list?: Array<any> | null, customer_unique_id?: string | null, customer_details?: any | null, price_vat_type?: PriceVatType | null, currency?: string | null, pre_vat_amount?: number | null, additional_discount?: number | null, additional_discount_type?: AdditionalDiscountType | null, post_discount_amount?: number | null, vat_exempted_amount?: number | null, vat_0_percent_amount?: number | null, vat_7_percent_amount?: number | null, vat_amount?: number | null, net_amount?: number | null, withholding_tax_amount?: number | null, total_amount?: number | null, paid_net_amount?: number | null, paid_total_amount?: number | null, payment_total_amount?: number | null, remaining_deposit_amount?: number | null, remark?: string | null, main_status?: string | null, sub_status?: string | null, flag_status?: Array<string> | null, aggrid_status?: string | null, last_updated_date?: any | null, last_updated_by?: any | null, contact_person_list?: Array<any> | null, is_original_print?: any | null, branch?: { __typename?: 'Branch', id: number, name: string, unique_id: string, is_hq: boolean } | null, deposit_list?: Array<{ __typename?: 'CustomerDepositItem', id: number, reference_document_id?: string | null, name?: string | null, vat_percentage?: string | null, pre_vat_amount?: number | null, withholding_tax_type?: string | null, withholding_tax_value?: number | null, remark?: string | null }> | null, tag_list?: Array<{ __typename?: 'Tag', document_type: TagDocumentType, id: number, name: string }> | null, payment_list?: Array<{ __typename?: 'SalesPayment', id: number, reference_unique_id: string, reference_document_type: SalesReferenceDocumentType, branch_id: number, payment_channel_id?: number | null, payment_channel_unique_id?: string | null, payment_channel_payment_name?: string | null, payment_channel_name?: string | null, payment_amount?: number | null, payment_date?: any | null, cheque_provider?: string | null, cheque_no?: string | null, cheque_date?: any | null, is_withholding_tax?: boolean | null, withholding_tax_rate?: string | null, withholding_tax_amount?: number | null, remark?: string | null }> | null } };

export type QuotationCreateMutationVariables = Exact<{
  input: QuotationCreateInput;
}>;


export type QuotationCreateMutation = { __typename?: 'Mutation', QuotationCreate: { __typename?: 'Quotation', id: number, unique_id: string, branch_id: number, reference_no?: string | null, related_user_list?: Array<any> | null, created_date: any, created_by: any, last_updated_date?: any | null, issue_date?: any | null, due_date?: any | null, credit_day?: number | null, price_vat_type?: PriceVatType | null, currency?: string | null, item_price_list_id?: number | null, accepted_date?: any | null, pre_vat_amount?: number | null, additional_discount?: number | null, additional_discount_type?: AdditionalDiscountType | null, post_discount_amount?: number | null, vat_exempted_amount?: number | null, vat_0_percent_amount?: number | null, vat_7_percent_amount?: number | null, vat_amount?: number | null, net_amount?: number | null, withholding_tax_amount?: number | null, total_amount?: number | null, template_remark_id?: string | null, remark?: string | null, accepted_remark?: string | null, main_status?: string | null, sub_status?: string | null, flag_status?: Array<string> | null, aggrid_status?: string | null, customer_unique_id?: string | null, customer_details?: any | null, sales_type?: string | null, sales_channel_id?: number | null, account_id?: string | null, tag_id_list?: Array<number> | null, attachment_list?: Array<any | null> | null, approval_step?: number | null, approver_list?: Array<any | null> | null, reviewer_list?: Array<any | null> | null, contact_person_list?: Array<any> | null, branch: { __typename?: 'Branch', id: number, name: string, unique_id: string, is_hq: boolean }, item_price_list?: { __typename?: 'ItemPriceList', adjusted_price?: number | null, is_increase: number, name: string, is_active: number, end_date?: any | null, description?: string | null, currency?: string | null, adjusted_item_list?: Array<{ __typename?: 'ItemAdjustment', id: number, sku_name: string, item_name: string, reference_unique_id?: string | null, current_price?: number | null, adjusted_price?: number | null } | null> | null } | null, sales_channel?: { __typename?: 'SalesChannel', id: number, name_en: string, name_th: string, unique_id: string } | null, tag_list?: Array<{ __typename?: 'Tag', document_type: TagDocumentType, id: number, name: string } | null> | null, item_list?: Array<{ __typename?: 'SalesItem', id: number, unique_id: string, reference_unique_id: string, reference_document_type: SalesReferenceDocumentType, item_unique_id: string, item_sku_name: string, item_name?: string | null, item_sku_desc?: string | null, item_img_url?: Array<string> | null, tracability: TraceAbilityEnum, barcode?: string | null, qty: number, so_qty?: number | null, uom_id?: number | null, uom_name?: string | null, price_per_unit?: number | null, discount?: number | null, vat_percentage?: string | null, volume: number, weight: number, pre_vat_amount?: number | null, withholding_tax_type?: string | null, withholding_tax_value?: number | null, remark?: string | null, stock_qty?: number | null, qty_shipped?: number | null, qty_to_ship?: number | null, qty_invoiced?: number | null, qty_returned?: number | null, qty_issued?: number | null, qty_received?: number | null, branch_id: number, reference_line_item?: { __typename?: 'ReferenceSalesLineItem', line_item_unique_id: string, line_item_document_type: string } | null } | null> | null } };

export type QuotationFindUniqueQueryVariables = Exact<{
  uniqueInput: QuotationUniqueInput;
}>;


export type QuotationFindUniqueQuery = { __typename?: 'Query', QuotationFindUnique: { __typename?: 'Quotation', id: number, unique_id: string, branch_id: number, reference_no?: string | null, related_user_list?: Array<any> | null, created_date: any, created_by: any, last_updated_date?: any | null, issue_date?: any | null, due_date?: any | null, credit_day?: number | null, price_vat_type?: PriceVatType | null, currency?: string | null, item_price_list_id?: number | null, accepted_date?: any | null, pre_vat_amount?: number | null, additional_discount?: number | null, additional_discount_type?: AdditionalDiscountType | null, post_discount_amount?: number | null, vat_exempted_amount?: number | null, vat_0_percent_amount?: number | null, vat_7_percent_amount?: number | null, vat_amount?: number | null, net_amount?: number | null, withholding_tax_amount?: number | null, total_amount?: number | null, template_remark_id?: string | null, remark?: string | null, accepted_remark?: string | null, main_status?: string | null, sub_status?: string | null, flag_status?: Array<string> | null, aggrid_status?: string | null, customer_unique_id?: string | null, customer_details?: any | null, sales_type?: string | null, sales_channel_id?: number | null, account_id?: string | null, tag_id_list?: Array<number> | null, attachment_list?: Array<any | null> | null, approval_step?: number | null, approver_list?: Array<any | null> | null, reviewer_list?: Array<any | null> | null, contact_person_list?: Array<any> | null, branch: { __typename?: 'Branch', id: number, name: string, unique_id: string, is_hq: boolean }, item_price_list?: { __typename?: 'ItemPriceList', adjusted_price?: number | null, is_increase: number, name: string, is_active: number, end_date?: any | null, description?: string | null, currency?: string | null, adjusted_item_list?: Array<{ __typename?: 'ItemAdjustment', id: number, sku_name: string, item_name: string, reference_unique_id?: string | null, current_price?: number | null, adjusted_price?: number | null } | null> | null } | null, sales_channel?: { __typename?: 'SalesChannel', id: number, name_en: string, name_th: string, unique_id: string } | null, tag_list?: Array<{ __typename?: 'Tag', document_type: TagDocumentType, id: number, name: string } | null> | null, item_list?: Array<{ __typename?: 'SalesItem', id: number, unique_id: string, reference_unique_id: string, reference_document_type: SalesReferenceDocumentType, item_unique_id: string, item_sku_name: string, item_name?: string | null, item_sku_desc?: string | null, item_img_url?: Array<string> | null, tracability: TraceAbilityEnum, barcode?: string | null, qty: number, so_qty?: number | null, uom_id?: number | null, uom_name?: string | null, price_per_unit?: number | null, discount?: number | null, vat_percentage?: string | null, volume: number, weight: number, pre_vat_amount?: number | null, withholding_tax_type?: string | null, withholding_tax_value?: number | null, remark?: string | null, stock_qty?: number | null, qty_shipped?: number | null, qty_to_ship?: number | null, qty_invoiced?: number | null, qty_returned?: number | null, qty_issued?: number | null, qty_received?: number | null, branch_id: number, reference_line_item?: { __typename?: 'ReferenceSalesLineItem', line_item_unique_id: string, line_item_document_type: string } | null } | null> | null } };

export type QuotationUpdateMutationVariables = Exact<{
  uniqueInput: QuotationUniqueInput;
  input: QuotationUpdateInput;
}>;


export type QuotationUpdateMutation = { __typename?: 'Mutation', QuotationUpdate: { __typename?: 'Quotation', id: number, unique_id: string, branch_id: number, reference_no?: string | null, related_user_list?: Array<any> | null, created_date: any, created_by: any, last_updated_date?: any | null, issue_date?: any | null, due_date?: any | null, credit_day?: number | null, price_vat_type?: PriceVatType | null, currency?: string | null, item_price_list_id?: number | null, accepted_date?: any | null, pre_vat_amount?: number | null, additional_discount?: number | null, additional_discount_type?: AdditionalDiscountType | null, post_discount_amount?: number | null, vat_exempted_amount?: number | null, vat_0_percent_amount?: number | null, vat_7_percent_amount?: number | null, vat_amount?: number | null, net_amount?: number | null, withholding_tax_amount?: number | null, total_amount?: number | null, template_remark_id?: string | null, remark?: string | null, accepted_remark?: string | null, main_status?: string | null, sub_status?: string | null, flag_status?: Array<string> | null, aggrid_status?: string | null, customer_unique_id?: string | null, customer_details?: any | null, sales_type?: string | null, sales_channel_id?: number | null, account_id?: string | null, tag_id_list?: Array<number> | null, attachment_list?: Array<any | null> | null, approval_step?: number | null, approver_list?: Array<any | null> | null, reviewer_list?: Array<any | null> | null, contact_person_list?: Array<any> | null, branch: { __typename?: 'Branch', id: number, name: string, unique_id: string, is_hq: boolean }, item_price_list?: { __typename?: 'ItemPriceList', adjusted_price?: number | null, is_increase: number, name: string, is_active: number, end_date?: any | null, description?: string | null, currency?: string | null, adjusted_item_list?: Array<{ __typename?: 'ItemAdjustment', id: number, sku_name: string, item_name: string, reference_unique_id?: string | null, current_price?: number | null, adjusted_price?: number | null } | null> | null } | null, sales_channel?: { __typename?: 'SalesChannel', id: number, name_en: string, name_th: string, unique_id: string } | null, tag_list?: Array<{ __typename?: 'Tag', document_type: TagDocumentType, id: number, name: string } | null> | null, item_list?: Array<{ __typename?: 'SalesItem', id: number, unique_id: string, reference_unique_id: string, reference_document_type: SalesReferenceDocumentType, item_unique_id: string, item_sku_name: string, item_name?: string | null, item_sku_desc?: string | null, item_img_url?: Array<string> | null, tracability: TraceAbilityEnum, barcode?: string | null, qty: number, so_qty?: number | null, uom_id?: number | null, uom_name?: string | null, price_per_unit?: number | null, discount?: number | null, vat_percentage?: string | null, volume: number, weight: number, pre_vat_amount?: number | null, withholding_tax_type?: string | null, withholding_tax_value?: number | null, remark?: string | null, stock_qty?: number | null, qty_shipped?: number | null, qty_to_ship?: number | null, qty_invoiced?: number | null, qty_returned?: number | null, qty_issued?: number | null, qty_received?: number | null, branch_id: number, reference_line_item?: { __typename?: 'ReferenceSalesLineItem', line_item_unique_id: string, line_item_document_type: string } | null } | null> | null } };

export type SalesInvoiceCreateMutationVariables = Exact<{
  input: SalesInvoiceCreateInput;
}>;


export type SalesInvoiceCreateMutation = { __typename?: 'Mutation', SalesInvoiceCreate: { __typename?: 'SalesInvoice', id: number, unique_id: string, branch_id: number, reference_document_list?: Array<any> | null, reference_no?: string | null, external_reference_no?: string | null, created_date: any, created_by: any, issue_date: any, due_date: any, credit_day?: number | null, related_user_list?: Array<any> | null, sales_type?: string | null, sales_channel_id?: number | null, price_vat_type: PriceVatType, currency: string, pre_vat_amount?: number | null, additional_discount?: number | null, additional_discount_type?: AdditionalDiscountType | null, post_discount_amount?: number | null, vat_exempted_amount?: number | null, vat_0_percent_amount?: number | null, vat_7_percent_amount?: number | null, vat_amount?: number | null, net_amount?: number | null, withholding_tax_amount?: number | null, total_amount?: number | null, template_remark_id?: string | null, remark?: string | null, tag_id_list?: Array<number> | null, main_status?: string | null, sub_status?: string | null, flag_status?: Array<string> | null, aggrid_status?: string | null, approval_step?: number | null, approver_list?: Array<any> | null, reviewer_list?: Array<any> | null, last_updated_date?: any | null, item_price_list_id?: number | null, customer_unique_id: string, customer_details: any, need_tax_invoice?: boolean | null, tax_invoice_no?: string | null, tax_invoice_date?: any | null, paid_total_amount?: number | null, paid_net_amount?: number | null, payment_total_amount?: number | null, deduction_total_amount?: number | null, contact_person_list?: Array<any> | null, is_original_print?: any | null, branch?: { __typename?: 'Branch', id: number, name: string, unique_id: string, is_hq: boolean } | null, sales_channel?: { __typename?: 'SalesChannel', id: number, name_en: string, name_th: string, unique_id: string } | null, tag_list?: Array<{ __typename?: 'Tag', document_type: TagDocumentType, id: number, name: string }> | null, item_list?: Array<{ __typename?: 'SalesItem', id: number, unique_id: string, branch_id: number, reference_unique_id: string, reference_document_type: SalesReferenceDocumentType, item_unique_id: string, item_sku_name: string, item_name?: string | null, item_sku_desc?: string | null, item_img_url?: Array<string> | null, tracability: TraceAbilityEnum, barcode?: string | null, qty: number, so_qty?: number | null, uom_id?: number | null, uom_name?: string | null, price_per_unit?: number | null, discount?: number | null, vat_percentage?: string | null, volume: number, weight: number, pre_vat_amount?: number | null, withholding_tax_type?: string | null, withholding_tax_value?: number | null, remark?: string | null, stock_qty?: number | null, qty_shipped?: number | null, qty_to_ship?: number | null, qty_invoiced?: number | null, qty_returned?: number | null, qty_issued?: number | null, qty_received?: number | null, reference_line_item?: { __typename?: 'ReferenceSalesLineItem', line_item_unique_id: string, line_item_document_type: string } | null }> | null, item_price_list?: { __typename?: 'ItemPriceList', adjusted_price?: number | null, is_increase: number, name: string, is_active: number, end_date?: any | null, description?: string | null, currency?: string | null, adjusted_item_list?: Array<{ __typename?: 'ItemAdjustment', id: number, sku_name: string, item_name: string, reference_unique_id?: string | null, current_price?: number | null, adjusted_price?: number | null } | null> | null } | null, deduction_document_list?: Array<{ __typename?: 'SalesDeduction', id: number, reference_unique_id: string, reference_document_type: SalesReferenceDocumentType, branch_id: number, document_type?: string | null, document_unique_id?: string | null, deduction_amount?: number | null, credit_balance?: number | null, deduction_issue_date?: any | null, remark?: string | null }> | null, payment_list?: Array<{ __typename?: 'SalesPayment', id: number, reference_unique_id: string, reference_document_type: SalesReferenceDocumentType, branch_id: number, payment_channel_id?: number | null, payment_channel_unique_id?: string | null, payment_channel_payment_name?: string | null, payment_channel_name?: string | null, payment_amount?: number | null, payment_date?: any | null, cheque_provider?: string | null, cheque_no?: string | null, cheque_date?: any | null, is_withholding_tax?: boolean | null, withholding_tax_rate?: string | null, withholding_tax_amount?: number | null, remark?: string | null }> | null } };

export type SalesInvoiceFindUniqueQueryVariables = Exact<{
  uniqueInput: SalesInvoiceUniqueInput;
}>;


export type SalesInvoiceFindUniqueQuery = { __typename?: 'Query', SalesInvoiceFindUnique: { __typename?: 'SalesInvoice', id: number, unique_id: string, branch_id: number, reference_document_list?: Array<any> | null, reference_no?: string | null, external_reference_no?: string | null, created_date: any, created_by: any, issue_date: any, due_date: any, credit_day?: number | null, related_user_list?: Array<any> | null, sales_type?: string | null, sales_channel_id?: number | null, price_vat_type: PriceVatType, currency: string, pre_vat_amount?: number | null, additional_discount?: number | null, additional_discount_type?: AdditionalDiscountType | null, post_discount_amount?: number | null, vat_exempted_amount?: number | null, vat_0_percent_amount?: number | null, vat_7_percent_amount?: number | null, vat_amount?: number | null, net_amount?: number | null, withholding_tax_amount?: number | null, total_amount?: number | null, template_remark_id?: string | null, remark?: string | null, tag_id_list?: Array<number> | null, main_status?: string | null, sub_status?: string | null, flag_status?: Array<string> | null, aggrid_status?: string | null, approval_step?: number | null, approver_list?: Array<any> | null, reviewer_list?: Array<any> | null, last_updated_date?: any | null, item_price_list_id?: number | null, customer_unique_id: string, customer_details: any, need_tax_invoice?: boolean | null, tax_invoice_no?: string | null, tax_invoice_date?: any | null, paid_total_amount?: number | null, paid_net_amount?: number | null, payment_total_amount?: number | null, deduction_total_amount?: number | null, contact_person_list?: Array<any> | null, is_original_print?: any | null, branch?: { __typename?: 'Branch', id: number, name: string, unique_id: string, is_hq: boolean } | null, sales_channel?: { __typename?: 'SalesChannel', id: number, name_en: string, name_th: string, unique_id: string } | null, tag_list?: Array<{ __typename?: 'Tag', document_type: TagDocumentType, id: number, name: string }> | null, item_list?: Array<{ __typename?: 'SalesItem', id: number, unique_id: string, branch_id: number, reference_unique_id: string, reference_document_type: SalesReferenceDocumentType, item_unique_id: string, item_sku_name: string, item_name?: string | null, item_sku_desc?: string | null, item_img_url?: Array<string> | null, tracability: TraceAbilityEnum, barcode?: string | null, qty: number, so_qty?: number | null, uom_id?: number | null, uom_name?: string | null, price_per_unit?: number | null, discount?: number | null, vat_percentage?: string | null, volume: number, weight: number, pre_vat_amount?: number | null, withholding_tax_type?: string | null, withholding_tax_value?: number | null, remark?: string | null, stock_qty?: number | null, qty_shipped?: number | null, qty_to_ship?: number | null, qty_invoiced?: number | null, qty_returned?: number | null, qty_issued?: number | null, qty_received?: number | null, reference_line_item?: { __typename?: 'ReferenceSalesLineItem', line_item_unique_id: string, line_item_document_type: string } | null }> | null, item_price_list?: { __typename?: 'ItemPriceList', adjusted_price?: number | null, is_increase: number, name: string, is_active: number, end_date?: any | null, description?: string | null, currency?: string | null, adjusted_item_list?: Array<{ __typename?: 'ItemAdjustment', id: number, sku_name: string, item_name: string, reference_unique_id?: string | null, current_price?: number | null, adjusted_price?: number | null } | null> | null } | null, deduction_document_list?: Array<{ __typename?: 'SalesDeduction', id: number, reference_unique_id: string, reference_document_type: SalesReferenceDocumentType, branch_id: number, document_type?: string | null, document_unique_id?: string | null, deduction_amount?: number | null, credit_balance?: number | null, deduction_issue_date?: any | null, remark?: string | null }> | null, payment_list?: Array<{ __typename?: 'SalesPayment', id: number, reference_unique_id: string, reference_document_type: SalesReferenceDocumentType, branch_id: number, payment_channel_id?: number | null, payment_channel_unique_id?: string | null, payment_channel_payment_name?: string | null, payment_channel_name?: string | null, payment_amount?: number | null, payment_date?: any | null, cheque_provider?: string | null, cheque_no?: string | null, cheque_date?: any | null, is_withholding_tax?: boolean | null, withholding_tax_rate?: string | null, withholding_tax_amount?: number | null, remark?: string | null }> | null } };

export type SalesInvoiceUpdateMutationVariables = Exact<{
  uniqueInput: SalesInvoiceUniqueInput;
  input: SalesInvoiceUpdateInput;
}>;


export type SalesInvoiceUpdateMutation = { __typename?: 'Mutation', SalesInvoiceUpdate: { __typename?: 'SalesInvoice', id: number, unique_id: string, branch_id: number, reference_document_list?: Array<any> | null, reference_no?: string | null, external_reference_no?: string | null, created_date: any, created_by: any, issue_date: any, due_date: any, credit_day?: number | null, related_user_list?: Array<any> | null, sales_type?: string | null, sales_channel_id?: number | null, price_vat_type: PriceVatType, currency: string, pre_vat_amount?: number | null, additional_discount?: number | null, additional_discount_type?: AdditionalDiscountType | null, post_discount_amount?: number | null, vat_exempted_amount?: number | null, vat_0_percent_amount?: number | null, vat_7_percent_amount?: number | null, vat_amount?: number | null, net_amount?: number | null, withholding_tax_amount?: number | null, total_amount?: number | null, template_remark_id?: string | null, remark?: string | null, tag_id_list?: Array<number> | null, main_status?: string | null, sub_status?: string | null, flag_status?: Array<string> | null, aggrid_status?: string | null, approval_step?: number | null, approver_list?: Array<any> | null, reviewer_list?: Array<any> | null, last_updated_date?: any | null, item_price_list_id?: number | null, customer_unique_id: string, customer_details: any, need_tax_invoice?: boolean | null, tax_invoice_no?: string | null, tax_invoice_date?: any | null, paid_total_amount?: number | null, paid_net_amount?: number | null, payment_total_amount?: number | null, deduction_total_amount?: number | null, contact_person_list?: Array<any> | null, is_original_print?: any | null, branch?: { __typename?: 'Branch', id: number, name: string, unique_id: string, is_hq: boolean } | null, sales_channel?: { __typename?: 'SalesChannel', id: number, name_en: string, name_th: string, unique_id: string } | null, tag_list?: Array<{ __typename?: 'Tag', document_type: TagDocumentType, id: number, name: string }> | null, item_list?: Array<{ __typename?: 'SalesItem', id: number, unique_id: string, branch_id: number, reference_unique_id: string, reference_document_type: SalesReferenceDocumentType, item_unique_id: string, item_sku_name: string, item_name?: string | null, item_sku_desc?: string | null, item_img_url?: Array<string> | null, tracability: TraceAbilityEnum, barcode?: string | null, qty: number, so_qty?: number | null, uom_id?: number | null, uom_name?: string | null, price_per_unit?: number | null, discount?: number | null, vat_percentage?: string | null, volume: number, weight: number, pre_vat_amount?: number | null, withholding_tax_type?: string | null, withholding_tax_value?: number | null, remark?: string | null, stock_qty?: number | null, qty_shipped?: number | null, qty_to_ship?: number | null, qty_invoiced?: number | null, qty_returned?: number | null, qty_issued?: number | null, qty_received?: number | null, reference_line_item?: { __typename?: 'ReferenceSalesLineItem', line_item_unique_id: string, line_item_document_type: string } | null }> | null, item_price_list?: { __typename?: 'ItemPriceList', adjusted_price?: number | null, is_increase: number, name: string, is_active: number, end_date?: any | null, description?: string | null, currency?: string | null, adjusted_item_list?: Array<{ __typename?: 'ItemAdjustment', id: number, sku_name: string, item_name: string, reference_unique_id?: string | null, current_price?: number | null, adjusted_price?: number | null } | null> | null } | null, deduction_document_list?: Array<{ __typename?: 'SalesDeduction', id: number, reference_unique_id: string, reference_document_type: SalesReferenceDocumentType, branch_id: number, document_type?: string | null, document_unique_id?: string | null, deduction_amount?: number | null, credit_balance?: number | null, deduction_issue_date?: any | null, remark?: string | null }> | null, payment_list?: Array<{ __typename?: 'SalesPayment', id: number, reference_unique_id: string, reference_document_type: SalesReferenceDocumentType, branch_id: number, payment_channel_id?: number | null, payment_channel_unique_id?: string | null, payment_channel_payment_name?: string | null, payment_channel_name?: string | null, payment_amount?: number | null, payment_date?: any | null, cheque_provider?: string | null, cheque_no?: string | null, cheque_date?: any | null, is_withholding_tax?: boolean | null, withholding_tax_rate?: string | null, withholding_tax_amount?: number | null, remark?: string | null }> | null } };

export type SalesItemFindManyQueryVariables = Exact<{
  input?: InputMaybe<SalesItemFindManyInput>;
}>;


export type SalesItemFindManyQuery = { __typename?: 'Query', SalesItemFindMany?: Array<{ __typename?: 'SalesItem', id: number, unique_id: string, branch_id: number, reference_unique_id: string, reference_document_type: SalesReferenceDocumentType, item_unique_id: string, item_sku_name: string, item_name?: string | null, item_sku_desc?: string | null, item_img_url?: Array<string> | null, tracability: TraceAbilityEnum, barcode?: string | null, qty: number, so_qty?: number | null, uom_id?: number | null, uom_name?: string | null, price_per_unit?: number | null, discount?: number | null, vat_percentage?: string | null, volume: number, weight: number, pre_vat_amount?: number | null, withholding_tax_type?: string | null, withholding_tax_value?: number | null, remark?: string | null, stock_qty?: number | null, qty_shipped?: number | null, qty_to_ship?: number | null, qty_invoiced?: number | null, qty_returned?: number | null, qty_issued?: number | null, qty_received?: number | null, reference_line_item?: { __typename?: 'ReferenceSalesLineItem', line_item_unique_id: string, line_item_document_type: string } | null } | null> | null };

export type SalesOrderCanCreatePurchaseRequestQueryVariables = Exact<{
  uniqueInput: SalesOrderUniqueInput;
}>;


export type SalesOrderCanCreatePurchaseRequestQuery = { __typename?: 'Query', SalesOrderCanCreatePurchaseRequest: boolean };

export type SalesOrderCreateMutationVariables = Exact<{
  input: SalesOrderCreateInput;
}>;


export type SalesOrderCreateMutation = { __typename?: 'Mutation', SalesOrderCreate: { __typename?: 'SalesOrder', id: number, unique_id: string, branch_id: number, reference_document_list?: Array<any> | null, reference_no?: string | null, external_reference_no?: string | null, related_user_list?: Array<any> | null, sales_contact?: Array<any> | null, created_date: any, created_by: any, last_updated_date?: any | null, issue_date?: any | null, delivery_date?: any | null, due_date?: any | null, credit_day?: number | null, price_vat_type?: PriceVatType | null, currency?: string | null, item_price_list_id?: number | null, pre_vat_amount?: number | null, additional_discount?: number | null, additional_discount_type?: AdditionalDiscountType | null, post_discount_amount?: number | null, vat_exempted_amount?: number | null, vat_0_percent_amount?: number | null, vat_7_percent_amount?: number | null, vat_amount?: number | null, net_amount?: number | null, withholding_tax_amount?: number | null, total_amount?: number | null, remark?: string | null, main_status?: string | null, sub_status?: string | null, flag_status?: Array<string> | null, aggrid_status?: string | null, customer_unique_id?: string | null, customer_details?: any | null, sales_type?: string | null, sales_channel_id?: number | null, tag_id_list?: Array<number> | null, approval_step?: number | null, approver_list?: Array<any | null> | null, reviewer_list?: Array<any | null> | null, contact_person_list?: Array<any> | null, use_preorder_quota?: boolean | null, branch: { __typename?: 'Branch', id: number, name: string, unique_id: string, is_hq: boolean }, item_price_list?: { __typename?: 'ItemPriceList', adjusted_price?: number | null, is_increase: number, name: string, is_active: number, end_date?: any | null, description?: string | null, currency?: string | null, adjusted_item_list?: Array<{ __typename?: 'ItemAdjustment', id: number, sku_name: string, item_name: string, reference_unique_id?: string | null, current_price?: number | null, adjusted_price?: number | null } | null> | null } | null, sales_channel?: { __typename?: 'SalesChannel', id: number, name_en: string, name_th: string, unique_id: string } | null, tag_list?: Array<{ __typename?: 'Tag', document_type: TagDocumentType, id: number, name: string }> | null, item_list?: Array<{ __typename?: 'SalesItem', id: number, unique_id: string, reference_unique_id: string, reference_document_type: SalesReferenceDocumentType, item_unique_id: string, item_sku_name: string, item_name?: string | null, item_sku_desc?: string | null, item_img_url?: Array<string> | null, tracability: TraceAbilityEnum, barcode?: string | null, qty: number, so_qty?: number | null, uom_id?: number | null, uom_name?: string | null, price_per_unit?: number | null, discount?: number | null, vat_percentage?: string | null, volume: number, weight: number, pre_vat_amount?: number | null, withholding_tax_type?: string | null, withholding_tax_value?: number | null, remark?: string | null, stock_qty?: number | null, qty_shipped?: number | null, qty_to_ship?: number | null, qty_invoiced?: number | null, qty_returned?: number | null, qty_issued?: number | null, qty_received?: number | null, branch_id: number, applied_preorder_quota_setting_id?: number | null, reference_line_item?: { __typename?: 'ReferenceSalesLineItem', line_item_unique_id: string, line_item_document_type: string } | null }> | null } };

export type SalesOrderFindUniqueQueryVariables = Exact<{
  uniqueInput: SalesOrderUniqueInput;
}>;


export type SalesOrderFindUniqueQuery = { __typename?: 'Query', SalesOrderFindUnique: { __typename?: 'SalesOrder', id: number, unique_id: string, branch_id: number, reference_document_list?: Array<any> | null, reference_no?: string | null, external_reference_no?: string | null, related_user_list?: Array<any> | null, sales_contact?: Array<any> | null, created_date: any, created_by: any, last_updated_date?: any | null, issue_date?: any | null, delivery_date?: any | null, due_date?: any | null, credit_day?: number | null, price_vat_type?: PriceVatType | null, currency?: string | null, item_price_list_id?: number | null, pre_vat_amount?: number | null, additional_discount?: number | null, additional_discount_type?: AdditionalDiscountType | null, post_discount_amount?: number | null, vat_exempted_amount?: number | null, vat_0_percent_amount?: number | null, vat_7_percent_amount?: number | null, vat_amount?: number | null, net_amount?: number | null, withholding_tax_amount?: number | null, total_amount?: number | null, remark?: string | null, main_status?: string | null, sub_status?: string | null, flag_status?: Array<string> | null, aggrid_status?: string | null, customer_unique_id?: string | null, customer_details?: any | null, sales_type?: string | null, sales_channel_id?: number | null, tag_id_list?: Array<number> | null, approval_step?: number | null, approver_list?: Array<any | null> | null, reviewer_list?: Array<any | null> | null, contact_person_list?: Array<any> | null, use_preorder_quota?: boolean | null, branch: { __typename?: 'Branch', id: number, name: string, unique_id: string, is_hq: boolean }, item_price_list?: { __typename?: 'ItemPriceList', adjusted_price?: number | null, is_increase: number, name: string, is_active: number, end_date?: any | null, description?: string | null, currency?: string | null, adjusted_item_list?: Array<{ __typename?: 'ItemAdjustment', id: number, sku_name: string, item_name: string, reference_unique_id?: string | null, current_price?: number | null, adjusted_price?: number | null } | null> | null } | null, sales_channel?: { __typename?: 'SalesChannel', id: number, name_en: string, name_th: string, unique_id: string } | null, tag_list?: Array<{ __typename?: 'Tag', document_type: TagDocumentType, id: number, name: string }> | null, item_list?: Array<{ __typename?: 'SalesItem', id: number, unique_id: string, reference_unique_id: string, reference_document_type: SalesReferenceDocumentType, item_unique_id: string, item_sku_name: string, item_name?: string | null, item_sku_desc?: string | null, item_img_url?: Array<string> | null, tracability: TraceAbilityEnum, barcode?: string | null, qty: number, so_qty?: number | null, uom_id?: number | null, uom_name?: string | null, price_per_unit?: number | null, discount?: number | null, vat_percentage?: string | null, volume: number, weight: number, pre_vat_amount?: number | null, withholding_tax_type?: string | null, withholding_tax_value?: number | null, remark?: string | null, stock_qty?: number | null, qty_shipped?: number | null, qty_to_ship?: number | null, qty_invoiced?: number | null, qty_returned?: number | null, qty_issued?: number | null, qty_received?: number | null, branch_id: number, applied_preorder_quota_setting_id?: number | null, reference_line_item?: { __typename?: 'ReferenceSalesLineItem', line_item_unique_id: string, line_item_document_type: string } | null }> | null } };

export type SalesOrderUpdateMutationVariables = Exact<{
  uniqueInput: SalesOrderUniqueInput;
  input: SalesOrderUpdateInput;
}>;


export type SalesOrderUpdateMutation = { __typename?: 'Mutation', SalesOrderUpdate: { __typename?: 'SalesOrder', id: number, unique_id: string, branch_id: number, reference_document_list?: Array<any> | null, reference_no?: string | null, external_reference_no?: string | null, related_user_list?: Array<any> | null, sales_contact?: Array<any> | null, created_date: any, created_by: any, last_updated_date?: any | null, issue_date?: any | null, delivery_date?: any | null, due_date?: any | null, credit_day?: number | null, price_vat_type?: PriceVatType | null, currency?: string | null, item_price_list_id?: number | null, pre_vat_amount?: number | null, additional_discount?: number | null, additional_discount_type?: AdditionalDiscountType | null, post_discount_amount?: number | null, vat_exempted_amount?: number | null, vat_0_percent_amount?: number | null, vat_7_percent_amount?: number | null, vat_amount?: number | null, net_amount?: number | null, withholding_tax_amount?: number | null, total_amount?: number | null, remark?: string | null, main_status?: string | null, sub_status?: string | null, flag_status?: Array<string> | null, aggrid_status?: string | null, customer_unique_id?: string | null, customer_details?: any | null, sales_type?: string | null, sales_channel_id?: number | null, tag_id_list?: Array<number> | null, approval_step?: number | null, approver_list?: Array<any | null> | null, reviewer_list?: Array<any | null> | null, contact_person_list?: Array<any> | null, use_preorder_quota?: boolean | null, branch: { __typename?: 'Branch', id: number, name: string, unique_id: string, is_hq: boolean }, item_price_list?: { __typename?: 'ItemPriceList', adjusted_price?: number | null, is_increase: number, name: string, is_active: number, end_date?: any | null, description?: string | null, currency?: string | null, adjusted_item_list?: Array<{ __typename?: 'ItemAdjustment', id: number, sku_name: string, item_name: string, reference_unique_id?: string | null, current_price?: number | null, adjusted_price?: number | null } | null> | null } | null, sales_channel?: { __typename?: 'SalesChannel', id: number, name_en: string, name_th: string, unique_id: string } | null, tag_list?: Array<{ __typename?: 'Tag', document_type: TagDocumentType, id: number, name: string }> | null, item_list?: Array<{ __typename?: 'SalesItem', id: number, unique_id: string, reference_unique_id: string, reference_document_type: SalesReferenceDocumentType, item_unique_id: string, item_sku_name: string, item_name?: string | null, item_sku_desc?: string | null, item_img_url?: Array<string> | null, tracability: TraceAbilityEnum, barcode?: string | null, qty: number, so_qty?: number | null, uom_id?: number | null, uom_name?: string | null, price_per_unit?: number | null, discount?: number | null, vat_percentage?: string | null, volume: number, weight: number, pre_vat_amount?: number | null, withholding_tax_type?: string | null, withholding_tax_value?: number | null, remark?: string | null, stock_qty?: number | null, qty_shipped?: number | null, qty_to_ship?: number | null, qty_invoiced?: number | null, qty_returned?: number | null, qty_issued?: number | null, qty_received?: number | null, branch_id: number, applied_preorder_quota_setting_id?: number | null, reference_line_item?: { __typename?: 'ReferenceSalesLineItem', line_item_unique_id: string, line_item_document_type: string } | null }> | null } };

export type SalesOriginalPrintMutationVariables = Exact<{
  input: SalesOriginalPrintInput;
}>;


export type SalesOriginalPrintMutation = { __typename?: 'Mutation', SalesOriginalPrint?: { __typename?: 'SalesOriginalPrintOutput', id: number, unique_id: string, is_original_print?: any | null } | null };

export type SalesReturnCreateMutationVariables = Exact<{
  input: SalesReturnCreateInput;
}>;


export type SalesReturnCreateMutation = { __typename?: 'Mutation', SalesReturnCreate: { __typename?: 'SalesReturn', id: number, unique_id: string, branch_id: number, reference_document_list?: Array<any> | null, reference_no?: string | null, external_reference_no?: string | null, created_date: any, created_by: any, issue_date: any, due_date: any, credit_day?: number | null, related_user_list?: Array<any> | null, reason_to_return?: string | null, is_effect_stock?: boolean | null, sales_type?: string | null, sales_channel_id?: number | null, price_vat_type?: PriceVatType | null, currency?: string | null, pre_vat_amount?: number | null, additional_discount?: number | null, additional_discount_type?: AdditionalDiscountType | null, post_discount_amount?: number | null, vat_exempted_amount?: number | null, vat_0_percent_amount?: number | null, vat_7_percent_amount?: number | null, vat_amount?: number | null, net_amount?: number | null, withholding_tax_amount?: number | null, total_amount?: number | null, template_remark_id?: string | null, remark?: string | null, tag_id_list?: Array<number> | null, main_status?: string | null, sub_status?: string | null, flag_status?: Array<string> | null, aggrid_status?: string | null, approval_step?: number | null, approver_list?: Array<any> | null, reviewer_list?: Array<any> | null, last_updated_date?: any | null, item_price_list_id?: number | null, customer_unique_id?: string | null, customer_details?: any | null, contact_person_list?: Array<any> | null, branch?: { __typename?: 'Branch', id: number, name: string, unique_id: string, is_hq: boolean } | null, sales_channel?: { __typename?: 'SalesChannel', id: number, name_en: string, name_th: string, unique_id: string } | null, tag_list?: Array<{ __typename?: 'Tag', document_type: TagDocumentType, id: number, name: string }> | null, item_list?: Array<{ __typename?: 'SalesItem', id: number, unique_id: string, branch_id: number, reference_unique_id: string, reference_document_type: SalesReferenceDocumentType, item_unique_id: string, item_sku_name: string, item_name?: string | null, item_sku_desc?: string | null, item_img_url?: Array<string> | null, tracability: TraceAbilityEnum, barcode?: string | null, qty: number, so_qty?: number | null, uom_id?: number | null, uom_name?: string | null, price_per_unit?: number | null, discount?: number | null, vat_percentage?: string | null, volume: number, weight: number, pre_vat_amount?: number | null, withholding_tax_type?: string | null, withholding_tax_value?: number | null, remark?: string | null, stock_qty?: number | null, qty_shipped?: number | null, qty_to_ship?: number | null, qty_invoiced?: number | null, qty_returned?: number | null, qty_issued?: number | null, qty_received?: number | null, reference_line_item?: { __typename?: 'ReferenceSalesLineItem', line_item_unique_id: string, line_item_document_type: string } | null }> | null, item_price_list?: { __typename?: 'ItemPriceList', adjusted_price?: number | null, is_increase: number, name: string, is_active: number, end_date?: any | null, description?: string | null, currency?: string | null, adjusted_item_list?: Array<{ __typename?: 'ItemAdjustment', id: number, sku_name: string, item_name: string, reference_unique_id?: string | null, current_price?: number | null, adjusted_price?: number | null } | null> | null } | null } };

export type SalesReturnFindUniqueQueryVariables = Exact<{
  uniqueInput: SalesReturnUniqueInput;
}>;


export type SalesReturnFindUniqueQuery = { __typename?: 'Query', SalesReturnFindUnique: { __typename?: 'SalesReturn', id: number, unique_id: string, branch_id: number, reference_document_list?: Array<any> | null, reference_no?: string | null, external_reference_no?: string | null, created_date: any, created_by: any, issue_date: any, due_date: any, credit_day?: number | null, related_user_list?: Array<any> | null, reason_to_return?: string | null, is_effect_stock?: boolean | null, sales_type?: string | null, sales_channel_id?: number | null, price_vat_type?: PriceVatType | null, currency?: string | null, pre_vat_amount?: number | null, additional_discount?: number | null, additional_discount_type?: AdditionalDiscountType | null, post_discount_amount?: number | null, vat_exempted_amount?: number | null, vat_0_percent_amount?: number | null, vat_7_percent_amount?: number | null, vat_amount?: number | null, net_amount?: number | null, withholding_tax_amount?: number | null, total_amount?: number | null, template_remark_id?: string | null, remark?: string | null, tag_id_list?: Array<number> | null, main_status?: string | null, sub_status?: string | null, flag_status?: Array<string> | null, aggrid_status?: string | null, approval_step?: number | null, approver_list?: Array<any> | null, reviewer_list?: Array<any> | null, last_updated_date?: any | null, item_price_list_id?: number | null, customer_unique_id?: string | null, customer_details?: any | null, contact_person_list?: Array<any> | null, branch?: { __typename?: 'Branch', id: number, name: string, unique_id: string, is_hq: boolean } | null, sales_channel?: { __typename?: 'SalesChannel', id: number, name_en: string, name_th: string, unique_id: string } | null, tag_list?: Array<{ __typename?: 'Tag', document_type: TagDocumentType, id: number, name: string }> | null, item_list?: Array<{ __typename?: 'SalesItem', id: number, unique_id: string, branch_id: number, reference_unique_id: string, reference_document_type: SalesReferenceDocumentType, item_unique_id: string, item_sku_name: string, item_name?: string | null, item_sku_desc?: string | null, item_img_url?: Array<string> | null, tracability: TraceAbilityEnum, barcode?: string | null, qty: number, so_qty?: number | null, uom_id?: number | null, uom_name?: string | null, price_per_unit?: number | null, discount?: number | null, vat_percentage?: string | null, volume: number, weight: number, pre_vat_amount?: number | null, withholding_tax_type?: string | null, withholding_tax_value?: number | null, remark?: string | null, stock_qty?: number | null, qty_shipped?: number | null, qty_to_ship?: number | null, qty_invoiced?: number | null, qty_returned?: number | null, qty_issued?: number | null, qty_received?: number | null, reference_line_item?: { __typename?: 'ReferenceSalesLineItem', line_item_unique_id: string, line_item_document_type: string } | null }> | null, item_price_list?: { __typename?: 'ItemPriceList', adjusted_price?: number | null, is_increase: number, name: string, is_active: number, end_date?: any | null, description?: string | null, currency?: string | null, adjusted_item_list?: Array<{ __typename?: 'ItemAdjustment', id: number, sku_name: string, item_name: string, reference_unique_id?: string | null, current_price?: number | null, adjusted_price?: number | null } | null> | null } | null } };

export type SalesReturnUpdateMutationVariables = Exact<{
  uniqueInput: SalesReturnUniqueInput;
  input: SalesReturnUpdateInput;
}>;


export type SalesReturnUpdateMutation = { __typename?: 'Mutation', SalesReturnUpdate: { __typename?: 'SalesReturn', id: number, unique_id: string, branch_id: number, reference_document_list?: Array<any> | null, reference_no?: string | null, external_reference_no?: string | null, created_date: any, created_by: any, issue_date: any, due_date: any, credit_day?: number | null, related_user_list?: Array<any> | null, reason_to_return?: string | null, is_effect_stock?: boolean | null, sales_type?: string | null, sales_channel_id?: number | null, price_vat_type?: PriceVatType | null, currency?: string | null, pre_vat_amount?: number | null, additional_discount?: number | null, additional_discount_type?: AdditionalDiscountType | null, post_discount_amount?: number | null, vat_exempted_amount?: number | null, vat_0_percent_amount?: number | null, vat_7_percent_amount?: number | null, vat_amount?: number | null, net_amount?: number | null, withholding_tax_amount?: number | null, total_amount?: number | null, template_remark_id?: string | null, remark?: string | null, tag_id_list?: Array<number> | null, main_status?: string | null, sub_status?: string | null, flag_status?: Array<string> | null, aggrid_status?: string | null, approval_step?: number | null, approver_list?: Array<any> | null, reviewer_list?: Array<any> | null, last_updated_date?: any | null, item_price_list_id?: number | null, customer_unique_id?: string | null, customer_details?: any | null, contact_person_list?: Array<any> | null, branch?: { __typename?: 'Branch', id: number, name: string, unique_id: string, is_hq: boolean } | null, sales_channel?: { __typename?: 'SalesChannel', id: number, name_en: string, name_th: string, unique_id: string } | null, tag_list?: Array<{ __typename?: 'Tag', document_type: TagDocumentType, id: number, name: string }> | null, item_list?: Array<{ __typename?: 'SalesItem', id: number, unique_id: string, branch_id: number, reference_unique_id: string, reference_document_type: SalesReferenceDocumentType, item_unique_id: string, item_sku_name: string, item_name?: string | null, item_sku_desc?: string | null, item_img_url?: Array<string> | null, tracability: TraceAbilityEnum, barcode?: string | null, qty: number, so_qty?: number | null, uom_id?: number | null, uom_name?: string | null, price_per_unit?: number | null, discount?: number | null, vat_percentage?: string | null, volume: number, weight: number, pre_vat_amount?: number | null, withholding_tax_type?: string | null, withholding_tax_value?: number | null, remark?: string | null, stock_qty?: number | null, qty_shipped?: number | null, qty_to_ship?: number | null, qty_invoiced?: number | null, qty_returned?: number | null, qty_issued?: number | null, qty_received?: number | null, reference_line_item?: { __typename?: 'ReferenceSalesLineItem', line_item_unique_id: string, line_item_document_type: string } | null }> | null, item_price_list?: { __typename?: 'ItemPriceList', adjusted_price?: number | null, is_increase: number, name: string, is_active: number, end_date?: any | null, description?: string | null, currency?: string | null, adjusted_item_list?: Array<{ __typename?: 'ItemAdjustment', id: number, sku_name: string, item_name: string, reference_unique_id?: string | null, current_price?: number | null, adjusted_price?: number | null } | null> | null } | null } };

export type SalesUniqueIdGenerateQueryVariables = Exact<{
  modelType: SalesModelType;
  usePreorderQuota?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SalesUniqueIdGenerateQuery = { __typename?: 'Query', UniqueIdGenerate: string };


export const CashSalesCreateDocument = `
    mutation CashSalesCreate($createInput: CashSalesCreateInput!) {
  CashSalesCreate(createInput: $createInput) {
    id
    unique_id
    branch_id
    branch {
      id
      name
      unique_id
      is_hq
    }
    reference_document_list
    reference_no
    external_reference_no
    related_user_list
    sales_contact
    created_date
    created_by
    last_updated_date
    issue_date
    due_date
    need_tax_invoice
    tax_invoice_no
    credit_day
    price_vat_type
    currency
    item_price_list_id
    item_price_list {
      adjusted_item_list {
        id
        sku_name
        item_name
        reference_unique_id
        current_price
        adjusted_price
      }
      adjusted_price
      is_increase
      name
      is_active
      end_date
      description
      currency
    }
    pre_vat_amount
    shipping_cost
    additional_discount
    additional_discount_type
    post_discount_amount
    vat_exempted_amount
    vat_0_percent_amount
    vat_7_percent_amount
    vat_amount
    net_amount
    withholding_tax_amount
    total_amount
    remark
    main_status
    sub_status
    flag_status
    aggrid_status
    customer_unique_id
    customer_details
    sales_type
    sales_channel_id
    sales_channel {
      id
      name_en
      name_th
      unique_id
    }
    tag_id_list
    tag_list {
      document_type
      id
      name
    }
    item_list {
      id
      unique_id
      reference_unique_id
      reference_document_type
      item_id
      item_unique_id
      item_sku_name
      item_name
      item_sku_desc
      item_img_url
      tracability
      barcode
      qty
      so_qty
      uom_id
      uom_name
      price_per_unit
      discount
      promotion_discount
      vat_percentage
      volume
      weight
      pre_vat_amount
      withholding_tax_type
      withholding_tax_value
      remark
      stock_qty
      qty_shipped
      qty_to_ship
      qty_invoiced
      qty_returned
      qty_issued
      qty_received
      branch_id
      reference_line_item {
        line_item_unique_id
        line_item_document_type
      }
    }
    approval_step
    approver_list
    reviewer_list
    paid_total_amount
    paid_net_amount
    payment_total_amount
    deduction_total_amount
    deduction_document_list {
      id
      reference_unique_id
      reference_document_type
      branch_id
      document_type
      document_unique_id
      deduction_amount
      credit_balance
      deduction_issue_date
      remark
    }
    payment_list {
      id
      reference_unique_id
      reference_document_type
      branch_id
      payment_channel_id
      payment_channel_unique_id
      payment_channel_payment_name
      payment_channel_name
      payment_amount
      payment_date
      cheque_provider
      cheque_no
      cheque_date
      is_withholding_tax
      withholding_tax_rate
      withholding_tax_amount
      remark
    }
    contact_person_list
    is_original_print
    promotion_list {
      id
      promotion_id
      promotion_unique_id
      name
      coupon_code
      discount_rate
      total_discount_amount
      priority
      receive_type
      redeem_item_list
      conditional_item_id_list
    }
  }
}
    `;
export const useCashSalesCreateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CashSalesCreateMutation, TError, CashSalesCreateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CashSalesCreateMutation, TError, CashSalesCreateMutationVariables, TContext>(
      ['CashSalesCreate'],
      (variables?: CashSalesCreateMutationVariables) => fetcher<CashSalesCreateMutation, CashSalesCreateMutationVariables>(client, CashSalesCreateDocument, variables, headers)(),
      options
    );
export const CashSalesFindUniqueDocument = `
    query CashSalesFindUnique($uniqueInput: CashSalesUniqueInput!) {
  CashSalesFindUnique(uniqueInput: $uniqueInput) {
    id
    unique_id
    branch_id
    branch {
      id
      name
      unique_id
      is_hq
    }
    reference_document_list
    reference_no
    external_reference_no
    related_user_list
    sales_contact
    created_date
    created_by
    last_updated_date
    issue_date
    due_date
    need_tax_invoice
    tax_invoice_no
    credit_day
    price_vat_type
    currency
    item_price_list_id
    item_price_list {
      adjusted_item_list {
        id
        sku_name
        item_name
        reference_unique_id
        current_price
        adjusted_price
      }
      adjusted_price
      is_increase
      name
      is_active
      end_date
      description
      currency
    }
    pre_vat_amount
    additional_discount
    additional_discount_type
    post_discount_amount
    vat_exempted_amount
    vat_0_percent_amount
    vat_7_percent_amount
    vat_amount
    net_amount
    withholding_tax_amount
    total_amount
    remark
    main_status
    sub_status
    flag_status
    aggrid_status
    customer_unique_id
    customer_details
    sales_type
    sales_channel_id
    sales_channel {
      id
      name_en
      name_th
      unique_id
    }
    tag_id_list
    tag_list {
      document_type
      id
      name
    }
    item_list {
      id
      unique_id
      reference_unique_id
      reference_document_type
      item_id
      item_unique_id
      item_sku_name
      item_name
      item_sku_desc
      item_img_url
      tracability
      barcode
      qty
      so_qty
      uom_id
      uom_name
      price_per_unit
      discount
      promotion_discount
      vat_percentage
      volume
      weight
      pre_vat_amount
      withholding_tax_type
      withholding_tax_value
      remark
      stock_qty
      qty_shipped
      qty_to_ship
      qty_invoiced
      qty_returned
      qty_issued
      qty_received
      branch_id
      reference_line_item {
        line_item_unique_id
        line_item_document_type
      }
    }
    approval_step
    approver_list
    reviewer_list
    paid_total_amount
    paid_net_amount
    payment_total_amount
    deduction_total_amount
    deduction_document_list {
      id
      reference_unique_id
      reference_document_type
      branch_id
      document_type
      document_unique_id
      deduction_amount
      credit_balance
      deduction_issue_date
      remark
    }
    payment_list {
      id
      reference_unique_id
      reference_document_type
      branch_id
      payment_channel_id
      payment_channel_unique_id
      payment_channel_payment_name
      payment_channel_name
      payment_amount
      payment_date
      cheque_provider
      cheque_no
      cheque_date
      is_withholding_tax
      withholding_tax_rate
      withholding_tax_amount
      remark
    }
    contact_person_list
    is_original_print
    promotion_list {
      id
      promotion_id
      promotion_unique_id
      name
      coupon_code
      discount_rate
      total_discount_amount
      priority
      receive_type
      redeem_item_list
      conditional_item_id_list
    }
  }
}
    `;
export const useCashSalesFindUniqueQuery = <
      TData = CashSalesFindUniqueQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: CashSalesFindUniqueQueryVariables,
      options?: UseQueryOptions<CashSalesFindUniqueQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CashSalesFindUniqueQuery, TError, TData>(
      ['CashSalesFindUnique', variables],
      fetcher<CashSalesFindUniqueQuery, CashSalesFindUniqueQueryVariables>(client, CashSalesFindUniqueDocument, variables, headers),
      options
    );
export const CashSalesUpdateDocument = `
    mutation CashSalesUpdate($uniqueInput: CashSalesUniqueInput!, $updateInput: CashSalesUpdateInput!) {
  CashSalesUpdate(uniqueInput: $uniqueInput, updateInput: $updateInput) {
    id
    unique_id
    branch_id
    branch {
      id
      name
      unique_id
      is_hq
    }
    reference_document_list
    reference_no
    external_reference_no
    related_user_list
    sales_contact
    created_date
    created_by
    last_updated_date
    issue_date
    due_date
    need_tax_invoice
    tax_invoice_no
    credit_day
    price_vat_type
    currency
    item_price_list_id
    item_price_list {
      adjusted_item_list {
        id
        sku_name
        item_name
        reference_unique_id
        current_price
        adjusted_price
      }
      adjusted_price
      is_increase
      name
      is_active
      end_date
      description
      currency
    }
    pre_vat_amount
    additional_discount
    additional_discount_type
    post_discount_amount
    vat_exempted_amount
    vat_0_percent_amount
    vat_7_percent_amount
    vat_amount
    net_amount
    withholding_tax_amount
    total_amount
    remark
    main_status
    sub_status
    flag_status
    aggrid_status
    customer_unique_id
    customer_details
    sales_type
    sales_channel_id
    sales_channel {
      id
      name_en
      name_th
      unique_id
    }
    tag_id_list
    tag_list {
      document_type
      id
      name
    }
    item_list {
      id
      unique_id
      reference_unique_id
      reference_document_type
      item_id
      item_unique_id
      item_sku_name
      item_name
      item_sku_desc
      item_img_url
      tracability
      barcode
      qty
      so_qty
      uom_id
      uom_name
      price_per_unit
      discount
      promotion_discount
      vat_percentage
      volume
      weight
      pre_vat_amount
      withholding_tax_type
      withholding_tax_value
      remark
      stock_qty
      qty_shipped
      qty_to_ship
      qty_invoiced
      qty_returned
      qty_issued
      qty_received
      branch_id
      reference_line_item {
        line_item_unique_id
        line_item_document_type
      }
    }
    approval_step
    approver_list
    reviewer_list
    paid_total_amount
    paid_net_amount
    payment_total_amount
    deduction_total_amount
    deduction_document_list {
      id
      reference_unique_id
      reference_document_type
      branch_id
      document_type
      document_unique_id
      deduction_amount
      credit_balance
      deduction_issue_date
      remark
    }
    payment_list {
      id
      reference_unique_id
      reference_document_type
      branch_id
      payment_channel_id
      payment_channel_unique_id
      payment_channel_payment_name
      payment_channel_name
      payment_amount
      payment_date
      cheque_provider
      cheque_no
      cheque_date
      is_withholding_tax
      withholding_tax_rate
      withholding_tax_amount
      remark
    }
    contact_person_list
    is_original_print
    promotion_list {
      id
      promotion_id
      promotion_unique_id
      name
      coupon_code
      discount_rate
      total_discount_amount
      priority
      receive_type
      redeem_item_list
      conditional_item_id_list
    }
  }
}
    `;
export const useCashSalesUpdateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CashSalesUpdateMutation, TError, CashSalesUpdateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CashSalesUpdateMutation, TError, CashSalesUpdateMutationVariables, TContext>(
      ['CashSalesUpdate'],
      (variables?: CashSalesUpdateMutationVariables) => fetcher<CashSalesUpdateMutation, CashSalesUpdateMutationVariables>(client, CashSalesUpdateDocument, variables, headers)(),
      options
    );
export const CustomerDepositCreateDocument = `
    mutation CustomerDepositCreate($input: CustomerDepositCreateInput!) {
  CustomerDepositCreate(input: $input) {
    id
    unique_id
    branch_id
    branch {
      id
      name
      unique_id
      is_hq
    }
    reference_document_list
    reference_no
    external_reference_no
    created_date
    created_by
    issue_date
    due_date
    need_tax_invoice
    tax_invoice_no
    tax_invoice_date
    related_user_list
    customer_unique_id
    customer_details
    price_vat_type
    currency
    deposit_list {
      id
      reference_document_id
      name
      vat_percentage
      pre_vat_amount
      withholding_tax_type
      withholding_tax_value
      remark
    }
    pre_vat_amount
    additional_discount
    additional_discount_type
    post_discount_amount
    vat_exempted_amount
    vat_0_percent_amount
    vat_7_percent_amount
    vat_amount
    net_amount
    withholding_tax_amount
    total_amount
    paid_net_amount
    paid_total_amount
    payment_total_amount
    remaining_deposit_amount
    remark
    tag_list {
      document_type
      id
      name
    }
    main_status
    sub_status
    flag_status
    aggrid_status
    last_updated_date
    last_updated_by
    payment_list {
      id
      reference_unique_id
      reference_document_type
      branch_id
      payment_channel_id
      payment_channel_unique_id
      payment_channel_payment_name
      payment_channel_name
      payment_amount
      payment_date
      cheque_provider
      cheque_no
      cheque_date
      is_withholding_tax
      withholding_tax_rate
      withholding_tax_amount
      remark
    }
    contact_person_list
    is_original_print
  }
}
    `;
export const useCustomerDepositCreateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CustomerDepositCreateMutation, TError, CustomerDepositCreateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CustomerDepositCreateMutation, TError, CustomerDepositCreateMutationVariables, TContext>(
      ['CustomerDepositCreate'],
      (variables?: CustomerDepositCreateMutationVariables) => fetcher<CustomerDepositCreateMutation, CustomerDepositCreateMutationVariables>(client, CustomerDepositCreateDocument, variables, headers)(),
      options
    );
export const CustomerDepositFindUniqueDocument = `
    query CustomerDepositFindUnique($uniqueInput: CustomerDepositUniqueInput!) {
  CustomerDepositFindUnique(uniqueInput: $uniqueInput) {
    id
    unique_id
    branch_id
    branch {
      id
      name
      unique_id
      is_hq
    }
    reference_document_list
    reference_no
    external_reference_no
    created_date
    created_by
    issue_date
    due_date
    need_tax_invoice
    tax_invoice_no
    tax_invoice_date
    related_user_list
    customer_unique_id
    customer_details
    price_vat_type
    currency
    deposit_list {
      id
      reference_document_id
      name
      vat_percentage
      pre_vat_amount
      withholding_tax_type
      withholding_tax_value
      remark
    }
    pre_vat_amount
    additional_discount
    additional_discount_type
    post_discount_amount
    vat_exempted_amount
    vat_0_percent_amount
    vat_7_percent_amount
    vat_amount
    net_amount
    withholding_tax_amount
    total_amount
    paid_net_amount
    paid_total_amount
    payment_total_amount
    remaining_deposit_amount
    remark
    tag_list {
      document_type
      id
      name
    }
    main_status
    sub_status
    flag_status
    aggrid_status
    last_updated_date
    last_updated_by
    payment_list {
      id
      reference_unique_id
      reference_document_type
      branch_id
      payment_channel_id
      payment_channel_unique_id
      payment_channel_payment_name
      payment_channel_name
      payment_amount
      payment_date
      cheque_provider
      cheque_no
      cheque_date
      is_withholding_tax
      withholding_tax_rate
      withholding_tax_amount
      remark
    }
    contact_person_list
    is_original_print
  }
}
    `;
export const useCustomerDepositFindUniqueQuery = <
      TData = CustomerDepositFindUniqueQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: CustomerDepositFindUniqueQueryVariables,
      options?: UseQueryOptions<CustomerDepositFindUniqueQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CustomerDepositFindUniqueQuery, TError, TData>(
      ['CustomerDepositFindUnique', variables],
      fetcher<CustomerDepositFindUniqueQuery, CustomerDepositFindUniqueQueryVariables>(client, CustomerDepositFindUniqueDocument, variables, headers),
      options
    );
export const CustomerDepositUpdateDocument = `
    mutation CustomerDepositUpdate($uniqueInput: CustomerDepositUniqueInput!, $input: CustomerDepositUpdateInput!) {
  CustomerDepositUpdate(uniqueInput: $uniqueInput, input: $input) {
    id
    unique_id
    branch_id
    branch {
      id
      name
      unique_id
      is_hq
    }
    reference_document_list
    reference_no
    external_reference_no
    created_date
    created_by
    issue_date
    due_date
    need_tax_invoice
    tax_invoice_no
    tax_invoice_date
    related_user_list
    customer_unique_id
    customer_details
    price_vat_type
    currency
    deposit_list {
      id
      reference_document_id
      name
      vat_percentage
      pre_vat_amount
      withholding_tax_type
      withholding_tax_value
      remark
    }
    pre_vat_amount
    additional_discount
    additional_discount_type
    post_discount_amount
    vat_exempted_amount
    vat_0_percent_amount
    vat_7_percent_amount
    vat_amount
    net_amount
    withholding_tax_amount
    total_amount
    paid_net_amount
    paid_total_amount
    payment_total_amount
    remaining_deposit_amount
    remark
    tag_list {
      document_type
      id
      name
    }
    main_status
    sub_status
    flag_status
    aggrid_status
    last_updated_date
    last_updated_by
    payment_list {
      id
      reference_unique_id
      reference_document_type
      branch_id
      payment_channel_id
      payment_channel_unique_id
      payment_channel_payment_name
      payment_channel_name
      payment_amount
      payment_date
      cheque_provider
      cheque_no
      cheque_date
      is_withholding_tax
      withholding_tax_rate
      withholding_tax_amount
      remark
    }
    contact_person_list
    is_original_print
  }
}
    `;
export const useCustomerDepositUpdateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CustomerDepositUpdateMutation, TError, CustomerDepositUpdateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CustomerDepositUpdateMutation, TError, CustomerDepositUpdateMutationVariables, TContext>(
      ['CustomerDepositUpdate'],
      (variables?: CustomerDepositUpdateMutationVariables) => fetcher<CustomerDepositUpdateMutation, CustomerDepositUpdateMutationVariables>(client, CustomerDepositUpdateDocument, variables, headers)(),
      options
    );
export const QuotationCreateDocument = `
    mutation QuotationCreate($input: QuotationCreateInput!) {
  QuotationCreate(input: $input) {
    id
    unique_id
    branch_id
    branch {
      id
      name
      unique_id
      is_hq
    }
    reference_no
    related_user_list
    created_date
    created_by
    last_updated_date
    issue_date
    due_date
    credit_day
    price_vat_type
    currency
    item_price_list_id
    item_price_list {
      adjusted_item_list {
        id
        sku_name
        item_name
        reference_unique_id
        current_price
        adjusted_price
      }
      adjusted_price
      is_increase
      name
      is_active
      end_date
      description
      currency
    }
    accepted_date
    pre_vat_amount
    additional_discount
    additional_discount_type
    post_discount_amount
    vat_exempted_amount
    vat_0_percent_amount
    vat_7_percent_amount
    vat_amount
    net_amount
    withholding_tax_amount
    total_amount
    template_remark_id
    remark
    accepted_remark
    main_status
    sub_status
    flag_status
    aggrid_status
    customer_unique_id
    customer_details
    sales_type
    sales_channel_id
    sales_channel {
      id
      name_en
      name_th
      unique_id
    }
    account_id
    tag_id_list
    tag_list {
      document_type
      id
      name
    }
    item_list {
      id
      unique_id
      reference_unique_id
      reference_document_type
      item_unique_id
      item_sku_name
      item_name
      item_sku_desc
      item_img_url
      tracability
      barcode
      qty
      so_qty
      uom_id
      uom_name
      price_per_unit
      discount
      vat_percentage
      volume
      weight
      pre_vat_amount
      withholding_tax_type
      withholding_tax_value
      remark
      stock_qty
      qty_shipped
      qty_to_ship
      qty_invoiced
      qty_returned
      qty_issued
      qty_received
      branch_id
      reference_line_item {
        line_item_unique_id
        line_item_document_type
      }
    }
    attachment_list
    approval_step
    approver_list
    reviewer_list
    contact_person_list
  }
}
    `;
export const useQuotationCreateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<QuotationCreateMutation, TError, QuotationCreateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<QuotationCreateMutation, TError, QuotationCreateMutationVariables, TContext>(
      ['QuotationCreate'],
      (variables?: QuotationCreateMutationVariables) => fetcher<QuotationCreateMutation, QuotationCreateMutationVariables>(client, QuotationCreateDocument, variables, headers)(),
      options
    );
export const QuotationFindUniqueDocument = `
    query QuotationFindUnique($uniqueInput: QuotationUniqueInput!) {
  QuotationFindUnique(uniqueInput: $uniqueInput) {
    id
    unique_id
    branch_id
    branch {
      id
      name
      unique_id
      is_hq
    }
    reference_no
    related_user_list
    created_date
    created_by
    last_updated_date
    issue_date
    due_date
    credit_day
    price_vat_type
    currency
    item_price_list_id
    item_price_list {
      adjusted_item_list {
        id
        sku_name
        item_name
        reference_unique_id
        current_price
        adjusted_price
      }
      adjusted_price
      is_increase
      name
      is_active
      end_date
      description
      currency
    }
    accepted_date
    pre_vat_amount
    additional_discount
    additional_discount_type
    post_discount_amount
    vat_exempted_amount
    vat_0_percent_amount
    vat_7_percent_amount
    vat_amount
    net_amount
    withholding_tax_amount
    total_amount
    template_remark_id
    remark
    accepted_remark
    main_status
    sub_status
    flag_status
    aggrid_status
    customer_unique_id
    customer_details
    sales_type
    sales_channel_id
    sales_channel {
      id
      name_en
      name_th
      unique_id
    }
    account_id
    tag_id_list
    tag_list {
      document_type
      id
      name
    }
    item_list {
      id
      unique_id
      reference_unique_id
      reference_document_type
      item_unique_id
      item_sku_name
      item_name
      item_sku_desc
      item_img_url
      tracability
      barcode
      qty
      so_qty
      uom_id
      uom_name
      price_per_unit
      discount
      vat_percentage
      volume
      weight
      pre_vat_amount
      withholding_tax_type
      withholding_tax_value
      remark
      stock_qty
      qty_shipped
      qty_to_ship
      qty_invoiced
      qty_returned
      qty_issued
      qty_received
      branch_id
      reference_line_item {
        line_item_unique_id
        line_item_document_type
      }
    }
    attachment_list
    approval_step
    approver_list
    reviewer_list
    contact_person_list
  }
}
    `;
export const useQuotationFindUniqueQuery = <
      TData = QuotationFindUniqueQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: QuotationFindUniqueQueryVariables,
      options?: UseQueryOptions<QuotationFindUniqueQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<QuotationFindUniqueQuery, TError, TData>(
      ['QuotationFindUnique', variables],
      fetcher<QuotationFindUniqueQuery, QuotationFindUniqueQueryVariables>(client, QuotationFindUniqueDocument, variables, headers),
      options
    );
export const QuotationUpdateDocument = `
    mutation QuotationUpdate($uniqueInput: QuotationUniqueInput!, $input: QuotationUpdateInput!) {
  QuotationUpdate(uniqueInput: $uniqueInput, input: $input) {
    id
    unique_id
    branch_id
    branch {
      id
      name
      unique_id
      is_hq
    }
    reference_no
    related_user_list
    created_date
    created_by
    last_updated_date
    issue_date
    due_date
    credit_day
    price_vat_type
    currency
    item_price_list_id
    item_price_list {
      adjusted_item_list {
        id
        sku_name
        item_name
        reference_unique_id
        current_price
        adjusted_price
      }
      adjusted_price
      is_increase
      name
      is_active
      end_date
      description
      currency
    }
    accepted_date
    pre_vat_amount
    additional_discount
    additional_discount_type
    post_discount_amount
    vat_exempted_amount
    vat_0_percent_amount
    vat_7_percent_amount
    vat_amount
    net_amount
    withholding_tax_amount
    total_amount
    template_remark_id
    remark
    accepted_remark
    main_status
    sub_status
    flag_status
    aggrid_status
    customer_unique_id
    customer_details
    sales_type
    sales_channel_id
    sales_channel {
      id
      name_en
      name_th
      unique_id
    }
    account_id
    tag_id_list
    tag_list {
      document_type
      id
      name
    }
    item_list {
      id
      unique_id
      reference_unique_id
      reference_document_type
      item_unique_id
      item_sku_name
      item_name
      item_sku_desc
      item_img_url
      tracability
      barcode
      qty
      so_qty
      uom_id
      uom_name
      price_per_unit
      discount
      vat_percentage
      volume
      weight
      pre_vat_amount
      withholding_tax_type
      withholding_tax_value
      remark
      stock_qty
      qty_shipped
      qty_to_ship
      qty_invoiced
      qty_returned
      qty_issued
      qty_received
      branch_id
      reference_line_item {
        line_item_unique_id
        line_item_document_type
      }
    }
    attachment_list
    approval_step
    approver_list
    reviewer_list
    contact_person_list
  }
}
    `;
export const useQuotationUpdateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<QuotationUpdateMutation, TError, QuotationUpdateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<QuotationUpdateMutation, TError, QuotationUpdateMutationVariables, TContext>(
      ['QuotationUpdate'],
      (variables?: QuotationUpdateMutationVariables) => fetcher<QuotationUpdateMutation, QuotationUpdateMutationVariables>(client, QuotationUpdateDocument, variables, headers)(),
      options
    );
export const SalesInvoiceCreateDocument = `
    mutation SalesInvoiceCreate($input: SalesInvoiceCreateInput!) {
  SalesInvoiceCreate(input: $input) {
    id
    unique_id
    branch_id
    branch {
      id
      name
      unique_id
      is_hq
    }
    reference_document_list
    reference_no
    external_reference_no
    created_date
    created_by
    issue_date
    due_date
    credit_day
    related_user_list
    sales_type
    sales_channel_id
    sales_channel {
      id
      name_en
      name_th
      unique_id
    }
    price_vat_type
    currency
    pre_vat_amount
    additional_discount
    additional_discount_type
    post_discount_amount
    vat_exempted_amount
    vat_0_percent_amount
    vat_7_percent_amount
    vat_amount
    net_amount
    withholding_tax_amount
    total_amount
    template_remark_id
    remark
    tag_id_list
    tag_list {
      document_type
      id
      name
    }
    main_status
    sub_status
    flag_status
    aggrid_status
    approval_step
    approver_list
    reviewer_list
    last_updated_date
    item_list {
      id
      unique_id
      branch_id
      reference_unique_id
      reference_document_type
      item_unique_id
      item_sku_name
      item_name
      item_sku_desc
      item_img_url
      tracability
      barcode
      qty
      so_qty
      uom_id
      uom_name
      price_per_unit
      discount
      vat_percentage
      volume
      weight
      pre_vat_amount
      withholding_tax_type
      withholding_tax_value
      remark
      stock_qty
      qty_shipped
      qty_to_ship
      qty_invoiced
      qty_returned
      qty_issued
      qty_received
      reference_line_item {
        line_item_unique_id
        line_item_document_type
      }
    }
    item_price_list_id
    item_price_list {
      adjusted_item_list {
        id
        sku_name
        item_name
        reference_unique_id
        current_price
        adjusted_price
      }
      adjusted_price
      is_increase
      name
      is_active
      end_date
      description
      currency
    }
    customer_unique_id
    customer_details
    need_tax_invoice
    tax_invoice_no
    tax_invoice_date
    deduction_document_list {
      id
      reference_unique_id
      reference_document_type
      branch_id
      document_type
      document_unique_id
      deduction_amount
      credit_balance
      deduction_issue_date
      remark
    }
    payment_list {
      id
      reference_unique_id
      reference_document_type
      branch_id
      payment_channel_id
      payment_channel_unique_id
      payment_channel_payment_name
      payment_channel_name
      payment_amount
      payment_date
      cheque_provider
      cheque_no
      cheque_date
      is_withholding_tax
      withholding_tax_rate
      withholding_tax_amount
      remark
    }
    paid_total_amount
    paid_net_amount
    payment_total_amount
    deduction_total_amount
    contact_person_list
    is_original_print
  }
}
    `;
export const useSalesInvoiceCreateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SalesInvoiceCreateMutation, TError, SalesInvoiceCreateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SalesInvoiceCreateMutation, TError, SalesInvoiceCreateMutationVariables, TContext>(
      ['SalesInvoiceCreate'],
      (variables?: SalesInvoiceCreateMutationVariables) => fetcher<SalesInvoiceCreateMutation, SalesInvoiceCreateMutationVariables>(client, SalesInvoiceCreateDocument, variables, headers)(),
      options
    );
export const SalesInvoiceFindUniqueDocument = `
    query SalesInvoiceFindUnique($uniqueInput: SalesInvoiceUniqueInput!) {
  SalesInvoiceFindUnique(uniqueInput: $uniqueInput) {
    id
    unique_id
    branch_id
    branch {
      id
      name
      unique_id
      is_hq
    }
    reference_document_list
    reference_no
    external_reference_no
    created_date
    created_by
    issue_date
    due_date
    credit_day
    related_user_list
    sales_type
    sales_channel_id
    sales_channel {
      id
      name_en
      name_th
      unique_id
    }
    price_vat_type
    currency
    pre_vat_amount
    additional_discount
    additional_discount_type
    post_discount_amount
    vat_exempted_amount
    vat_0_percent_amount
    vat_7_percent_amount
    vat_amount
    net_amount
    withholding_tax_amount
    total_amount
    template_remark_id
    remark
    tag_id_list
    tag_list {
      document_type
      id
      name
    }
    main_status
    sub_status
    flag_status
    aggrid_status
    approval_step
    approver_list
    reviewer_list
    last_updated_date
    item_list {
      id
      unique_id
      branch_id
      reference_unique_id
      reference_document_type
      item_unique_id
      item_sku_name
      item_name
      item_sku_desc
      item_img_url
      tracability
      barcode
      qty
      so_qty
      uom_id
      uom_name
      price_per_unit
      discount
      vat_percentage
      volume
      weight
      pre_vat_amount
      withholding_tax_type
      withholding_tax_value
      remark
      stock_qty
      qty_shipped
      qty_to_ship
      qty_invoiced
      qty_returned
      qty_issued
      qty_received
      reference_line_item {
        line_item_unique_id
        line_item_document_type
      }
    }
    item_price_list_id
    item_price_list {
      adjusted_item_list {
        id
        sku_name
        item_name
        reference_unique_id
        current_price
        adjusted_price
      }
      adjusted_price
      is_increase
      name
      is_active
      end_date
      description
      currency
    }
    customer_unique_id
    customer_details
    need_tax_invoice
    tax_invoice_no
    tax_invoice_date
    deduction_document_list {
      id
      reference_unique_id
      reference_document_type
      branch_id
      document_type
      document_unique_id
      deduction_amount
      credit_balance
      deduction_issue_date
      remark
    }
    payment_list {
      id
      reference_unique_id
      reference_document_type
      branch_id
      payment_channel_id
      payment_channel_unique_id
      payment_channel_payment_name
      payment_channel_name
      payment_amount
      payment_date
      cheque_provider
      cheque_no
      cheque_date
      is_withholding_tax
      withholding_tax_rate
      withholding_tax_amount
      remark
    }
    paid_total_amount
    paid_net_amount
    payment_total_amount
    deduction_total_amount
    contact_person_list
    is_original_print
  }
}
    `;
export const useSalesInvoiceFindUniqueQuery = <
      TData = SalesInvoiceFindUniqueQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: SalesInvoiceFindUniqueQueryVariables,
      options?: UseQueryOptions<SalesInvoiceFindUniqueQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<SalesInvoiceFindUniqueQuery, TError, TData>(
      ['SalesInvoiceFindUnique', variables],
      fetcher<SalesInvoiceFindUniqueQuery, SalesInvoiceFindUniqueQueryVariables>(client, SalesInvoiceFindUniqueDocument, variables, headers),
      options
    );
export const SalesInvoiceUpdateDocument = `
    mutation SalesInvoiceUpdate($uniqueInput: SalesInvoiceUniqueInput!, $input: SalesInvoiceUpdateInput!) {
  SalesInvoiceUpdate(uniqueInput: $uniqueInput, input: $input) {
    id
    unique_id
    branch_id
    branch {
      id
      name
      unique_id
      is_hq
    }
    reference_document_list
    reference_no
    external_reference_no
    created_date
    created_by
    issue_date
    due_date
    credit_day
    related_user_list
    sales_type
    sales_channel_id
    sales_channel {
      id
      name_en
      name_th
      unique_id
    }
    price_vat_type
    currency
    pre_vat_amount
    additional_discount
    additional_discount_type
    post_discount_amount
    vat_exempted_amount
    vat_0_percent_amount
    vat_7_percent_amount
    vat_amount
    net_amount
    withholding_tax_amount
    total_amount
    template_remark_id
    remark
    tag_id_list
    tag_list {
      document_type
      id
      name
    }
    main_status
    sub_status
    flag_status
    aggrid_status
    approval_step
    approver_list
    reviewer_list
    last_updated_date
    item_list {
      id
      unique_id
      branch_id
      reference_unique_id
      reference_document_type
      item_unique_id
      item_sku_name
      item_name
      item_sku_desc
      item_img_url
      tracability
      barcode
      qty
      so_qty
      uom_id
      uom_name
      price_per_unit
      discount
      vat_percentage
      volume
      weight
      pre_vat_amount
      withholding_tax_type
      withholding_tax_value
      remark
      stock_qty
      qty_shipped
      qty_to_ship
      qty_invoiced
      qty_returned
      qty_issued
      qty_received
      reference_line_item {
        line_item_unique_id
        line_item_document_type
      }
    }
    item_price_list_id
    item_price_list {
      adjusted_item_list {
        id
        sku_name
        item_name
        reference_unique_id
        current_price
        adjusted_price
      }
      adjusted_price
      is_increase
      name
      is_active
      end_date
      description
      currency
    }
    customer_unique_id
    customer_details
    need_tax_invoice
    tax_invoice_no
    tax_invoice_date
    deduction_document_list {
      id
      reference_unique_id
      reference_document_type
      branch_id
      document_type
      document_unique_id
      deduction_amount
      credit_balance
      deduction_issue_date
      remark
    }
    payment_list {
      id
      reference_unique_id
      reference_document_type
      branch_id
      payment_channel_id
      payment_channel_unique_id
      payment_channel_payment_name
      payment_channel_name
      payment_amount
      payment_date
      cheque_provider
      cheque_no
      cheque_date
      is_withholding_tax
      withholding_tax_rate
      withholding_tax_amount
      remark
    }
    paid_total_amount
    paid_net_amount
    payment_total_amount
    deduction_total_amount
    contact_person_list
    is_original_print
  }
}
    `;
export const useSalesInvoiceUpdateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SalesInvoiceUpdateMutation, TError, SalesInvoiceUpdateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SalesInvoiceUpdateMutation, TError, SalesInvoiceUpdateMutationVariables, TContext>(
      ['SalesInvoiceUpdate'],
      (variables?: SalesInvoiceUpdateMutationVariables) => fetcher<SalesInvoiceUpdateMutation, SalesInvoiceUpdateMutationVariables>(client, SalesInvoiceUpdateDocument, variables, headers)(),
      options
    );
export const SalesItemFindManyDocument = `
    query SalesItemFindMany($input: SalesItemFindManyInput) {
  SalesItemFindMany(input: $input) {
    id
    unique_id
    branch_id
    reference_line_item {
      line_item_unique_id
      line_item_document_type
    }
    reference_unique_id
    reference_document_type
    item_unique_id
    item_sku_name
    item_name
    item_sku_desc
    item_img_url
    tracability
    barcode
    qty
    so_qty
    uom_id
    uom_name
    price_per_unit
    discount
    vat_percentage
    volume
    weight
    pre_vat_amount
    withholding_tax_type
    withholding_tax_value
    remark
    stock_qty
    qty_shipped
    qty_to_ship
    qty_invoiced
    qty_returned
    qty_issued
    qty_received
  }
}
    `;
export const useSalesItemFindManyQuery = <
      TData = SalesItemFindManyQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: SalesItemFindManyQueryVariables,
      options?: UseQueryOptions<SalesItemFindManyQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<SalesItemFindManyQuery, TError, TData>(
      variables === undefined ? ['SalesItemFindMany'] : ['SalesItemFindMany', variables],
      fetcher<SalesItemFindManyQuery, SalesItemFindManyQueryVariables>(client, SalesItemFindManyDocument, variables, headers),
      options
    );
export const SalesOrderCanCreatePurchaseRequestDocument = `
    query SalesOrderCanCreatePurchaseRequest($uniqueInput: SalesOrderUniqueInput!) {
  SalesOrderCanCreatePurchaseRequest(uniqueInput: $uniqueInput)
}
    `;
export const useSalesOrderCanCreatePurchaseRequestQuery = <
      TData = SalesOrderCanCreatePurchaseRequestQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: SalesOrderCanCreatePurchaseRequestQueryVariables,
      options?: UseQueryOptions<SalesOrderCanCreatePurchaseRequestQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<SalesOrderCanCreatePurchaseRequestQuery, TError, TData>(
      ['SalesOrderCanCreatePurchaseRequest', variables],
      fetcher<SalesOrderCanCreatePurchaseRequestQuery, SalesOrderCanCreatePurchaseRequestQueryVariables>(client, SalesOrderCanCreatePurchaseRequestDocument, variables, headers),
      options
    );
export const SalesOrderCreateDocument = `
    mutation SalesOrderCreate($input: SalesOrderCreateInput!) {
  SalesOrderCreate(input: $input) {
    id
    unique_id
    branch_id
    branch {
      id
      name
      unique_id
      is_hq
    }
    reference_document_list
    reference_no
    external_reference_no
    related_user_list
    sales_contact
    created_date
    created_by
    last_updated_date
    issue_date
    delivery_date
    due_date
    credit_day
    price_vat_type
    currency
    item_price_list_id
    item_price_list {
      adjusted_item_list {
        id
        sku_name
        item_name
        reference_unique_id
        current_price
        adjusted_price
      }
      adjusted_price
      is_increase
      name
      is_active
      end_date
      description
      currency
    }
    pre_vat_amount
    additional_discount
    additional_discount_type
    post_discount_amount
    vat_exempted_amount
    vat_0_percent_amount
    vat_7_percent_amount
    vat_amount
    net_amount
    withholding_tax_amount
    total_amount
    remark
    main_status
    sub_status
    flag_status
    aggrid_status
    customer_unique_id
    customer_details
    sales_type
    sales_channel_id
    sales_channel {
      id
      name_en
      name_th
      unique_id
    }
    tag_id_list
    tag_list {
      document_type
      id
      name
    }
    item_list {
      id
      unique_id
      reference_unique_id
      reference_document_type
      item_unique_id
      item_sku_name
      item_name
      item_sku_desc
      item_img_url
      tracability
      barcode
      qty
      so_qty
      uom_id
      uom_name
      price_per_unit
      discount
      vat_percentage
      volume
      weight
      pre_vat_amount
      withholding_tax_type
      withholding_tax_value
      remark
      stock_qty
      qty_shipped
      qty_to_ship
      qty_invoiced
      qty_returned
      qty_issued
      qty_received
      branch_id
      reference_line_item {
        line_item_unique_id
        line_item_document_type
      }
      applied_preorder_quota_setting_id
    }
    approval_step
    approver_list
    reviewer_list
    contact_person_list
    use_preorder_quota
  }
}
    `;
export const useSalesOrderCreateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SalesOrderCreateMutation, TError, SalesOrderCreateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SalesOrderCreateMutation, TError, SalesOrderCreateMutationVariables, TContext>(
      ['SalesOrderCreate'],
      (variables?: SalesOrderCreateMutationVariables) => fetcher<SalesOrderCreateMutation, SalesOrderCreateMutationVariables>(client, SalesOrderCreateDocument, variables, headers)(),
      options
    );
export const SalesOrderFindUniqueDocument = `
    query SalesOrderFindUnique($uniqueInput: SalesOrderUniqueInput!) {
  SalesOrderFindUnique(uniqueInput: $uniqueInput) {
    id
    unique_id
    branch_id
    branch {
      id
      name
      unique_id
      is_hq
    }
    reference_document_list
    reference_no
    external_reference_no
    related_user_list
    sales_contact
    created_date
    created_by
    last_updated_date
    issue_date
    delivery_date
    due_date
    credit_day
    price_vat_type
    currency
    item_price_list_id
    item_price_list {
      adjusted_item_list {
        id
        sku_name
        item_name
        reference_unique_id
        current_price
        adjusted_price
      }
      adjusted_price
      is_increase
      name
      is_active
      end_date
      description
      currency
    }
    pre_vat_amount
    additional_discount
    additional_discount_type
    post_discount_amount
    vat_exempted_amount
    vat_0_percent_amount
    vat_7_percent_amount
    vat_amount
    net_amount
    withholding_tax_amount
    total_amount
    remark
    main_status
    sub_status
    flag_status
    aggrid_status
    customer_unique_id
    customer_details
    sales_type
    sales_channel_id
    sales_channel {
      id
      name_en
      name_th
      unique_id
    }
    tag_id_list
    tag_list {
      document_type
      id
      name
    }
    item_list {
      id
      unique_id
      reference_unique_id
      reference_document_type
      item_unique_id
      item_sku_name
      item_name
      item_sku_desc
      item_img_url
      tracability
      barcode
      qty
      so_qty
      uom_id
      uom_name
      price_per_unit
      discount
      vat_percentage
      volume
      weight
      pre_vat_amount
      withholding_tax_type
      withholding_tax_value
      remark
      stock_qty
      qty_shipped
      qty_to_ship
      qty_invoiced
      qty_returned
      qty_issued
      qty_received
      branch_id
      reference_line_item {
        line_item_unique_id
        line_item_document_type
      }
      applied_preorder_quota_setting_id
    }
    approval_step
    approver_list
    reviewer_list
    contact_person_list
    use_preorder_quota
  }
}
    `;
export const useSalesOrderFindUniqueQuery = <
      TData = SalesOrderFindUniqueQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: SalesOrderFindUniqueQueryVariables,
      options?: UseQueryOptions<SalesOrderFindUniqueQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<SalesOrderFindUniqueQuery, TError, TData>(
      ['SalesOrderFindUnique', variables],
      fetcher<SalesOrderFindUniqueQuery, SalesOrderFindUniqueQueryVariables>(client, SalesOrderFindUniqueDocument, variables, headers),
      options
    );
export const SalesOrderUpdateDocument = `
    mutation SalesOrderUpdate($uniqueInput: SalesOrderUniqueInput!, $input: SalesOrderUpdateInput!) {
  SalesOrderUpdate(uniqueInput: $uniqueInput, input: $input) {
    id
    unique_id
    branch_id
    branch {
      id
      name
      unique_id
      is_hq
    }
    reference_document_list
    reference_no
    external_reference_no
    related_user_list
    sales_contact
    created_date
    created_by
    last_updated_date
    issue_date
    delivery_date
    due_date
    credit_day
    price_vat_type
    currency
    item_price_list_id
    item_price_list {
      adjusted_item_list {
        id
        sku_name
        item_name
        reference_unique_id
        current_price
        adjusted_price
      }
      adjusted_price
      is_increase
      name
      is_active
      end_date
      description
      currency
    }
    pre_vat_amount
    additional_discount
    additional_discount_type
    post_discount_amount
    vat_exempted_amount
    vat_0_percent_amount
    vat_7_percent_amount
    vat_amount
    net_amount
    withholding_tax_amount
    total_amount
    remark
    main_status
    sub_status
    flag_status
    aggrid_status
    customer_unique_id
    customer_details
    sales_type
    sales_channel_id
    sales_channel {
      id
      name_en
      name_th
      unique_id
    }
    tag_id_list
    tag_list {
      document_type
      id
      name
    }
    item_list {
      id
      unique_id
      reference_unique_id
      reference_document_type
      item_unique_id
      item_sku_name
      item_name
      item_sku_desc
      item_img_url
      tracability
      barcode
      qty
      so_qty
      uom_id
      uom_name
      price_per_unit
      discount
      vat_percentage
      volume
      weight
      pre_vat_amount
      withholding_tax_type
      withholding_tax_value
      remark
      stock_qty
      qty_shipped
      qty_to_ship
      qty_invoiced
      qty_returned
      qty_issued
      qty_received
      branch_id
      reference_line_item {
        line_item_unique_id
        line_item_document_type
      }
      applied_preorder_quota_setting_id
    }
    approval_step
    approver_list
    reviewer_list
    contact_person_list
    use_preorder_quota
  }
}
    `;
export const useSalesOrderUpdateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SalesOrderUpdateMutation, TError, SalesOrderUpdateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SalesOrderUpdateMutation, TError, SalesOrderUpdateMutationVariables, TContext>(
      ['SalesOrderUpdate'],
      (variables?: SalesOrderUpdateMutationVariables) => fetcher<SalesOrderUpdateMutation, SalesOrderUpdateMutationVariables>(client, SalesOrderUpdateDocument, variables, headers)(),
      options
    );
export const SalesOriginalPrintDocument = `
    mutation SalesOriginalPrint($input: SalesOriginalPrintInput!) {
  SalesOriginalPrint(input: $input) {
    id
    unique_id
    is_original_print
  }
}
    `;
export const useSalesOriginalPrintMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SalesOriginalPrintMutation, TError, SalesOriginalPrintMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SalesOriginalPrintMutation, TError, SalesOriginalPrintMutationVariables, TContext>(
      ['SalesOriginalPrint'],
      (variables?: SalesOriginalPrintMutationVariables) => fetcher<SalesOriginalPrintMutation, SalesOriginalPrintMutationVariables>(client, SalesOriginalPrintDocument, variables, headers)(),
      options
    );
export const SalesReturnCreateDocument = `
    mutation SalesReturnCreate($input: SalesReturnCreateInput!) {
  SalesReturnCreate(input: $input) {
    id
    unique_id
    branch_id
    branch {
      id
      name
      unique_id
      is_hq
    }
    reference_document_list
    reference_no
    external_reference_no
    created_date
    created_by
    issue_date
    due_date
    credit_day
    related_user_list
    reason_to_return
    is_effect_stock
    sales_type
    sales_channel_id
    sales_channel {
      id
      name_en
      name_th
      unique_id
    }
    price_vat_type
    currency
    pre_vat_amount
    additional_discount
    additional_discount_type
    post_discount_amount
    vat_exempted_amount
    vat_0_percent_amount
    vat_7_percent_amount
    vat_amount
    net_amount
    withholding_tax_amount
    total_amount
    template_remark_id
    remark
    tag_id_list
    tag_list {
      document_type
      id
      name
    }
    main_status
    sub_status
    flag_status
    aggrid_status
    approval_step
    approver_list
    reviewer_list
    last_updated_date
    item_list {
      id
      unique_id
      branch_id
      reference_unique_id
      reference_document_type
      item_unique_id
      item_sku_name
      item_name
      item_sku_desc
      item_img_url
      tracability
      barcode
      qty
      so_qty
      uom_id
      uom_name
      price_per_unit
      discount
      vat_percentage
      volume
      weight
      pre_vat_amount
      withholding_tax_type
      withholding_tax_value
      remark
      stock_qty
      qty_shipped
      qty_to_ship
      qty_invoiced
      qty_returned
      qty_issued
      qty_received
      reference_line_item {
        line_item_unique_id
        line_item_document_type
      }
    }
    item_price_list_id
    item_price_list {
      adjusted_item_list {
        id
        sku_name
        item_name
        reference_unique_id
        current_price
        adjusted_price
      }
      adjusted_price
      is_increase
      name
      is_active
      end_date
      description
      currency
    }
    customer_unique_id
    customer_details
    contact_person_list
  }
}
    `;
export const useSalesReturnCreateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SalesReturnCreateMutation, TError, SalesReturnCreateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SalesReturnCreateMutation, TError, SalesReturnCreateMutationVariables, TContext>(
      ['SalesReturnCreate'],
      (variables?: SalesReturnCreateMutationVariables) => fetcher<SalesReturnCreateMutation, SalesReturnCreateMutationVariables>(client, SalesReturnCreateDocument, variables, headers)(),
      options
    );
export const SalesReturnFindUniqueDocument = `
    query SalesReturnFindUnique($uniqueInput: SalesReturnUniqueInput!) {
  SalesReturnFindUnique(uniqueInput: $uniqueInput) {
    id
    unique_id
    branch_id
    branch {
      id
      name
      unique_id
      is_hq
    }
    reference_document_list
    reference_no
    external_reference_no
    created_date
    created_by
    issue_date
    due_date
    credit_day
    related_user_list
    reason_to_return
    is_effect_stock
    sales_type
    sales_channel_id
    sales_channel {
      id
      name_en
      name_th
      unique_id
    }
    price_vat_type
    currency
    pre_vat_amount
    additional_discount
    additional_discount_type
    post_discount_amount
    vat_exempted_amount
    vat_0_percent_amount
    vat_7_percent_amount
    vat_amount
    net_amount
    withholding_tax_amount
    total_amount
    template_remark_id
    remark
    tag_id_list
    tag_list {
      document_type
      id
      name
    }
    main_status
    sub_status
    flag_status
    aggrid_status
    approval_step
    approver_list
    reviewer_list
    last_updated_date
    item_list {
      id
      unique_id
      branch_id
      reference_unique_id
      reference_document_type
      item_unique_id
      item_sku_name
      item_name
      item_sku_desc
      item_img_url
      tracability
      barcode
      qty
      so_qty
      uom_id
      uom_name
      price_per_unit
      discount
      vat_percentage
      volume
      weight
      pre_vat_amount
      withholding_tax_type
      withholding_tax_value
      remark
      stock_qty
      qty_shipped
      qty_to_ship
      qty_invoiced
      qty_returned
      qty_issued
      qty_received
      reference_line_item {
        line_item_unique_id
        line_item_document_type
      }
    }
    item_price_list_id
    item_price_list {
      adjusted_item_list {
        id
        sku_name
        item_name
        reference_unique_id
        current_price
        adjusted_price
      }
      adjusted_price
      is_increase
      name
      is_active
      end_date
      description
      currency
    }
    customer_unique_id
    customer_details
    contact_person_list
  }
}
    `;
export const useSalesReturnFindUniqueQuery = <
      TData = SalesReturnFindUniqueQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: SalesReturnFindUniqueQueryVariables,
      options?: UseQueryOptions<SalesReturnFindUniqueQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<SalesReturnFindUniqueQuery, TError, TData>(
      ['SalesReturnFindUnique', variables],
      fetcher<SalesReturnFindUniqueQuery, SalesReturnFindUniqueQueryVariables>(client, SalesReturnFindUniqueDocument, variables, headers),
      options
    );
export const SalesReturnUpdateDocument = `
    mutation SalesReturnUpdate($uniqueInput: SalesReturnUniqueInput!, $input: SalesReturnUpdateInput!) {
  SalesReturnUpdate(uniqueInput: $uniqueInput, input: $input) {
    id
    unique_id
    branch_id
    branch {
      id
      name
      unique_id
      is_hq
    }
    reference_document_list
    reference_no
    external_reference_no
    created_date
    created_by
    issue_date
    due_date
    credit_day
    related_user_list
    reason_to_return
    is_effect_stock
    sales_type
    sales_channel_id
    sales_channel {
      id
      name_en
      name_th
      unique_id
    }
    price_vat_type
    currency
    pre_vat_amount
    additional_discount
    additional_discount_type
    post_discount_amount
    vat_exempted_amount
    vat_0_percent_amount
    vat_7_percent_amount
    vat_amount
    net_amount
    withholding_tax_amount
    total_amount
    template_remark_id
    remark
    tag_id_list
    tag_list {
      document_type
      id
      name
    }
    main_status
    sub_status
    flag_status
    aggrid_status
    approval_step
    approver_list
    reviewer_list
    last_updated_date
    item_list {
      id
      unique_id
      branch_id
      reference_unique_id
      reference_document_type
      item_unique_id
      item_sku_name
      item_name
      item_sku_desc
      item_img_url
      tracability
      barcode
      qty
      so_qty
      uom_id
      uom_name
      price_per_unit
      discount
      vat_percentage
      volume
      weight
      pre_vat_amount
      withholding_tax_type
      withholding_tax_value
      remark
      stock_qty
      qty_shipped
      qty_to_ship
      qty_invoiced
      qty_returned
      qty_issued
      qty_received
      reference_line_item {
        line_item_unique_id
        line_item_document_type
      }
    }
    item_price_list_id
    item_price_list {
      adjusted_item_list {
        id
        sku_name
        item_name
        reference_unique_id
        current_price
        adjusted_price
      }
      adjusted_price
      is_increase
      name
      is_active
      end_date
      description
      currency
    }
    customer_unique_id
    customer_details
    contact_person_list
  }
}
    `;
export const useSalesReturnUpdateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SalesReturnUpdateMutation, TError, SalesReturnUpdateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SalesReturnUpdateMutation, TError, SalesReturnUpdateMutationVariables, TContext>(
      ['SalesReturnUpdate'],
      (variables?: SalesReturnUpdateMutationVariables) => fetcher<SalesReturnUpdateMutation, SalesReturnUpdateMutationVariables>(client, SalesReturnUpdateDocument, variables, headers)(),
      options
    );
export const SalesUniqueIdGenerateDocument = `
    query SalesUniqueIdGenerate($modelType: SalesModelType!, $usePreorderQuota: Boolean) {
  UniqueIdGenerate(modelType: $modelType, usePreorderQuota: $usePreorderQuota)
}
    `;
export const useSalesUniqueIdGenerateQuery = <
      TData = SalesUniqueIdGenerateQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: SalesUniqueIdGenerateQueryVariables,
      options?: UseQueryOptions<SalesUniqueIdGenerateQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<SalesUniqueIdGenerateQuery, TError, TData>(
      ['SalesUniqueIdGenerate', variables],
      fetcher<SalesUniqueIdGenerateQuery, SalesUniqueIdGenerateQueryVariables>(client, SalesUniqueIdGenerateDocument, variables, headers),
      options
    );